const emojis = [
  {
    CodePointsHex: ['1F600'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE00',
    Version: 'E1.0',
    name: 'grinning face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-smiling'
  },
  {
    CodePointsHex: ['1F603'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE03',
    Version: 'E0.6',
    name: 'grinning face with big eyes',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-smiling'
  },
  {
    CodePointsHex: ['1F604'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE04',
    Version: 'E0.6',
    name: 'grinning face with smiling eyes',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-smiling'
  },
  {
    CodePointsHex: ['1F601'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE01',
    Version: 'E0.6',
    name: 'beaming face with smiling eyes',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-smiling'
  },
  {
    CodePointsHex: ['1F606'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE06',
    Version: 'E0.6',
    name: 'grinning squinting face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-smiling'
  },
  {
    CodePointsHex: ['1F605'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE05',
    Version: 'E0.6',
    name: 'grinning face with sweat',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-smiling'
  },
  {
    CodePointsHex: ['1F923'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD23',
    Version: 'E3.0',
    name: 'rolling on the floor laughing',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-smiling'
  },
  {
    CodePointsHex: ['1F602'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE02',
    Version: 'E0.6',
    name: 'face with tears of joy',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-smiling'
  },
  {
    CodePointsHex: ['1F642'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE42',
    Version: 'E1.0',
    name: 'slightly smiling face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-smiling'
  },
  {
    CodePointsHex: ['1F643'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE43',
    Version: 'E1.0',
    name: 'upside-down face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-smiling'
  },
  {
    CodePointsHex: ['1FAE0'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEE0',
    Version: 'E14.0',
    name: 'melting face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-smiling'
  },
  {
    CodePointsHex: ['1F609'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE09',
    Version: 'E0.6',
    name: 'winking face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-smiling'
  },
  {
    CodePointsHex: ['1F60A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE0A',
    Version: 'E0.6',
    name: 'smiling face with smiling eyes',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-smiling'
  },
  {
    CodePointsHex: ['1F607'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE07',
    Version: 'E1.0',
    name: 'smiling face with halo',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-smiling'
  },
  {
    CodePointsHex: ['1F970'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD70',
    Version: 'E11.0',
    name: 'smiling face with hearts',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-affection'
  },
  {
    CodePointsHex: ['1F60D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE0D',
    Version: 'E0.6',
    name: 'smiling face with heart-eyes',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-affection'
  },
  {
    CodePointsHex: ['1F929'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD29',
    Version: 'E5.0',
    name: 'star-struck',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-affection'
  },
  {
    CodePointsHex: ['1F618'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE18',
    Version: 'E0.6',
    name: 'face blowing a kiss',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-affection'
  },
  {
    CodePointsHex: ['1F617'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE17',
    Version: 'E1.0',
    name: 'kissing face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-affection'
  },
  {
    CodePointsHex: ['263A', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u263A\uFE0F',
    Version: 'E0.6',
    name: 'smiling face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-affection'
  },
  {
    CodePointsHex: ['263A'],
    Status: 'unqualified',
    char: '\u263A',
    Version: 'E0.6',
    name: 'smiling face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-affection'
  },
  {
    CodePointsHex: ['1F61A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE1A',
    Version: 'E0.6',
    name: 'kissing face with closed eyes',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-affection'
  },
  {
    CodePointsHex: ['1F619'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE19',
    Version: 'E1.0',
    name: 'kissing face with smiling eyes',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-affection'
  },
  {
    CodePointsHex: ['1F972'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD72',
    Version: 'E13.0',
    name: 'smiling face with tear',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-affection'
  },
  {
    CodePointsHex: ['1F60B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE0B',
    Version: 'E0.6',
    name: 'face savoring food',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-tongue'
  },
  {
    CodePointsHex: ['1F61B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE1B',
    Version: 'E1.0',
    name: 'face with tongue',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-tongue'
  },
  {
    CodePointsHex: ['1F61C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE1C',
    Version: 'E0.6',
    name: 'winking face with tongue',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-tongue'
  },
  {
    CodePointsHex: ['1F92A'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD2A',
    Version: 'E5.0',
    name: 'zany face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-tongue'
  },
  {
    CodePointsHex: ['1F61D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE1D',
    Version: 'E0.6',
    name: 'squinting face with tongue',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-tongue'
  },
  {
    CodePointsHex: ['1F911'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD11',
    Version: 'E1.0',
    name: 'money-mouth face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-tongue'
  },
  {
    CodePointsHex: ['1F917'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD17',
    Version: 'E1.0',
    name: 'smiling face with open hands',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-hand'
  },
  {
    CodePointsHex: ['1F92D'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD2D',
    Version: 'E5.0',
    name: 'face with hand over mouth',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-hand'
  },
  {
    CodePointsHex: ['1FAE2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEE2',
    Version: 'E14.0',
    name: 'face with open eyes and hand over mouth',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-hand'
  },
  {
    CodePointsHex: ['1FAE3'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEE3',
    Version: 'E14.0',
    name: 'face with peeking eye',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-hand'
  },
  {
    CodePointsHex: ['1F92B'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD2B',
    Version: 'E5.0',
    name: 'shushing face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-hand'
  },
  {
    CodePointsHex: ['1F914'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD14',
    Version: 'E1.0',
    name: 'thinking face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-hand'
  },
  {
    CodePointsHex: ['1FAE1'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEE1',
    Version: 'E14.0',
    name: 'saluting face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-hand'
  },
  {
    CodePointsHex: ['1F910'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD10',
    Version: 'E1.0',
    name: 'zipper-mouth face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1F928'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD28',
    Version: 'E5.0',
    name: 'face with raised eyebrow',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1F610'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE10',
    Version: 'E0.7',
    name: 'neutral face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1F611'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE11',
    Version: 'E1.0',
    name: 'expressionless face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1F636'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE36',
    Version: 'E1.0',
    name: 'face without mouth',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1FAE5'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEE5',
    Version: 'E14.0',
    name: 'dotted line face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1F636', '200D', '1F32B', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE36\u200D\uD83C\uDF2B\uFE0F',
    Version: 'E13.1',
    name: 'face in clouds',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1F636', '200D', '1F32B'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE36\u200D\uD83C\uDF2B',
    Version: 'E13.1',
    name: 'face in clouds',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1F60F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE0F',
    Version: 'E0.6',
    name: 'smirking face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1F612'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE12',
    Version: 'E0.6',
    name: 'unamused face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1F644'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE44',
    Version: 'E1.0',
    name: 'face with rolling eyes',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1F62C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE2C',
    Version: 'E1.0',
    name: 'grimacing face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1F62E', '200D', '1F4A8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE2E\u200D\uD83D\uDCA8',
    Version: 'E13.1',
    name: 'face exhaling',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1F925'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD25',
    Version: 'E3.0',
    name: 'lying face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1FAE8'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEE8',
    Version: 'E15.0',
    name: 'shaking face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1F642', '200D', '2194', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE42\u200D\u2194\uFE0F',
    Version: 'E15.1',
    name: 'head shaking horizontally',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1F642', '200D', '2194'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE42\u200D\u2194',
    Version: 'E15.1',
    name: 'head shaking horizontally',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1F642', '200D', '2195', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE42\u200D\u2195\uFE0F',
    Version: 'E15.1',
    name: 'head shaking vertically',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1F642', '200D', '2195'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE42\u200D\u2195',
    Version: 'E15.1',
    name: 'head shaking vertically',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-neutral-skeptical'
  },
  {
    CodePointsHex: ['1F60C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE0C',
    Version: 'E0.6',
    name: 'relieved face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-sleepy'
  },
  {
    CodePointsHex: ['1F614'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE14',
    Version: 'E0.6',
    name: 'pensive face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-sleepy'
  },
  {
    CodePointsHex: ['1F62A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE2A',
    Version: 'E0.6',
    name: 'sleepy face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-sleepy'
  },
  {
    CodePointsHex: ['1F924'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD24',
    Version: 'E3.0',
    name: 'drooling face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-sleepy'
  },
  {
    CodePointsHex: ['1F634'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE34',
    Version: 'E1.0',
    name: 'sleeping face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-sleepy'
  },
  {
    CodePointsHex: ['1FAE9'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEE9',
    Version: 'E16.0',
    name: 'face with bags under eyes',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-sleepy'
  },
  {
    CodePointsHex: ['1F637'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE37',
    Version: 'E0.6',
    name: 'face with medical mask',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-unwell'
  },
  {
    CodePointsHex: ['1F912'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD12',
    Version: 'E1.0',
    name: 'face with thermometer',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-unwell'
  },
  {
    CodePointsHex: ['1F915'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD15',
    Version: 'E1.0',
    name: 'face with head-bandage',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-unwell'
  },
  {
    CodePointsHex: ['1F922'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD22',
    Version: 'E3.0',
    name: 'nauseated face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-unwell'
  },
  {
    CodePointsHex: ['1F92E'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD2E',
    Version: 'E5.0',
    name: 'face vomiting',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-unwell'
  },
  {
    CodePointsHex: ['1F927'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD27',
    Version: 'E3.0',
    name: 'sneezing face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-unwell'
  },
  {
    CodePointsHex: ['1F975'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD75',
    Version: 'E11.0',
    name: 'hot face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-unwell'
  },
  {
    CodePointsHex: ['1F976'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD76',
    Version: 'E11.0',
    name: 'cold face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-unwell'
  },
  {
    CodePointsHex: ['1F974'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD74',
    Version: 'E11.0',
    name: 'woozy face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-unwell'
  },
  {
    CodePointsHex: ['1F635'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE35',
    Version: 'E0.6',
    name: 'face with crossed-out eyes',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-unwell'
  },
  {
    CodePointsHex: ['1F635', '200D', '1F4AB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE35\u200D\uD83D\uDCAB',
    Version: 'E13.1',
    name: 'face with spiral eyes',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-unwell'
  },
  {
    CodePointsHex: ['1F92F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD2F',
    Version: 'E5.0',
    name: 'exploding head',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-unwell'
  },
  {
    CodePointsHex: ['1F920'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD20',
    Version: 'E3.0',
    name: 'cowboy hat face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-hat'
  },
  {
    CodePointsHex: ['1F973'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD73',
    Version: 'E11.0',
    name: 'partying face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-hat'
  },
  {
    CodePointsHex: ['1F978'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD78',
    Version: 'E13.0',
    name: 'disguised face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-hat'
  },
  {
    CodePointsHex: ['1F60E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE0E',
    Version: 'E1.0',
    name: 'smiling face with sunglasses',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-glasses'
  },
  {
    CodePointsHex: ['1F913'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD13',
    Version: 'E1.0',
    name: 'nerd face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-glasses'
  },
  {
    CodePointsHex: ['1F9D0'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD0',
    Version: 'E5.0',
    name: 'face with monocle',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-glasses'
  },
  {
    CodePointsHex: ['1F615'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE15',
    Version: 'E1.0',
    name: 'confused face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1FAE4'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEE4',
    Version: 'E14.0',
    name: 'face with diagonal mouth',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F61F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE1F',
    Version: 'E1.0',
    name: 'worried face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F641'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE41',
    Version: 'E1.0',
    name: 'slightly frowning face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['2639', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2639\uFE0F',
    Version: 'E0.7',
    name: 'frowning face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['2639'],
    Status: 'unqualified',
    char: '\u2639',
    Version: 'E0.7',
    name: 'frowning face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F62E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE2E',
    Version: 'E1.0',
    name: 'face with open mouth',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F62F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE2F',
    Version: 'E1.0',
    name: 'hushed face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F632'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE32',
    Version: 'E0.6',
    name: 'astonished face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F633'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE33',
    Version: 'E0.6',
    name: 'flushed face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1FAEA'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEEA',
    Version: 'E17.0',
    name: 'distorted face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F97A'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD7A',
    Version: 'E11.0',
    name: 'pleading face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F979'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD79',
    Version: 'E14.0',
    name: 'face holding back tears',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F626'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE26',
    Version: 'E1.0',
    name: 'frowning face with open mouth',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F627'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE27',
    Version: 'E1.0',
    name: 'anguished face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F628'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE28',
    Version: 'E0.6',
    name: 'fearful face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F630'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE30',
    Version: 'E0.6',
    name: 'anxious face with sweat',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F625'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE25',
    Version: 'E0.6',
    name: 'sad but relieved face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F622'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE22',
    Version: 'E0.6',
    name: 'crying face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F62D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE2D',
    Version: 'E0.6',
    name: 'loudly crying face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F631'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE31',
    Version: 'E0.6',
    name: 'face screaming in fear',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F616'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE16',
    Version: 'E0.6',
    name: 'confounded face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F623'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE23',
    Version: 'E0.6',
    name: 'persevering face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F61E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE1E',
    Version: 'E0.6',
    name: 'disappointed face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F613'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE13',
    Version: 'E0.6',
    name: 'downcast face with sweat',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F629'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE29',
    Version: 'E0.6',
    name: 'weary face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F62B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE2B',
    Version: 'E0.6',
    name: 'tired face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F971'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD71',
    Version: 'E12.0',
    name: 'yawning face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-concerned'
  },
  {
    CodePointsHex: ['1F624'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE24',
    Version: 'E0.6',
    name: 'face with steam from nose',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-negative'
  },
  {
    CodePointsHex: ['1F621'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE21',
    Version: 'E0.6',
    name: 'enraged face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-negative'
  },
  {
    CodePointsHex: ['1F620'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE20',
    Version: 'E0.6',
    name: 'angry face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-negative'
  },
  {
    CodePointsHex: ['1F92C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD2C',
    Version: 'E5.0',
    name: 'face with symbols on mouth',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-negative'
  },
  {
    CodePointsHex: ['1F608'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE08',
    Version: 'E1.0',
    name: 'smiling face with horns',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-negative'
  },
  {
    CodePointsHex: ['1F47F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC7F',
    Version: 'E0.6',
    name: 'angry face with horns',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-negative'
  },
  {
    CodePointsHex: ['1F480'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC80',
    Version: 'E0.6',
    name: 'skull',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-negative'
  },
  {
    CodePointsHex: ['2620', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2620\uFE0F',
    Version: 'E1.0',
    name: 'skull and crossbones',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-negative'
  },
  {
    CodePointsHex: ['2620'],
    Status: 'unqualified',
    char: '\u2620',
    Version: 'E1.0',
    name: 'skull and crossbones',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-negative'
  },
  {
    CodePointsHex: ['1F4A9'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCA9',
    Version: 'E0.6',
    name: 'pile of poo',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-costume'
  },
  {
    CodePointsHex: ['1F921'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD21',
    Version: 'E3.0',
    name: 'clown face',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-costume'
  },
  {
    CodePointsHex: ['1F479'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC79',
    Version: 'E0.6',
    name: 'ogre',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-costume'
  },
  {
    CodePointsHex: ['1F47A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC7A',
    Version: 'E0.6',
    name: 'goblin',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-costume'
  },
  {
    CodePointsHex: ['1F47B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC7B',
    Version: 'E0.6',
    name: 'ghost',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-costume'
  },
  {
    CodePointsHex: ['1F47D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC7D',
    Version: 'E0.6',
    name: 'alien',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-costume'
  },
  {
    CodePointsHex: ['1F47E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC7E',
    Version: 'E0.6',
    name: 'alien monster',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-costume'
  },
  {
    CodePointsHex: ['1F916'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD16',
    Version: 'E1.0',
    name: 'robot',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'face-costume'
  },
  {
    CodePointsHex: ['1F63A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE3A',
    Version: 'E0.6',
    name: 'grinning cat',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'cat-face'
  },
  {
    CodePointsHex: ['1F638'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE38',
    Version: 'E0.6',
    name: 'grinning cat with smiling eyes',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'cat-face'
  },
  {
    CodePointsHex: ['1F639'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE39',
    Version: 'E0.6',
    name: 'cat with tears of joy',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'cat-face'
  },
  {
    CodePointsHex: ['1F63B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE3B',
    Version: 'E0.6',
    name: 'smiling cat with heart-eyes',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'cat-face'
  },
  {
    CodePointsHex: ['1F63C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE3C',
    Version: 'E0.6',
    name: 'cat with wry smile',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'cat-face'
  },
  {
    CodePointsHex: ['1F63D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE3D',
    Version: 'E0.6',
    name: 'kissing cat',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'cat-face'
  },
  {
    CodePointsHex: ['1F640'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE40',
    Version: 'E0.6',
    name: 'weary cat',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'cat-face'
  },
  {
    CodePointsHex: ['1F63F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE3F',
    Version: 'E0.6',
    name: 'crying cat',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'cat-face'
  },
  {
    CodePointsHex: ['1F63E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE3E',
    Version: 'E0.6',
    name: 'pouting cat',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'cat-face'
  },
  {
    CodePointsHex: ['1F648'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE48',
    Version: 'E0.6',
    name: 'see-no-evil monkey',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'monkey-face'
  },
  {
    CodePointsHex: ['1F649'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE49',
    Version: 'E0.6',
    name: 'hear-no-evil monkey',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'monkey-face'
  },
  {
    CodePointsHex: ['1F64A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4A',
    Version: 'E0.6',
    name: 'speak-no-evil monkey',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'monkey-face'
  },
  {
    CodePointsHex: ['1F48C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC8C',
    Version: 'E0.6',
    name: 'love letter',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1F498'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC98',
    Version: 'E0.6',
    name: 'heart with arrow',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1F49D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC9D',
    Version: 'E0.6',
    name: 'heart with ribbon',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1F496'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC96',
    Version: 'E0.6',
    name: 'sparkling heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1F497'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC97',
    Version: 'E0.6',
    name: 'growing heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1F493'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC93',
    Version: 'E0.6',
    name: 'beating heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1F49E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC9E',
    Version: 'E0.6',
    name: 'revolving hearts',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1F495'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC95',
    Version: 'E0.6',
    name: 'two hearts',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1F49F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC9F',
    Version: 'E0.6',
    name: 'heart decoration',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['2763', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2763\uFE0F',
    Version: 'E1.0',
    name: 'heart exclamation',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['2763'],
    Status: 'unqualified',
    char: '\u2763',
    Version: 'E1.0',
    name: 'heart exclamation',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1F494'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC94',
    Version: 'E0.6',
    name: 'broken heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['2764', 'FE0F', '200D', '1F525'],
    Status: 'fully-qualified',
    char: '\u2764\uFE0F\u200D\uD83D\uDD25',
    Version: 'E13.1',
    name: 'heart on fire',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['2764', '200D', '1F525'],
    Status: 'unqualified',
    char: '\u2764\u200D\uD83D\uDD25',
    Version: 'E13.1',
    name: 'heart on fire',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['2764', 'FE0F', '200D', '1FA79'],
    Status: 'fully-qualified',
    char: '\u2764\uFE0F\u200D\uD83E\uDE79',
    Version: 'E13.1',
    name: 'mending heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['2764', '200D', '1FA79'],
    Status: 'unqualified',
    char: '\u2764\u200D\uD83E\uDE79',
    Version: 'E13.1',
    name: 'mending heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['2764', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2764\uFE0F',
    Version: 'E0.6',
    name: 'red heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['2764'],
    Status: 'unqualified',
    char: '\u2764',
    Version: 'E0.6',
    name: 'red heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1FA77'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE77',
    Version: 'E15.0',
    name: 'pink heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1F9E1'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDE1',
    Version: 'E5.0',
    name: 'orange heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1F49B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC9B',
    Version: 'E0.6',
    name: 'yellow heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1F49A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC9A',
    Version: 'E0.6',
    name: 'green heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1F499'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC99',
    Version: 'E0.6',
    name: 'blue heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1FA75'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE75',
    Version: 'E15.0',
    name: 'light blue heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1F49C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC9C',
    Version: 'E0.6',
    name: 'purple heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1F90E'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD0E',
    Version: 'E12.0',
    name: 'brown heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1F5A4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDA4',
    Version: 'E3.0',
    name: 'black heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1FA76'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE76',
    Version: 'E15.0',
    name: 'grey heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1F90D'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD0D',
    Version: 'E12.0',
    name: 'white heart',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'heart'
  },
  {
    CodePointsHex: ['1F48B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC8B',
    Version: 'E0.6',
    name: 'kiss mark',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F4AF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCAF',
    Version: 'E0.6',
    name: 'hundred points',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F4A2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCA2',
    Version: 'E0.6',
    name: 'anger symbol',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1FAEF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEEF',
    Version: 'E17.0',
    name: 'fight cloud',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F4A5'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCA5',
    Version: 'E0.6',
    name: 'collision',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F4AB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCAB',
    Version: 'E0.6',
    name: 'dizzy',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F4A6'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCA6',
    Version: 'E0.6',
    name: 'sweat droplets',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F4A8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCA8',
    Version: 'E0.6',
    name: 'dashing away',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F573', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD73\uFE0F',
    Version: 'E0.7',
    name: 'hole',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F573'],
    Status: 'unqualified',
    char: '\uD83D\uDD73',
    Version: 'E0.7',
    name: 'hole',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F4AC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCAC',
    Version: 'E0.6',
    name: 'speech balloon',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F441', 'FE0F', '200D', '1F5E8', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F',
    Version: 'E2.0',
    name: 'eye in speech bubble',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F441', '200D', '1F5E8', 'FE0F'],
    Status: 'unqualified',
    char: '\uD83D\uDC41\u200D\uD83D\uDDE8\uFE0F',
    Version: 'E2.0',
    name: 'eye in speech bubble',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F441', 'FE0F', '200D', '1F5E8'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8',
    Version: 'E2.0',
    name: 'eye in speech bubble',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F441', '200D', '1F5E8'],
    Status: 'unqualified',
    char: '\uD83D\uDC41\u200D\uD83D\uDDE8',
    Version: 'E2.0',
    name: 'eye in speech bubble',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F5E8', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDE8\uFE0F',
    Version: 'E2.0',
    name: 'left speech bubble',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F5E8'],
    Status: 'unqualified',
    char: '\uD83D\uDDE8',
    Version: 'E2.0',
    name: 'left speech bubble',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F5EF', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDEF\uFE0F',
    Version: 'E0.7',
    name: 'right anger bubble',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F5EF'],
    Status: 'unqualified',
    char: '\uD83D\uDDEF',
    Version: 'E0.7',
    name: 'right anger bubble',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F4AD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCAD',
    Version: 'E1.0',
    name: 'thought balloon',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F4A4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCA4',
    Version: 'E0.6',
    name: 'ZZZ',
    category: 'Smileys \u0026 Emotion',
    SubGroup: 'emotion'
  },
  {
    CodePointsHex: ['1F44B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4B',
    Version: 'E0.6',
    name: 'waving hand',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F44B', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4B\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'waving hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F44B', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4B\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'waving hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F44B', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4B\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'waving hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F44B', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4B\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'waving hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F44B', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4B\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'waving hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F91A'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1A',
    Version: 'E3.0',
    name: 'raised back of hand',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F91A', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1A\uD83C\uDFFB',
    Version: 'E3.0',
    name: 'raised back of hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F91A', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1A\uD83C\uDFFC',
    Version: 'E3.0',
    name: 'raised back of hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F91A', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1A\uD83C\uDFFD',
    Version: 'E3.0',
    name: 'raised back of hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F91A', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1A\uD83C\uDFFE',
    Version: 'E3.0',
    name: 'raised back of hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F91A', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1A\uD83C\uDFFF',
    Version: 'E3.0',
    name: 'raised back of hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F590', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD90\uFE0F',
    Version: 'E0.7',
    name: 'hand with fingers splayed',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F590'],
    Status: 'unqualified',
    char: '\uD83D\uDD90',
    Version: 'E0.7',
    name: 'hand with fingers splayed',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F590', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD90\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'hand with fingers splayed: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F590', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD90\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'hand with fingers splayed: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F590', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD90\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'hand with fingers splayed: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F590', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD90\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'hand with fingers splayed: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F590', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD90\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'hand with fingers splayed: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['270B'],
    Status: 'fully-qualified',
    char: '\u270B',
    Version: 'E0.6',
    name: 'raised hand',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['270B', '1F3FB'],
    Status: 'fully-qualified',
    char: '\u270B\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'raised hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['270B', '1F3FC'],
    Status: 'fully-qualified',
    char: '\u270B\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'raised hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['270B', '1F3FD'],
    Status: 'fully-qualified',
    char: '\u270B\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'raised hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['270B', '1F3FE'],
    Status: 'fully-qualified',
    char: '\u270B\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'raised hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['270B', '1F3FF'],
    Status: 'fully-qualified',
    char: '\u270B\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'raised hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F596'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD96',
    Version: 'E1.0',
    name: 'vulcan salute',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F596', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD96\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'vulcan salute: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F596', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD96\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'vulcan salute: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F596', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD96\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'vulcan salute: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F596', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD96\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'vulcan salute: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F596', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD96\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'vulcan salute: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF1'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1',
    Version: 'E14.0',
    name: 'rightwards hand',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFB',
    Version: 'E14.0',
    name: 'rightwards hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFC',
    Version: 'E14.0',
    name: 'rightwards hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFD',
    Version: 'E14.0',
    name: 'rightwards hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFE',
    Version: 'E14.0',
    name: 'rightwards hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFF',
    Version: 'E14.0',
    name: 'rightwards hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF2',
    Version: 'E14.0',
    name: 'leftwards hand',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF2', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF2\uD83C\uDFFB',
    Version: 'E14.0',
    name: 'leftwards hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF2', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF2\uD83C\uDFFC',
    Version: 'E14.0',
    name: 'leftwards hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF2', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF2\uD83C\uDFFD',
    Version: 'E14.0',
    name: 'leftwards hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF2', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF2\uD83C\uDFFE',
    Version: 'E14.0',
    name: 'leftwards hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF2', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF2\uD83C\uDFFF',
    Version: 'E14.0',
    name: 'leftwards hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF3'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF3',
    Version: 'E14.0',
    name: 'palm down hand',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF3', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF3\uD83C\uDFFB',
    Version: 'E14.0',
    name: 'palm down hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF3', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF3\uD83C\uDFFC',
    Version: 'E14.0',
    name: 'palm down hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF3', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF3\uD83C\uDFFD',
    Version: 'E14.0',
    name: 'palm down hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF3', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF3\uD83C\uDFFE',
    Version: 'E14.0',
    name: 'palm down hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF3', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF3\uD83C\uDFFF',
    Version: 'E14.0',
    name: 'palm down hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF4'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF4',
    Version: 'E14.0',
    name: 'palm up hand',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF4', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF4\uD83C\uDFFB',
    Version: 'E14.0',
    name: 'palm up hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF4', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF4\uD83C\uDFFC',
    Version: 'E14.0',
    name: 'palm up hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF4', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF4\uD83C\uDFFD',
    Version: 'E14.0',
    name: 'palm up hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF4', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF4\uD83C\uDFFE',
    Version: 'E14.0',
    name: 'palm up hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF4', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF4\uD83C\uDFFF',
    Version: 'E14.0',
    name: 'palm up hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF7'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF7',
    Version: 'E15.0',
    name: 'leftwards pushing hand',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF7', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF7\uD83C\uDFFB',
    Version: 'E15.0',
    name: 'leftwards pushing hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF7', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF7\uD83C\uDFFC',
    Version: 'E15.0',
    name: 'leftwards pushing hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF7', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF7\uD83C\uDFFD',
    Version: 'E15.0',
    name: 'leftwards pushing hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF7', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF7\uD83C\uDFFE',
    Version: 'E15.0',
    name: 'leftwards pushing hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF7', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF7\uD83C\uDFFF',
    Version: 'E15.0',
    name: 'leftwards pushing hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF8'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF8',
    Version: 'E15.0',
    name: 'rightwards pushing hand',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF8', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF8\uD83C\uDFFB',
    Version: 'E15.0',
    name: 'rightwards pushing hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF8', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF8\uD83C\uDFFC',
    Version: 'E15.0',
    name: 'rightwards pushing hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF8', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF8\uD83C\uDFFD',
    Version: 'E15.0',
    name: 'rightwards pushing hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF8', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF8\uD83C\uDFFE',
    Version: 'E15.0',
    name: 'rightwards pushing hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1FAF8', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF8\uD83C\uDFFF',
    Version: 'E15.0',
    name: 'rightwards pushing hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-open'
  },
  {
    CodePointsHex: ['1F44C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4C',
    Version: 'E0.6',
    name: 'OK hand',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F44C', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4C\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'OK hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F44C', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4C\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'OK hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F44C', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4C\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'OK hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F44C', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4C\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'OK hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F44C', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4C\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'OK hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F90C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD0C',
    Version: 'E13.0',
    name: 'pinched fingers',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F90C', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD0C\uD83C\uDFFB',
    Version: 'E13.0',
    name: 'pinched fingers: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F90C', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD0C\uD83C\uDFFC',
    Version: 'E13.0',
    name: 'pinched fingers: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F90C', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD0C\uD83C\uDFFD',
    Version: 'E13.0',
    name: 'pinched fingers: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F90C', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD0C\uD83C\uDFFE',
    Version: 'E13.0',
    name: 'pinched fingers: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F90C', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD0C\uD83C\uDFFF',
    Version: 'E13.0',
    name: 'pinched fingers: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F90F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD0F',
    Version: 'E12.0',
    name: 'pinching hand',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F90F', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD0F\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'pinching hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F90F', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD0F\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'pinching hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F90F', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD0F\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'pinching hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F90F', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD0F\uD83C\uDFFE',
    Version: 'E12.0',
    name: 'pinching hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F90F', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD0F\uD83C\uDFFF',
    Version: 'E12.0',
    name: 'pinching hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['270C', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u270C\uFE0F',
    Version: 'E0.6',
    name: 'victory hand',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['270C'],
    Status: 'unqualified',
    char: '\u270C',
    Version: 'E0.6',
    name: 'victory hand',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['270C', '1F3FB'],
    Status: 'fully-qualified',
    char: '\u270C\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'victory hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['270C', '1F3FC'],
    Status: 'fully-qualified',
    char: '\u270C\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'victory hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['270C', '1F3FD'],
    Status: 'fully-qualified',
    char: '\u270C\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'victory hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['270C', '1F3FE'],
    Status: 'fully-qualified',
    char: '\u270C\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'victory hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['270C', '1F3FF'],
    Status: 'fully-qualified',
    char: '\u270C\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'victory hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F91E'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1E',
    Version: 'E3.0',
    name: 'crossed fingers',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F91E', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1E\uD83C\uDFFB',
    Version: 'E3.0',
    name: 'crossed fingers: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F91E', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1E\uD83C\uDFFC',
    Version: 'E3.0',
    name: 'crossed fingers: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F91E', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1E\uD83C\uDFFD',
    Version: 'E3.0',
    name: 'crossed fingers: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F91E', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1E\uD83C\uDFFE',
    Version: 'E3.0',
    name: 'crossed fingers: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F91E', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1E\uD83C\uDFFF',
    Version: 'E3.0',
    name: 'crossed fingers: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1FAF0'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF0',
    Version: 'E14.0',
    name: 'hand with index finger and thumb crossed',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1FAF0', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF0\uD83C\uDFFB',
    Version: 'E14.0',
    name: 'hand with index finger and thumb crossed: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1FAF0', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF0\uD83C\uDFFC',
    Version: 'E14.0',
    name: 'hand with index finger and thumb crossed: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1FAF0', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF0\uD83C\uDFFD',
    Version: 'E14.0',
    name: 'hand with index finger and thumb crossed: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1FAF0', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF0\uD83C\uDFFE',
    Version: 'E14.0',
    name: 'hand with index finger and thumb crossed: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1FAF0', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF0\uD83C\uDFFF',
    Version: 'E14.0',
    name: 'hand with index finger and thumb crossed: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F91F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1F',
    Version: 'E5.0',
    name: 'love-you gesture',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F91F', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1F\uD83C\uDFFB',
    Version: 'E5.0',
    name: 'love-you gesture: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F91F', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1F\uD83C\uDFFC',
    Version: 'E5.0',
    name: 'love-you gesture: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F91F', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1F\uD83C\uDFFD',
    Version: 'E5.0',
    name: 'love-you gesture: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F91F', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1F\uD83C\uDFFE',
    Version: 'E5.0',
    name: 'love-you gesture: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F91F', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1F\uD83C\uDFFF',
    Version: 'E5.0',
    name: 'love-you gesture: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F918'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD18',
    Version: 'E1.0',
    name: 'sign of the horns',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F918', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD18\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'sign of the horns: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F918', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD18\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'sign of the horns: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F918', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD18\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'sign of the horns: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F918', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD18\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'sign of the horns: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F918', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD18\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'sign of the horns: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F919'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD19',
    Version: 'E3.0',
    name: 'call me hand',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F919', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD19\uD83C\uDFFB',
    Version: 'E3.0',
    name: 'call me hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F919', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD19\uD83C\uDFFC',
    Version: 'E3.0',
    name: 'call me hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F919', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD19\uD83C\uDFFD',
    Version: 'E3.0',
    name: 'call me hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F919', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD19\uD83C\uDFFE',
    Version: 'E3.0',
    name: 'call me hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F919', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD19\uD83C\uDFFF',
    Version: 'E3.0',
    name: 'call me hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-partial'
  },
  {
    CodePointsHex: ['1F448'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC48',
    Version: 'E0.6',
    name: 'backhand index pointing left',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F448', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC48\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'backhand index pointing left: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F448', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC48\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'backhand index pointing left: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F448', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC48\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'backhand index pointing left: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F448', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC48\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'backhand index pointing left: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F448', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC48\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'backhand index pointing left: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F449'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC49',
    Version: 'E0.6',
    name: 'backhand index pointing right',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F449', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC49\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'backhand index pointing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F449', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC49\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'backhand index pointing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F449', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC49\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'backhand index pointing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F449', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC49\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'backhand index pointing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F449', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC49\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'backhand index pointing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F446'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC46',
    Version: 'E0.6',
    name: 'backhand index pointing up',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F446', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC46\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'backhand index pointing up: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F446', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC46\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'backhand index pointing up: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F446', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC46\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'backhand index pointing up: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F446', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC46\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'backhand index pointing up: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F446', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC46\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'backhand index pointing up: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F595'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD95',
    Version: 'E1.0',
    name: 'middle finger',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F595', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD95\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'middle finger: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F595', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD95\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'middle finger: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F595', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD95\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'middle finger: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F595', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD95\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'middle finger: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F595', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD95\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'middle finger: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F447'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC47',
    Version: 'E0.6',
    name: 'backhand index pointing down',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F447', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC47\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'backhand index pointing down: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F447', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC47\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'backhand index pointing down: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F447', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC47\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'backhand index pointing down: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F447', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC47\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'backhand index pointing down: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F447', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC47\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'backhand index pointing down: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['261D', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u261D\uFE0F',
    Version: 'E0.6',
    name: 'index pointing up',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['261D'],
    Status: 'unqualified',
    char: '\u261D',
    Version: 'E0.6',
    name: 'index pointing up',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['261D', '1F3FB'],
    Status: 'fully-qualified',
    char: '\u261D\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'index pointing up: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['261D', '1F3FC'],
    Status: 'fully-qualified',
    char: '\u261D\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'index pointing up: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['261D', '1F3FD'],
    Status: 'fully-qualified',
    char: '\u261D\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'index pointing up: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['261D', '1F3FE'],
    Status: 'fully-qualified',
    char: '\u261D\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'index pointing up: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['261D', '1F3FF'],
    Status: 'fully-qualified',
    char: '\u261D\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'index pointing up: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1FAF5'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF5',
    Version: 'E14.0',
    name: 'index pointing at the viewer',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1FAF5', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF5\uD83C\uDFFB',
    Version: 'E14.0',
    name: 'index pointing at the viewer: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1FAF5', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF5\uD83C\uDFFC',
    Version: 'E14.0',
    name: 'index pointing at the viewer: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1FAF5', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF5\uD83C\uDFFD',
    Version: 'E14.0',
    name: 'index pointing at the viewer: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1FAF5', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF5\uD83C\uDFFE',
    Version: 'E14.0',
    name: 'index pointing at the viewer: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1FAF5', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF5\uD83C\uDFFF',
    Version: 'E14.0',
    name: 'index pointing at the viewer: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-single-finger'
  },
  {
    CodePointsHex: ['1F44D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4D',
    Version: 'E0.6',
    name: 'thumbs up',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F44D', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4D\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'thumbs up: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F44D', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4D\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'thumbs up: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F44D', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4D\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'thumbs up: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F44D', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4D\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'thumbs up: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F44D', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4D\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'thumbs up: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F44E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4E',
    Version: 'E0.6',
    name: 'thumbs down',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F44E', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4E\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'thumbs down: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F44E', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4E\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'thumbs down: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F44E', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4E\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'thumbs down: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F44E', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4E\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'thumbs down: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F44E', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4E\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'thumbs down: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['270A'],
    Status: 'fully-qualified',
    char: '\u270A',
    Version: 'E0.6',
    name: 'raised fist',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['270A', '1F3FB'],
    Status: 'fully-qualified',
    char: '\u270A\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'raised fist: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['270A', '1F3FC'],
    Status: 'fully-qualified',
    char: '\u270A\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'raised fist: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['270A', '1F3FD'],
    Status: 'fully-qualified',
    char: '\u270A\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'raised fist: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['270A', '1F3FE'],
    Status: 'fully-qualified',
    char: '\u270A\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'raised fist: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['270A', '1F3FF'],
    Status: 'fully-qualified',
    char: '\u270A\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'raised fist: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F44A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4A',
    Version: 'E0.6',
    name: 'oncoming fist',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F44A', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4A\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'oncoming fist: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F44A', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4A\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'oncoming fist: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F44A', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4A\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'oncoming fist: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F44A', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4A\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'oncoming fist: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F44A', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4A\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'oncoming fist: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F91B'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1B',
    Version: 'E3.0',
    name: 'left-facing fist',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F91B', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1B\uD83C\uDFFB',
    Version: 'E3.0',
    name: 'left-facing fist: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F91B', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1B\uD83C\uDFFC',
    Version: 'E3.0',
    name: 'left-facing fist: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F91B', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1B\uD83C\uDFFD',
    Version: 'E3.0',
    name: 'left-facing fist: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F91B', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1B\uD83C\uDFFE',
    Version: 'E3.0',
    name: 'left-facing fist: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F91B', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1B\uD83C\uDFFF',
    Version: 'E3.0',
    name: 'left-facing fist: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F91C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1C',
    Version: 'E3.0',
    name: 'right-facing fist',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F91C', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1C\uD83C\uDFFB',
    Version: 'E3.0',
    name: 'right-facing fist: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F91C', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1C\uD83C\uDFFC',
    Version: 'E3.0',
    name: 'right-facing fist: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F91C', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1C\uD83C\uDFFD',
    Version: 'E3.0',
    name: 'right-facing fist: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F91C', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1C\uD83C\uDFFE',
    Version: 'E3.0',
    name: 'right-facing fist: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F91C', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1C\uD83C\uDFFF',
    Version: 'E3.0',
    name: 'right-facing fist: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-fingers-closed'
  },
  {
    CodePointsHex: ['1F44F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4F',
    Version: 'E0.6',
    name: 'clapping hands',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F44F', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4F\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'clapping hands: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F44F', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4F\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'clapping hands: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F44F', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4F\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'clapping hands: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F44F', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4F\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'clapping hands: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F44F', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC4F\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'clapping hands: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F64C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4C',
    Version: 'E0.6',
    name: 'raising hands',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F64C', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4C\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'raising hands: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F64C', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4C\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'raising hands: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F64C', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4C\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'raising hands: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F64C', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4C\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'raising hands: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F64C', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4C\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'raising hands: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF6'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF6',
    Version: 'E14.0',
    name: 'heart hands',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF6', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF6\uD83C\uDFFB',
    Version: 'E14.0',
    name: 'heart hands: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF6', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF6\uD83C\uDFFC',
    Version: 'E14.0',
    name: 'heart hands: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF6', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF6\uD83C\uDFFD',
    Version: 'E14.0',
    name: 'heart hands: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF6', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF6\uD83C\uDFFE',
    Version: 'E14.0',
    name: 'heart hands: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF6', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF6\uD83C\uDFFF',
    Version: 'E14.0',
    name: 'heart hands: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F450'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC50',
    Version: 'E0.6',
    name: 'open hands',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F450', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC50\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'open hands: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F450', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC50\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'open hands: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F450', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC50\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'open hands: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F450', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC50\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'open hands: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F450', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC50\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'open hands: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F932'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD32',
    Version: 'E5.0',
    name: 'palms up together',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F932', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD32\uD83C\uDFFB',
    Version: 'E5.0',
    name: 'palms up together: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F932', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD32\uD83C\uDFFC',
    Version: 'E5.0',
    name: 'palms up together: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F932', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD32\uD83C\uDFFD',
    Version: 'E5.0',
    name: 'palms up together: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F932', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD32\uD83C\uDFFE',
    Version: 'E5.0',
    name: 'palms up together: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F932', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD32\uD83C\uDFFF',
    Version: 'E5.0',
    name: 'palms up together: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F91D'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1D',
    Version: 'E3.0',
    name: 'handshake',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F91D', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1D\uD83C\uDFFB',
    Version: 'E14.0',
    name: 'handshake: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F91D', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1D\uD83C\uDFFC',
    Version: 'E14.0',
    name: 'handshake: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F91D', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1D\uD83C\uDFFD',
    Version: 'E14.0',
    name: 'handshake: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F91D', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1D\uD83C\uDFFE',
    Version: 'E14.0',
    name: 'handshake: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F91D', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD1D\uD83C\uDFFF',
    Version: 'E14.0',
    name: 'handshake: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FB', '200D', '1FAF2', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFB\u200D\uD83E\uDEF2\uD83C\uDFFC',
    Version: 'E14.0',
    name: 'handshake: light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FB', '200D', '1FAF2', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFB\u200D\uD83E\uDEF2\uD83C\uDFFD',
    Version: 'E14.0',
    name: 'handshake: light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FB', '200D', '1FAF2', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFB\u200D\uD83E\uDEF2\uD83C\uDFFE',
    Version: 'E14.0',
    name: 'handshake: light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FB', '200D', '1FAF2', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFB\u200D\uD83E\uDEF2\uD83C\uDFFF',
    Version: 'E14.0',
    name: 'handshake: light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FC', '200D', '1FAF2', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFC\u200D\uD83E\uDEF2\uD83C\uDFFB',
    Version: 'E14.0',
    name: 'handshake: medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FC', '200D', '1FAF2', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFC\u200D\uD83E\uDEF2\uD83C\uDFFD',
    Version: 'E14.0',
    name: 'handshake: medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FC', '200D', '1FAF2', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFC\u200D\uD83E\uDEF2\uD83C\uDFFE',
    Version: 'E14.0',
    name: 'handshake: medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FC', '200D', '1FAF2', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFC\u200D\uD83E\uDEF2\uD83C\uDFFF',
    Version: 'E14.0',
    name: 'handshake: medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FD', '200D', '1FAF2', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFD\u200D\uD83E\uDEF2\uD83C\uDFFB',
    Version: 'E14.0',
    name: 'handshake: medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FD', '200D', '1FAF2', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFD\u200D\uD83E\uDEF2\uD83C\uDFFC',
    Version: 'E14.0',
    name: 'handshake: medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FD', '200D', '1FAF2', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFD\u200D\uD83E\uDEF2\uD83C\uDFFE',
    Version: 'E14.0',
    name: 'handshake: medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FD', '200D', '1FAF2', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFD\u200D\uD83E\uDEF2\uD83C\uDFFF',
    Version: 'E14.0',
    name: 'handshake: medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FE', '200D', '1FAF2', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFE\u200D\uD83E\uDEF2\uD83C\uDFFB',
    Version: 'E14.0',
    name: 'handshake: medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FE', '200D', '1FAF2', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFE\u200D\uD83E\uDEF2\uD83C\uDFFC',
    Version: 'E14.0',
    name: 'handshake: medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FE', '200D', '1FAF2', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFE\u200D\uD83E\uDEF2\uD83C\uDFFD',
    Version: 'E14.0',
    name: 'handshake: medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FE', '200D', '1FAF2', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFE\u200D\uD83E\uDEF2\uD83C\uDFFF',
    Version: 'E14.0',
    name: 'handshake: medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FF', '200D', '1FAF2', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFF\u200D\uD83E\uDEF2\uD83C\uDFFB',
    Version: 'E14.0',
    name: 'handshake: dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FF', '200D', '1FAF2', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFF\u200D\uD83E\uDEF2\uD83C\uDFFC',
    Version: 'E14.0',
    name: 'handshake: dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FF', '200D', '1FAF2', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFF\u200D\uD83E\uDEF2\uD83C\uDFFD',
    Version: 'E14.0',
    name: 'handshake: dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1FAF1', '1F3FF', '200D', '1FAF2', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEF1\uD83C\uDFFF\u200D\uD83E\uDEF2\uD83C\uDFFE',
    Version: 'E14.0',
    name: 'handshake: dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F64F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4F',
    Version: 'E0.6',
    name: 'folded hands',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F64F', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4F\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'folded hands: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F64F', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4F\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'folded hands: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F64F', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4F\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'folded hands: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F64F', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4F\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'folded hands: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['1F64F', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4F\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'folded hands: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hands'
  },
  {
    CodePointsHex: ['270D', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u270D\uFE0F',
    Version: 'E0.7',
    name: 'writing hand',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['270D'],
    Status: 'unqualified',
    char: '\u270D',
    Version: 'E0.7',
    name: 'writing hand',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['270D', '1F3FB'],
    Status: 'fully-qualified',
    char: '\u270D\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'writing hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['270D', '1F3FC'],
    Status: 'fully-qualified',
    char: '\u270D\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'writing hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['270D', '1F3FD'],
    Status: 'fully-qualified',
    char: '\u270D\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'writing hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['270D', '1F3FE'],
    Status: 'fully-qualified',
    char: '\u270D\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'writing hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['270D', '1F3FF'],
    Status: 'fully-qualified',
    char: '\u270D\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'writing hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['1F485'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC85',
    Version: 'E0.6',
    name: 'nail polish',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['1F485', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC85\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'nail polish: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['1F485', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC85\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'nail polish: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['1F485', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC85\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'nail polish: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['1F485', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC85\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'nail polish: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['1F485', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC85\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'nail polish: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['1F933'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD33',
    Version: 'E3.0',
    name: 'selfie',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['1F933', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD33\uD83C\uDFFB',
    Version: 'E3.0',
    name: 'selfie: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['1F933', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD33\uD83C\uDFFC',
    Version: 'E3.0',
    name: 'selfie: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['1F933', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD33\uD83C\uDFFD',
    Version: 'E3.0',
    name: 'selfie: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['1F933', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD33\uD83C\uDFFE',
    Version: 'E3.0',
    name: 'selfie: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['1F933', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD33\uD83C\uDFFF',
    Version: 'E3.0',
    name: 'selfie: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'hand-prop'
  },
  {
    CodePointsHex: ['1F4AA'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCAA',
    Version: 'E0.6',
    name: 'flexed biceps',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F4AA', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCAA\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'flexed biceps: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F4AA', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCAA\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'flexed biceps: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F4AA', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCAA\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'flexed biceps: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F4AA', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCAA\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'flexed biceps: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F4AA', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCAA\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'flexed biceps: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9BE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDBE',
    Version: 'E12.0',
    name: 'mechanical arm',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9BF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDBF',
    Version: 'E12.0',
    name: 'mechanical leg',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9B5'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB5',
    Version: 'E11.0',
    name: 'leg',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9B5', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB5\uD83C\uDFFB',
    Version: 'E11.0',
    name: 'leg: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9B5', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB5\uD83C\uDFFC',
    Version: 'E11.0',
    name: 'leg: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9B5', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB5\uD83C\uDFFD',
    Version: 'E11.0',
    name: 'leg: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9B5', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB5\uD83C\uDFFE',
    Version: 'E11.0',
    name: 'leg: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9B5', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB5\uD83C\uDFFF',
    Version: 'E11.0',
    name: 'leg: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9B6'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB6',
    Version: 'E11.0',
    name: 'foot',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9B6', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB6\uD83C\uDFFB',
    Version: 'E11.0',
    name: 'foot: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9B6', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB6\uD83C\uDFFC',
    Version: 'E11.0',
    name: 'foot: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9B6', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB6\uD83C\uDFFD',
    Version: 'E11.0',
    name: 'foot: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9B6', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB6\uD83C\uDFFE',
    Version: 'E11.0',
    name: 'foot: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9B6', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB6\uD83C\uDFFF',
    Version: 'E11.0',
    name: 'foot: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F442'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC42',
    Version: 'E0.6',
    name: 'ear',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F442', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC42\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'ear: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F442', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC42\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'ear: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F442', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC42\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'ear: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F442', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC42\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'ear: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F442', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC42\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'ear: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9BB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDBB',
    Version: 'E12.0',
    name: 'ear with hearing aid',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9BB', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDBB\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'ear with hearing aid: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9BB', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDBB\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'ear with hearing aid: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9BB', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDBB\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'ear with hearing aid: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9BB', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDBB\uD83C\uDFFE',
    Version: 'E12.0',
    name: 'ear with hearing aid: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9BB', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDBB\uD83C\uDFFF',
    Version: 'E12.0',
    name: 'ear with hearing aid: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F443'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC43',
    Version: 'E0.6',
    name: 'nose',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F443', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC43\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'nose: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F443', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC43\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'nose: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F443', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC43\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'nose: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F443', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC43\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'nose: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F443', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC43\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'nose: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9E0'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDE0',
    Version: 'E5.0',
    name: 'brain',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1FAC0'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC0',
    Version: 'E13.0',
    name: 'anatomical heart',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1FAC1'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC1',
    Version: 'E13.0',
    name: 'lungs',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9B7'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB7',
    Version: 'E11.0',
    name: 'tooth',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F9B4'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB4',
    Version: 'E11.0',
    name: 'bone',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F440'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC40',
    Version: 'E0.6',
    name: 'eyes',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F441', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC41\uFE0F',
    Version: 'E0.7',
    name: 'eye',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F441'],
    Status: 'unqualified',
    char: '\uD83D\uDC41',
    Version: 'E0.7',
    name: 'eye',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F445'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC45',
    Version: 'E0.6',
    name: 'tongue',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F444'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC44',
    Version: 'E0.6',
    name: 'mouth',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1FAE6'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEE6',
    Version: 'E14.0',
    name: 'biting lip',
    category: 'People \u0026 Body',
    SubGroup: 'body-parts'
  },
  {
    CodePointsHex: ['1F476'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC76',
    Version: 'E0.6',
    name: 'baby',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F476', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC76\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'baby: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F476', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC76\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'baby: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F476', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC76\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'baby: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F476', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC76\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'baby: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F476', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC76\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'baby: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD2',
    Version: 'E5.0',
    name: 'child',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D2', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD2\uD83C\uDFFB',
    Version: 'E5.0',
    name: 'child: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D2', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD2\uD83C\uDFFC',
    Version: 'E5.0',
    name: 'child: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D2', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD2\uD83C\uDFFD',
    Version: 'E5.0',
    name: 'child: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D2', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD2\uD83C\uDFFE',
    Version: 'E5.0',
    name: 'child: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D2', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD2\uD83C\uDFFF',
    Version: 'E5.0',
    name: 'child: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F466'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC66',
    Version: 'E0.6',
    name: 'boy',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F466', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC66\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'boy: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F466', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC66\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'boy: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F466', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC66\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'boy: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F466', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC66\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'boy: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F466', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC66\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'boy: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F467'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC67',
    Version: 'E0.6',
    name: 'girl',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F467', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC67\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'girl: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F467', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC67\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'girl: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F467', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC67\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'girl: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F467', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC67\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'girl: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F467', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC67\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'girl: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1',
    Version: 'E5.0',
    name: 'person',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E5.0',
    name: 'person: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E5.0',
    name: 'person: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E5.0',
    name: 'person: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E5.0',
    name: 'person: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E5.0',
    name: 'person: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC71',
    Version: 'E0.6',
    name: 'person: blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person: light skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person: medium-light skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person: medium skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person: medium-dark skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person: dark skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68',
    Version: 'E0.6',
    name: 'man',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'man: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'man: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'man: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'man: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'man: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD4',
    Version: 'E5.0',
    name: 'person: beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFB',
    Version: 'E5.0',
    name: 'person: light skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFC',
    Version: 'E5.0',
    name: 'person: medium-light skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFD',
    Version: 'E5.0',
    name: 'person: medium skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFE',
    Version: 'E5.0',
    name: 'person: medium-dark skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFF',
    Version: 'E5.0',
    name: 'person: dark skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD4\u200D\u2642\uFE0F',
    Version: 'E13.1',
    name: 'man: beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD4\u200D\u2642',
    Version: 'E13.1',
    name: 'man: beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E13.1',
    name: 'man: light skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFB\u200D\u2642',
    Version: 'E13.1',
    name: 'man: light skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E13.1',
    name: 'man: medium-light skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFC\u200D\u2642',
    Version: 'E13.1',
    name: 'man: medium-light skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E13.1',
    name: 'man: medium skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFD\u200D\u2642',
    Version: 'E13.1',
    name: 'man: medium skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E13.1',
    name: 'man: medium-dark skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFE\u200D\u2642',
    Version: 'E13.1',
    name: 'man: medium-dark skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E13.1',
    name: 'man: dark skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFF\u200D\u2642',
    Version: 'E13.1',
    name: 'man: dark skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD4\u200D\u2640\uFE0F',
    Version: 'E13.1',
    name: 'woman: beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD4\u200D\u2640',
    Version: 'E13.1',
    name: 'woman: beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E13.1',
    name: 'woman: light skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFB\u200D\u2640',
    Version: 'E13.1',
    name: 'woman: light skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E13.1',
    name: 'woman: medium-light skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFC\u200D\u2640',
    Version: 'E13.1',
    name: 'woman: medium-light skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E13.1',
    name: 'woman: medium skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFD\u200D\u2640',
    Version: 'E13.1',
    name: 'woman: medium skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E13.1',
    name: 'woman: medium-dark skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFE\u200D\u2640',
    Version: 'E13.1',
    name: 'woman: medium-dark skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E13.1',
    name: 'woman: dark skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D4', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD4\uD83C\uDFFF\u200D\u2640',
    Version: 'E13.1',
    name: 'woman: dark skin tone, beard',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F9B0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83E\uDDB0',
    Version: 'E11.0',
    name: 'man: red hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F9B0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB0',
    Version: 'E11.0',
    name: 'man: light skin tone, red hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F9B0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB0',
    Version: 'E11.0',
    name: 'man: medium-light skin tone, red hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F9B0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB0',
    Version: 'E11.0',
    name: 'man: medium skin tone, red hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F9B0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB0',
    Version: 'E11.0',
    name: 'man: medium-dark skin tone, red hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F9B0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB0',
    Version: 'E11.0',
    name: 'man: dark skin tone, red hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F9B1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83E\uDDB1',
    Version: 'E11.0',
    name: 'man: curly hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F9B1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB1',
    Version: 'E11.0',
    name: 'man: light skin tone, curly hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F9B1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB1',
    Version: 'E11.0',
    name: 'man: medium-light skin tone, curly hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F9B1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB1',
    Version: 'E11.0',
    name: 'man: medium skin tone, curly hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F9B1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB1',
    Version: 'E11.0',
    name: 'man: medium-dark skin tone, curly hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F9B1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB1',
    Version: 'E11.0',
    name: 'man: dark skin tone, curly hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F9B3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83E\uDDB3',
    Version: 'E11.0',
    name: 'man: white hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F9B3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB3',
    Version: 'E11.0',
    name: 'man: light skin tone, white hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F9B3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB3',
    Version: 'E11.0',
    name: 'man: medium-light skin tone, white hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F9B3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB3',
    Version: 'E11.0',
    name: 'man: medium skin tone, white hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F9B3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB3',
    Version: 'E11.0',
    name: 'man: medium-dark skin tone, white hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F9B3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB3',
    Version: 'E11.0',
    name: 'man: dark skin tone, white hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F9B2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83E\uDDB2',
    Version: 'E11.0',
    name: 'man: bald',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F9B2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB2',
    Version: 'E11.0',
    name: 'man: light skin tone, bald',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F9B2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB2',
    Version: 'E11.0',
    name: 'man: medium-light skin tone, bald',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F9B2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB2',
    Version: 'E11.0',
    name: 'man: medium skin tone, bald',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F9B2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB2',
    Version: 'E11.0',
    name: 'man: medium-dark skin tone, bald',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F9B2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB2',
    Version: 'E11.0',
    name: 'man: dark skin tone, bald',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69',
    Version: 'E0.6',
    name: 'woman',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'woman: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'woman: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'woman: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'woman: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'woman: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F9B0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83E\uDDB0',
    Version: 'E11.0',
    name: 'woman: red hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F9B0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB0',
    Version: 'E11.0',
    name: 'woman: light skin tone, red hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F9B0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB0',
    Version: 'E11.0',
    name: 'woman: medium-light skin tone, red hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F9B0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB0',
    Version: 'E11.0',
    name: 'woman: medium skin tone, red hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F9B0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB0',
    Version: 'E11.0',
    name: 'woman: medium-dark skin tone, red hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F9B0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB0',
    Version: 'E11.0',
    name: 'woman: dark skin tone, red hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F9B0'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDDB0',
    Version: 'E12.1',
    name: 'person: red hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F9B0'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB0',
    Version: 'E12.1',
    name: 'person: light skin tone, red hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F9B0'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB0',
    Version: 'E12.1',
    name: 'person: medium-light skin tone, red hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F9B0'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB0',
    Version: 'E12.1',
    name: 'person: medium skin tone, red hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F9B0'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB0',
    Version: 'E12.1',
    name: 'person: medium-dark skin tone, red hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F9B0'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB0',
    Version: 'E12.1',
    name: 'person: dark skin tone, red hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F9B1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83E\uDDB1',
    Version: 'E11.0',
    name: 'woman: curly hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F9B1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB1',
    Version: 'E11.0',
    name: 'woman: light skin tone, curly hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F9B1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB1',
    Version: 'E11.0',
    name: 'woman: medium-light skin tone, curly hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F9B1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB1',
    Version: 'E11.0',
    name: 'woman: medium skin tone, curly hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F9B1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB1',
    Version: 'E11.0',
    name: 'woman: medium-dark skin tone, curly hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F9B1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB1',
    Version: 'E11.0',
    name: 'woman: dark skin tone, curly hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F9B1'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDDB1',
    Version: 'E12.1',
    name: 'person: curly hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F9B1'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB1',
    Version: 'E12.1',
    name: 'person: light skin tone, curly hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F9B1'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB1',
    Version: 'E12.1',
    name: 'person: medium-light skin tone, curly hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F9B1'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB1',
    Version: 'E12.1',
    name: 'person: medium skin tone, curly hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F9B1'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB1',
    Version: 'E12.1',
    name: 'person: medium-dark skin tone, curly hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F9B1'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB1',
    Version: 'E12.1',
    name: 'person: dark skin tone, curly hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F9B3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83E\uDDB3',
    Version: 'E11.0',
    name: 'woman: white hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F9B3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB3',
    Version: 'E11.0',
    name: 'woman: light skin tone, white hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F9B3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB3',
    Version: 'E11.0',
    name: 'woman: medium-light skin tone, white hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F9B3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB3',
    Version: 'E11.0',
    name: 'woman: medium skin tone, white hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F9B3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB3',
    Version: 'E11.0',
    name: 'woman: medium-dark skin tone, white hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F9B3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB3',
    Version: 'E11.0',
    name: 'woman: dark skin tone, white hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F9B3'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDDB3',
    Version: 'E12.1',
    name: 'person: white hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F9B3'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB3',
    Version: 'E12.1',
    name: 'person: light skin tone, white hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F9B3'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB3',
    Version: 'E12.1',
    name: 'person: medium-light skin tone, white hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F9B3'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB3',
    Version: 'E12.1',
    name: 'person: medium skin tone, white hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F9B3'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB3',
    Version: 'E12.1',
    name: 'person: medium-dark skin tone, white hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F9B3'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB3',
    Version: 'E12.1',
    name: 'person: dark skin tone, white hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F9B2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83E\uDDB2',
    Version: 'E11.0',
    name: 'woman: bald',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F9B2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB2',
    Version: 'E11.0',
    name: 'woman: light skin tone, bald',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F9B2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB2',
    Version: 'E11.0',
    name: 'woman: medium-light skin tone, bald',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F9B2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB2',
    Version: 'E11.0',
    name: 'woman: medium skin tone, bald',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F9B2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB2',
    Version: 'E11.0',
    name: 'woman: medium-dark skin tone, bald',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F9B2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB2',
    Version: 'E11.0',
    name: 'woman: dark skin tone, bald',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F9B2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDDB2',
    Version: 'E12.1',
    name: 'person: bald',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F9B2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB2',
    Version: 'E12.1',
    name: 'person: light skin tone, bald',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F9B2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB2',
    Version: 'E12.1',
    name: 'person: medium-light skin tone, bald',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F9B2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB2',
    Version: 'E12.1',
    name: 'person: medium skin tone, bald',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F9B2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB2',
    Version: 'E12.1',
    name: 'person: medium-dark skin tone, bald',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F9B2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB2',
    Version: 'E12.1',
    name: 'person: dark skin tone, bald',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC71\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman: blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC71\u200D\u2640',
    Version: 'E4.0',
    name: 'woman: blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman: light skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman: light skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman: medium-light skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman: medium-light skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman: medium skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman: medium skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman: medium-dark skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman: medium-dark skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman: dark skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman: dark skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC71\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man: blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC71\u200D\u2642',
    Version: 'E4.0',
    name: 'man: blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man: light skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man: light skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man: medium-light skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man: medium-light skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man: medium skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man: medium skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man: medium-dark skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man: medium-dark skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man: dark skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F471', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC71\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man: dark skin tone, blond hair',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D3'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD3',
    Version: 'E5.0',
    name: 'older person',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D3', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD3\uD83C\uDFFB',
    Version: 'E5.0',
    name: 'older person: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D3', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD3\uD83C\uDFFC',
    Version: 'E5.0',
    name: 'older person: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D3', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD3\uD83C\uDFFD',
    Version: 'E5.0',
    name: 'older person: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D3', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD3\uD83C\uDFFE',
    Version: 'E5.0',
    name: 'older person: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F9D3', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD3\uD83C\uDFFF',
    Version: 'E5.0',
    name: 'older person: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F474'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC74',
    Version: 'E0.6',
    name: 'old man',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F474', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC74\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'old man: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F474', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC74\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'old man: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F474', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC74\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'old man: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F474', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC74\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'old man: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F474', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC74\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'old man: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F475'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC75',
    Version: 'E0.6',
    name: 'old woman',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F475', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC75\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'old woman: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F475', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC75\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'old woman: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F475', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC75\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'old woman: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F475', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC75\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'old woman: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F475', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC75\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'old woman: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person'
  },
  {
    CodePointsHex: ['1F64D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4D',
    Version: 'E0.6',
    name: 'person frowning',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person frowning: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person frowning: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person frowning: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person frowning: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person frowning: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4D\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man frowning',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4D\u200D\u2642',
    Version: 'E4.0',
    name: 'man frowning',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man frowning: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man frowning: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man frowning: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man frowning: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man frowning: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man frowning: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man frowning: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man frowning: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man frowning: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man frowning: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4D\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman frowning',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4D\u200D\u2640',
    Version: 'E4.0',
    name: 'woman frowning',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman frowning: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman frowning: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman frowning: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman frowning: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman frowning: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman frowning: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman frowning: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman frowning: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman frowning: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64D', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4D\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman frowning: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4E',
    Version: 'E0.6',
    name: 'person pouting',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person pouting: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person pouting: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person pouting: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person pouting: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person pouting: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4E\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man pouting',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4E\u200D\u2642',
    Version: 'E4.0',
    name: 'man pouting',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man pouting: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man pouting: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man pouting: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man pouting: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man pouting: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man pouting: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man pouting: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man pouting: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man pouting: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man pouting: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4E\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman pouting',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4E\u200D\u2640',
    Version: 'E4.0',
    name: 'woman pouting',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman pouting: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman pouting: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman pouting: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman pouting: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman pouting: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman pouting: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman pouting: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman pouting: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman pouting: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64E', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4E\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman pouting: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE45',
    Version: 'E0.6',
    name: 'person gesturing NO',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person gesturing NO: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person gesturing NO: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person gesturing NO: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person gesturing NO: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person gesturing NO: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE45\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man gesturing NO',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE45\u200D\u2642',
    Version: 'E4.0',
    name: 'man gesturing NO',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man gesturing NO: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man gesturing NO: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man gesturing NO: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man gesturing NO: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man gesturing NO: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man gesturing NO: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man gesturing NO: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man gesturing NO: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man gesturing NO: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man gesturing NO: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE45\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman gesturing NO',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE45\u200D\u2640',
    Version: 'E4.0',
    name: 'woman gesturing NO',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman gesturing NO: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman gesturing NO: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman gesturing NO: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman gesturing NO: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman gesturing NO: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman gesturing NO: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman gesturing NO: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman gesturing NO: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman gesturing NO: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F645', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE45\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman gesturing NO: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE46',
    Version: 'E0.6',
    name: 'person gesturing OK',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person gesturing OK: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person gesturing OK: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person gesturing OK: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person gesturing OK: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person gesturing OK: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE46\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man gesturing OK',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE46\u200D\u2642',
    Version: 'E4.0',
    name: 'man gesturing OK',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man gesturing OK: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man gesturing OK: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man gesturing OK: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man gesturing OK: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man gesturing OK: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man gesturing OK: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man gesturing OK: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man gesturing OK: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man gesturing OK: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man gesturing OK: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE46\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman gesturing OK',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE46\u200D\u2640',
    Version: 'E4.0',
    name: 'woman gesturing OK',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman gesturing OK: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman gesturing OK: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman gesturing OK: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman gesturing OK: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman gesturing OK: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman gesturing OK: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman gesturing OK: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman gesturing OK: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman gesturing OK: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F646', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE46\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman gesturing OK: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC81',
    Version: 'E0.6',
    name: 'person tipping hand',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person tipping hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person tipping hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person tipping hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person tipping hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person tipping hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC81\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man tipping hand',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC81\u200D\u2642',
    Version: 'E4.0',
    name: 'man tipping hand',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man tipping hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man tipping hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man tipping hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man tipping hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man tipping hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man tipping hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man tipping hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man tipping hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man tipping hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man tipping hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC81\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman tipping hand',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC81\u200D\u2640',
    Version: 'E4.0',
    name: 'woman tipping hand',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman tipping hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman tipping hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman tipping hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman tipping hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman tipping hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman tipping hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman tipping hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman tipping hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman tipping hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F481', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC81\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman tipping hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4B',
    Version: 'E0.6',
    name: 'person raising hand',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person raising hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person raising hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person raising hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person raising hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person raising hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4B\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man raising hand',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4B\u200D\u2642',
    Version: 'E4.0',
    name: 'man raising hand',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man raising hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man raising hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man raising hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man raising hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man raising hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man raising hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man raising hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man raising hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man raising hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man raising hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4B\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman raising hand',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4B\u200D\u2640',
    Version: 'E4.0',
    name: 'woman raising hand',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman raising hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman raising hand: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman raising hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman raising hand: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman raising hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman raising hand: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman raising hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman raising hand: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman raising hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F64B', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE4B\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman raising hand: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCF',
    Version: 'E12.0',
    name: 'deaf person',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'deaf person: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'deaf person: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'deaf person: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFE',
    Version: 'E12.0',
    name: 'deaf person: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFF',
    Version: 'E12.0',
    name: 'deaf person: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCF\u200D\u2642\uFE0F',
    Version: 'E12.0',
    name: 'deaf man',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCF\u200D\u2642',
    Version: 'E12.0',
    name: 'deaf man',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E12.0',
    name: 'deaf man: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFB\u200D\u2642',
    Version: 'E12.0',
    name: 'deaf man: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E12.0',
    name: 'deaf man: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFC\u200D\u2642',
    Version: 'E12.0',
    name: 'deaf man: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E12.0',
    name: 'deaf man: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFD\u200D\u2642',
    Version: 'E12.0',
    name: 'deaf man: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E12.0',
    name: 'deaf man: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFE\u200D\u2642',
    Version: 'E12.0',
    name: 'deaf man: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E12.0',
    name: 'deaf man: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFF\u200D\u2642',
    Version: 'E12.0',
    name: 'deaf man: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCF\u200D\u2640\uFE0F',
    Version: 'E12.0',
    name: 'deaf woman',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCF\u200D\u2640',
    Version: 'E12.0',
    name: 'deaf woman',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E12.0',
    name: 'deaf woman: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFB\u200D\u2640',
    Version: 'E12.0',
    name: 'deaf woman: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E12.0',
    name: 'deaf woman: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFC\u200D\u2640',
    Version: 'E12.0',
    name: 'deaf woman: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E12.0',
    name: 'deaf woman: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFD\u200D\u2640',
    Version: 'E12.0',
    name: 'deaf woman: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E12.0',
    name: 'deaf woman: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFE\u200D\u2640',
    Version: 'E12.0',
    name: 'deaf woman: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E12.0',
    name: 'deaf woman: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9CF', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCF\uD83C\uDFFF\u200D\u2640',
    Version: 'E12.0',
    name: 'deaf woman: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE47',
    Version: 'E0.6',
    name: 'person bowing',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person bowing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person bowing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person bowing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person bowing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person bowing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE47\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man bowing',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE47\u200D\u2642',
    Version: 'E4.0',
    name: 'man bowing',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man bowing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man bowing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man bowing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man bowing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man bowing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man bowing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man bowing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man bowing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man bowing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man bowing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE47\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman bowing',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE47\u200D\u2640',
    Version: 'E4.0',
    name: 'woman bowing',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman bowing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman bowing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman bowing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman bowing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman bowing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman bowing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman bowing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman bowing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman bowing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F647', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDE47\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman bowing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD26',
    Version: 'E3.0',
    name: 'person facepalming',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFB',
    Version: 'E3.0',
    name: 'person facepalming: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFC',
    Version: 'E3.0',
    name: 'person facepalming: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFD',
    Version: 'E3.0',
    name: 'person facepalming: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFE',
    Version: 'E3.0',
    name: 'person facepalming: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFF',
    Version: 'E3.0',
    name: 'person facepalming: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD26\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man facepalming',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD26\u200D\u2642',
    Version: 'E4.0',
    name: 'man facepalming',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man facepalming: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man facepalming: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man facepalming: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man facepalming: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man facepalming: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man facepalming: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man facepalming: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man facepalming: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man facepalming: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man facepalming: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD26\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman facepalming',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD26\u200D\u2640',
    Version: 'E4.0',
    name: 'woman facepalming',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman facepalming: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman facepalming: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman facepalming: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman facepalming: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman facepalming: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman facepalming: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman facepalming: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman facepalming: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman facepalming: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F926', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD26\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman facepalming: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD37',
    Version: 'E3.0',
    name: 'person shrugging',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFB',
    Version: 'E3.0',
    name: 'person shrugging: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFC',
    Version: 'E3.0',
    name: 'person shrugging: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFD',
    Version: 'E3.0',
    name: 'person shrugging: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFE',
    Version: 'E3.0',
    name: 'person shrugging: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFF',
    Version: 'E3.0',
    name: 'person shrugging: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD37\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man shrugging',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD37\u200D\u2642',
    Version: 'E4.0',
    name: 'man shrugging',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man shrugging: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man shrugging: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man shrugging: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man shrugging: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man shrugging: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man shrugging: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man shrugging: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man shrugging: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man shrugging: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man shrugging: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD37\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman shrugging',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD37\u200D\u2640',
    Version: 'E4.0',
    name: 'woman shrugging',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman shrugging: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman shrugging: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman shrugging: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman shrugging: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman shrugging: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman shrugging: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman shrugging: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman shrugging: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman shrugging: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F937', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD37\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman shrugging: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-gesture'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\u2695\uFE0F',
    Version: 'E12.1',
    name: 'health worker',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '2695'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\u200D\u2695',
    Version: 'E12.1',
    name: 'health worker',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2695\uFE0F',
    Version: 'E12.1',
    name: 'health worker: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2695'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2695',
    Version: 'E12.1',
    name: 'health worker: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2695\uFE0F',
    Version: 'E12.1',
    name: 'health worker: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2695'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2695',
    Version: 'E12.1',
    name: 'health worker: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2695\uFE0F',
    Version: 'E12.1',
    name: 'health worker: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2695'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2695',
    Version: 'E12.1',
    name: 'health worker: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2695\uFE0F',
    Version: 'E12.1',
    name: 'health worker: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2695'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2695',
    Version: 'E12.1',
    name: 'health worker: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2695\uFE0F',
    Version: 'E12.1',
    name: 'health worker: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2695'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2695',
    Version: 'E12.1',
    name: 'health worker: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\u2695\uFE0F',
    Version: 'E4.0',
    name: 'man health worker',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '2695'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\u200D\u2695',
    Version: 'E4.0',
    name: 'man health worker',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2695\uFE0F',
    Version: 'E4.0',
    name: 'man health worker: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2695'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2695',
    Version: 'E4.0',
    name: 'man health worker: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2695\uFE0F',
    Version: 'E4.0',
    name: 'man health worker: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2695'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2695',
    Version: 'E4.0',
    name: 'man health worker: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2695\uFE0F',
    Version: 'E4.0',
    name: 'man health worker: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2695'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2695',
    Version: 'E4.0',
    name: 'man health worker: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2695\uFE0F',
    Version: 'E4.0',
    name: 'man health worker: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2695'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2695',
    Version: 'E4.0',
    name: 'man health worker: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2695\uFE0F',
    Version: 'E4.0',
    name: 'man health worker: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2695'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2695',
    Version: 'E4.0',
    name: 'man health worker: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\u2695\uFE0F',
    Version: 'E4.0',
    name: 'woman health worker',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '2695'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\u200D\u2695',
    Version: 'E4.0',
    name: 'woman health worker',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2695\uFE0F',
    Version: 'E4.0',
    name: 'woman health worker: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2695'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2695',
    Version: 'E4.0',
    name: 'woman health worker: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2695\uFE0F',
    Version: 'E4.0',
    name: 'woman health worker: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2695'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2695',
    Version: 'E4.0',
    name: 'woman health worker: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2695\uFE0F',
    Version: 'E4.0',
    name: 'woman health worker: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2695'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2695',
    Version: 'E4.0',
    name: 'woman health worker: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2695\uFE0F',
    Version: 'E4.0',
    name: 'woman health worker: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2695'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2695',
    Version: 'E4.0',
    name: 'woman health worker: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2695\uFE0F',
    Version: 'E4.0',
    name: 'woman health worker: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2695'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2695',
    Version: 'E4.0',
    name: 'woman health worker: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F393'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83C\uDF93',
    Version: 'E12.1',
    name: 'student',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F393'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF93',
    Version: 'E12.1',
    name: 'student: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F393'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF93',
    Version: 'E12.1',
    name: 'student: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F393'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF93',
    Version: 'E12.1',
    name: 'student: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F393'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF93',
    Version: 'E12.1',
    name: 'student: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F393'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF93',
    Version: 'E12.1',
    name: 'student: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F393'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83C\uDF93',
    Version: 'E4.0',
    name: 'man student',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F393'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF93',
    Version: 'E4.0',
    name: 'man student: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F393'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF93',
    Version: 'E4.0',
    name: 'man student: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F393'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF93',
    Version: 'E4.0',
    name: 'man student: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F393'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF93',
    Version: 'E4.0',
    name: 'man student: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F393'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF93',
    Version: 'E4.0',
    name: 'man student: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F393'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83C\uDF93',
    Version: 'E4.0',
    name: 'woman student',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F393'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF93',
    Version: 'E4.0',
    name: 'woman student: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F393'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF93',
    Version: 'E4.0',
    name: 'woman student: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F393'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF93',
    Version: 'E4.0',
    name: 'woman student: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F393'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF93',
    Version: 'E4.0',
    name: 'woman student: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F393'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF93',
    Version: 'E4.0',
    name: 'woman student: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83C\uDFEB',
    Version: 'E12.1',
    name: 'teacher',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFEB',
    Version: 'E12.1',
    name: 'teacher: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFEB',
    Version: 'E12.1',
    name: 'teacher: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFEB',
    Version: 'E12.1',
    name: 'teacher: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFEB',
    Version: 'E12.1',
    name: 'teacher: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFEB',
    Version: 'E12.1',
    name: 'teacher: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83C\uDFEB',
    Version: 'E4.0',
    name: 'man teacher',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFEB',
    Version: 'E4.0',
    name: 'man teacher: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFEB',
    Version: 'E4.0',
    name: 'man teacher: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFEB',
    Version: 'E4.0',
    name: 'man teacher: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFEB',
    Version: 'E4.0',
    name: 'man teacher: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFEB',
    Version: 'E4.0',
    name: 'man teacher: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83C\uDFEB',
    Version: 'E4.0',
    name: 'woman teacher',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFEB',
    Version: 'E4.0',
    name: 'woman teacher: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFEB',
    Version: 'E4.0',
    name: 'woman teacher: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFEB',
    Version: 'E4.0',
    name: 'woman teacher: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFEB',
    Version: 'E4.0',
    name: 'woman teacher: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFEB',
    Version: 'E4.0',
    name: 'woman teacher: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\u2696\uFE0F',
    Version: 'E12.1',
    name: 'judge',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '2696'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\u200D\u2696',
    Version: 'E12.1',
    name: 'judge',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2696\uFE0F',
    Version: 'E12.1',
    name: 'judge: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2696'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2696',
    Version: 'E12.1',
    name: 'judge: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2696\uFE0F',
    Version: 'E12.1',
    name: 'judge: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2696'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2696',
    Version: 'E12.1',
    name: 'judge: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2696\uFE0F',
    Version: 'E12.1',
    name: 'judge: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2696'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2696',
    Version: 'E12.1',
    name: 'judge: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2696\uFE0F',
    Version: 'E12.1',
    name: 'judge: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2696'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2696',
    Version: 'E12.1',
    name: 'judge: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2696\uFE0F',
    Version: 'E12.1',
    name: 'judge: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2696'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2696',
    Version: 'E12.1',
    name: 'judge: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\u2696\uFE0F',
    Version: 'E4.0',
    name: 'man judge',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '2696'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\u200D\u2696',
    Version: 'E4.0',
    name: 'man judge',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2696\uFE0F',
    Version: 'E4.0',
    name: 'man judge: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2696'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2696',
    Version: 'E4.0',
    name: 'man judge: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2696\uFE0F',
    Version: 'E4.0',
    name: 'man judge: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2696'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2696',
    Version: 'E4.0',
    name: 'man judge: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2696\uFE0F',
    Version: 'E4.0',
    name: 'man judge: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2696'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2696',
    Version: 'E4.0',
    name: 'man judge: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2696\uFE0F',
    Version: 'E4.0',
    name: 'man judge: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2696'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2696',
    Version: 'E4.0',
    name: 'man judge: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2696\uFE0F',
    Version: 'E4.0',
    name: 'man judge: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2696'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2696',
    Version: 'E4.0',
    name: 'man judge: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\u2696\uFE0F',
    Version: 'E4.0',
    name: 'woman judge',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '2696'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\u200D\u2696',
    Version: 'E4.0',
    name: 'woman judge',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2696\uFE0F',
    Version: 'E4.0',
    name: 'woman judge: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2696'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2696',
    Version: 'E4.0',
    name: 'woman judge: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2696\uFE0F',
    Version: 'E4.0',
    name: 'woman judge: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2696'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2696',
    Version: 'E4.0',
    name: 'woman judge: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2696\uFE0F',
    Version: 'E4.0',
    name: 'woman judge: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2696'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2696',
    Version: 'E4.0',
    name: 'woman judge: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2696\uFE0F',
    Version: 'E4.0',
    name: 'woman judge: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2696'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2696',
    Version: 'E4.0',
    name: 'woman judge: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2696\uFE0F',
    Version: 'E4.0',
    name: 'woman judge: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2696'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2696',
    Version: 'E4.0',
    name: 'woman judge: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F33E'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83C\uDF3E',
    Version: 'E12.1',
    name: 'farmer',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F33E'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF3E',
    Version: 'E12.1',
    name: 'farmer: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F33E'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF3E',
    Version: 'E12.1',
    name: 'farmer: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F33E'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF3E',
    Version: 'E12.1',
    name: 'farmer: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F33E'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF3E',
    Version: 'E12.1',
    name: 'farmer: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F33E'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF3E',
    Version: 'E12.1',
    name: 'farmer: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F33E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83C\uDF3E',
    Version: 'E4.0',
    name: 'man farmer',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F33E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF3E',
    Version: 'E4.0',
    name: 'man farmer: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F33E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF3E',
    Version: 'E4.0',
    name: 'man farmer: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F33E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF3E',
    Version: 'E4.0',
    name: 'man farmer: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F33E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF3E',
    Version: 'E4.0',
    name: 'man farmer: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F33E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF3E',
    Version: 'E4.0',
    name: 'man farmer: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F33E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83C\uDF3E',
    Version: 'E4.0',
    name: 'woman farmer',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F33E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF3E',
    Version: 'E4.0',
    name: 'woman farmer: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F33E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF3E',
    Version: 'E4.0',
    name: 'woman farmer: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F33E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF3E',
    Version: 'E4.0',
    name: 'woman farmer: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F33E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF3E',
    Version: 'E4.0',
    name: 'woman farmer: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F33E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF3E',
    Version: 'E4.0',
    name: 'woman farmer: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F373'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83C\uDF73',
    Version: 'E12.1',
    name: 'cook',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F373'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF73',
    Version: 'E12.1',
    name: 'cook: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F373'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF73',
    Version: 'E12.1',
    name: 'cook: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F373'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF73',
    Version: 'E12.1',
    name: 'cook: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F373'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF73',
    Version: 'E12.1',
    name: 'cook: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F373'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF73',
    Version: 'E12.1',
    name: 'cook: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F373'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83C\uDF73',
    Version: 'E4.0',
    name: 'man cook',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F373'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF73',
    Version: 'E4.0',
    name: 'man cook: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F373'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF73',
    Version: 'E4.0',
    name: 'man cook: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F373'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF73',
    Version: 'E4.0',
    name: 'man cook: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F373'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF73',
    Version: 'E4.0',
    name: 'man cook: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F373'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF73',
    Version: 'E4.0',
    name: 'man cook: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F373'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83C\uDF73',
    Version: 'E4.0',
    name: 'woman cook',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F373'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF73',
    Version: 'E4.0',
    name: 'woman cook: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F373'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF73',
    Version: 'E4.0',
    name: 'woman cook: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F373'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF73',
    Version: 'E4.0',
    name: 'woman cook: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F373'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF73',
    Version: 'E4.0',
    name: 'woman cook: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F373'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF73',
    Version: 'E4.0',
    name: 'woman cook: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F527'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83D\uDD27',
    Version: 'E12.1',
    name: 'mechanic',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F527'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDD27',
    Version: 'E12.1',
    name: 'mechanic: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F527'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDD27',
    Version: 'E12.1',
    name: 'mechanic: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F527'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDD27',
    Version: 'E12.1',
    name: 'mechanic: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F527'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDD27',
    Version: 'E12.1',
    name: 'mechanic: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F527'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDD27',
    Version: 'E12.1',
    name: 'mechanic: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F527'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDD27',
    Version: 'E4.0',
    name: 'man mechanic',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F527'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDD27',
    Version: 'E4.0',
    name: 'man mechanic: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F527'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDD27',
    Version: 'E4.0',
    name: 'man mechanic: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F527'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDD27',
    Version: 'E4.0',
    name: 'man mechanic: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F527'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDD27',
    Version: 'E4.0',
    name: 'man mechanic: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F527'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDD27',
    Version: 'E4.0',
    name: 'man mechanic: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F527'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83D\uDD27',
    Version: 'E4.0',
    name: 'woman mechanic',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F527'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDD27',
    Version: 'E4.0',
    name: 'woman mechanic: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F527'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDD27',
    Version: 'E4.0',
    name: 'woman mechanic: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F527'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDD27',
    Version: 'E4.0',
    name: 'woman mechanic: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F527'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDD27',
    Version: 'E4.0',
    name: 'woman mechanic: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F527'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDD27',
    Version: 'E4.0',
    name: 'woman mechanic: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83C\uDFED',
    Version: 'E12.1',
    name: 'factory worker',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFED',
    Version: 'E12.1',
    name: 'factory worker: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFED',
    Version: 'E12.1',
    name: 'factory worker: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFED',
    Version: 'E12.1',
    name: 'factory worker: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFED',
    Version: 'E12.1',
    name: 'factory worker: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFED',
    Version: 'E12.1',
    name: 'factory worker: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83C\uDFED',
    Version: 'E4.0',
    name: 'man factory worker',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFED',
    Version: 'E4.0',
    name: 'man factory worker: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFED',
    Version: 'E4.0',
    name: 'man factory worker: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFED',
    Version: 'E4.0',
    name: 'man factory worker: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFED',
    Version: 'E4.0',
    name: 'man factory worker: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFED',
    Version: 'E4.0',
    name: 'man factory worker: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83C\uDFED',
    Version: 'E4.0',
    name: 'woman factory worker',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFED',
    Version: 'E4.0',
    name: 'woman factory worker: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFED',
    Version: 'E4.0',
    name: 'woman factory worker: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFED',
    Version: 'E4.0',
    name: 'woman factory worker: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFED',
    Version: 'E4.0',
    name: 'woman factory worker: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFED',
    Version: 'E4.0',
    name: 'woman factory worker: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83D\uDCBC',
    Version: 'E12.1',
    name: 'office worker',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDCBC',
    Version: 'E12.1',
    name: 'office worker: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDCBC',
    Version: 'E12.1',
    name: 'office worker: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDCBC',
    Version: 'E12.1',
    name: 'office worker: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDCBC',
    Version: 'E12.1',
    name: 'office worker: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDCBC',
    Version: 'E12.1',
    name: 'office worker: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDCBC',
    Version: 'E4.0',
    name: 'man office worker',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDCBC',
    Version: 'E4.0',
    name: 'man office worker: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDCBC',
    Version: 'E4.0',
    name: 'man office worker: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDCBC',
    Version: 'E4.0',
    name: 'man office worker: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDCBC',
    Version: 'E4.0',
    name: 'man office worker: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDCBC',
    Version: 'E4.0',
    name: 'man office worker: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83D\uDCBC',
    Version: 'E4.0',
    name: 'woman office worker',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDCBC',
    Version: 'E4.0',
    name: 'woman office worker: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDCBC',
    Version: 'E4.0',
    name: 'woman office worker: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDCBC',
    Version: 'E4.0',
    name: 'woman office worker: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDCBC',
    Version: 'E4.0',
    name: 'woman office worker: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDCBC',
    Version: 'E4.0',
    name: 'woman office worker: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F52C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83D\uDD2C',
    Version: 'E12.1',
    name: 'scientist',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F52C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDD2C',
    Version: 'E12.1',
    name: 'scientist: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F52C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDD2C',
    Version: 'E12.1',
    name: 'scientist: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F52C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDD2C',
    Version: 'E12.1',
    name: 'scientist: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F52C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDD2C',
    Version: 'E12.1',
    name: 'scientist: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F52C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDD2C',
    Version: 'E12.1',
    name: 'scientist: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F52C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDD2C',
    Version: 'E4.0',
    name: 'man scientist',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F52C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDD2C',
    Version: 'E4.0',
    name: 'man scientist: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F52C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDD2C',
    Version: 'E4.0',
    name: 'man scientist: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F52C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDD2C',
    Version: 'E4.0',
    name: 'man scientist: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F52C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDD2C',
    Version: 'E4.0',
    name: 'man scientist: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F52C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDD2C',
    Version: 'E4.0',
    name: 'man scientist: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F52C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83D\uDD2C',
    Version: 'E4.0',
    name: 'woman scientist',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F52C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDD2C',
    Version: 'E4.0',
    name: 'woman scientist: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F52C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDD2C',
    Version: 'E4.0',
    name: 'woman scientist: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F52C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDD2C',
    Version: 'E4.0',
    name: 'woman scientist: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F52C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDD2C',
    Version: 'E4.0',
    name: 'woman scientist: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F52C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDD2C',
    Version: 'E4.0',
    name: 'woman scientist: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83D\uDCBB',
    Version: 'E12.1',
    name: 'technologist',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDCBB',
    Version: 'E12.1',
    name: 'technologist: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDCBB',
    Version: 'E12.1',
    name: 'technologist: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDCBB',
    Version: 'E12.1',
    name: 'technologist: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDCBB',
    Version: 'E12.1',
    name: 'technologist: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDCBB',
    Version: 'E12.1',
    name: 'technologist: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDCBB',
    Version: 'E4.0',
    name: 'man technologist',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDCBB',
    Version: 'E4.0',
    name: 'man technologist: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDCBB',
    Version: 'E4.0',
    name: 'man technologist: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDCBB',
    Version: 'E4.0',
    name: 'man technologist: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDCBB',
    Version: 'E4.0',
    name: 'man technologist: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDCBB',
    Version: 'E4.0',
    name: 'man technologist: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83D\uDCBB',
    Version: 'E4.0',
    name: 'woman technologist',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDCBB',
    Version: 'E4.0',
    name: 'woman technologist: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDCBB',
    Version: 'E4.0',
    name: 'woman technologist: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDCBB',
    Version: 'E4.0',
    name: 'woman technologist: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDCBB',
    Version: 'E4.0',
    name: 'woman technologist: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDCBB',
    Version: 'E4.0',
    name: 'woman technologist: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83C\uDFA4',
    Version: 'E12.1',
    name: 'singer',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFA4',
    Version: 'E12.1',
    name: 'singer: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFA4',
    Version: 'E12.1',
    name: 'singer: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFA4',
    Version: 'E12.1',
    name: 'singer: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFA4',
    Version: 'E12.1',
    name: 'singer: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFA4',
    Version: 'E12.1',
    name: 'singer: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83C\uDFA4',
    Version: 'E4.0',
    name: 'man singer',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFA4',
    Version: 'E4.0',
    name: 'man singer: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFA4',
    Version: 'E4.0',
    name: 'man singer: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFA4',
    Version: 'E4.0',
    name: 'man singer: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFA4',
    Version: 'E4.0',
    name: 'man singer: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFA4',
    Version: 'E4.0',
    name: 'man singer: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83C\uDFA4',
    Version: 'E4.0',
    name: 'woman singer',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFA4',
    Version: 'E4.0',
    name: 'woman singer: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFA4',
    Version: 'E4.0',
    name: 'woman singer: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFA4',
    Version: 'E4.0',
    name: 'woman singer: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFA4',
    Version: 'E4.0',
    name: 'woman singer: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFA4',
    Version: 'E4.0',
    name: 'woman singer: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83C\uDFA8',
    Version: 'E12.1',
    name: 'artist',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFA8',
    Version: 'E12.1',
    name: 'artist: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFA8',
    Version: 'E12.1',
    name: 'artist: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFA8',
    Version: 'E12.1',
    name: 'artist: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFA8',
    Version: 'E12.1',
    name: 'artist: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFA8',
    Version: 'E12.1',
    name: 'artist: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83C\uDFA8',
    Version: 'E4.0',
    name: 'man artist',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFA8',
    Version: 'E4.0',
    name: 'man artist: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFA8',
    Version: 'E4.0',
    name: 'man artist: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFA8',
    Version: 'E4.0',
    name: 'man artist: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFA8',
    Version: 'E4.0',
    name: 'man artist: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFA8',
    Version: 'E4.0',
    name: 'man artist: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83C\uDFA8',
    Version: 'E4.0',
    name: 'woman artist',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFA8',
    Version: 'E4.0',
    name: 'woman artist: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFA8',
    Version: 'E4.0',
    name: 'woman artist: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFA8',
    Version: 'E4.0',
    name: 'woman artist: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFA8',
    Version: 'E4.0',
    name: 'woman artist: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFA8',
    Version: 'E4.0',
    name: 'woman artist: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\u2708\uFE0F',
    Version: 'E12.1',
    name: 'pilot',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '2708'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\u200D\u2708',
    Version: 'E12.1',
    name: 'pilot',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2708\uFE0F',
    Version: 'E12.1',
    name: 'pilot: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2708'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2708',
    Version: 'E12.1',
    name: 'pilot: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2708\uFE0F',
    Version: 'E12.1',
    name: 'pilot: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2708'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2708',
    Version: 'E12.1',
    name: 'pilot: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2708\uFE0F',
    Version: 'E12.1',
    name: 'pilot: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2708'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2708',
    Version: 'E12.1',
    name: 'pilot: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2708\uFE0F',
    Version: 'E12.1',
    name: 'pilot: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2708'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2708',
    Version: 'E12.1',
    name: 'pilot: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2708\uFE0F',
    Version: 'E12.1',
    name: 'pilot: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2708'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2708',
    Version: 'E12.1',
    name: 'pilot: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\u2708\uFE0F',
    Version: 'E4.0',
    name: 'man pilot',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '2708'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\u200D\u2708',
    Version: 'E4.0',
    name: 'man pilot',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2708\uFE0F',
    Version: 'E4.0',
    name: 'man pilot: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2708'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2708',
    Version: 'E4.0',
    name: 'man pilot: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2708\uFE0F',
    Version: 'E4.0',
    name: 'man pilot: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2708'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2708',
    Version: 'E4.0',
    name: 'man pilot: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2708\uFE0F',
    Version: 'E4.0',
    name: 'man pilot: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2708'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2708',
    Version: 'E4.0',
    name: 'man pilot: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2708\uFE0F',
    Version: 'E4.0',
    name: 'man pilot: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2708'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2708',
    Version: 'E4.0',
    name: 'man pilot: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2708\uFE0F',
    Version: 'E4.0',
    name: 'man pilot: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2708'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2708',
    Version: 'E4.0',
    name: 'man pilot: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\u2708\uFE0F',
    Version: 'E4.0',
    name: 'woman pilot',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '2708'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\u200D\u2708',
    Version: 'E4.0',
    name: 'woman pilot',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2708\uFE0F',
    Version: 'E4.0',
    name: 'woman pilot: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2708'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2708',
    Version: 'E4.0',
    name: 'woman pilot: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2708\uFE0F',
    Version: 'E4.0',
    name: 'woman pilot: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2708'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2708',
    Version: 'E4.0',
    name: 'woman pilot: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2708\uFE0F',
    Version: 'E4.0',
    name: 'woman pilot: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2708'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2708',
    Version: 'E4.0',
    name: 'woman pilot: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2708\uFE0F',
    Version: 'E4.0',
    name: 'woman pilot: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2708'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2708',
    Version: 'E4.0',
    name: 'woman pilot: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2708\uFE0F',
    Version: 'E4.0',
    name: 'woman pilot: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2708'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2708',
    Version: 'E4.0',
    name: 'woman pilot: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F680'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83D\uDE80',
    Version: 'E12.1',
    name: 'astronaut',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F680'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDE80',
    Version: 'E12.1',
    name: 'astronaut: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F680'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDE80',
    Version: 'E12.1',
    name: 'astronaut: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F680'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDE80',
    Version: 'E12.1',
    name: 'astronaut: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F680'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDE80',
    Version: 'E12.1',
    name: 'astronaut: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F680'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDE80',
    Version: 'E12.1',
    name: 'astronaut: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F680'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDE80',
    Version: 'E4.0',
    name: 'man astronaut',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F680'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDE80',
    Version: 'E4.0',
    name: 'man astronaut: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F680'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDE80',
    Version: 'E4.0',
    name: 'man astronaut: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F680'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDE80',
    Version: 'E4.0',
    name: 'man astronaut: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F680'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDE80',
    Version: 'E4.0',
    name: 'man astronaut: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F680'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDE80',
    Version: 'E4.0',
    name: 'man astronaut: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F680'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83D\uDE80',
    Version: 'E4.0',
    name: 'woman astronaut',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F680'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDE80',
    Version: 'E4.0',
    name: 'woman astronaut: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F680'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDE80',
    Version: 'E4.0',
    name: 'woman astronaut: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F680'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDE80',
    Version: 'E4.0',
    name: 'woman astronaut: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F680'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDE80',
    Version: 'E4.0',
    name: 'woman astronaut: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F680'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDE80',
    Version: 'E4.0',
    name: 'woman astronaut: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F692'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83D\uDE92',
    Version: 'E12.1',
    name: 'firefighter',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F692'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDE92',
    Version: 'E12.1',
    name: 'firefighter: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F692'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDE92',
    Version: 'E12.1',
    name: 'firefighter: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F692'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDE92',
    Version: 'E12.1',
    name: 'firefighter: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F692'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDE92',
    Version: 'E12.1',
    name: 'firefighter: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F692'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDE92',
    Version: 'E12.1',
    name: 'firefighter: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F692'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDE92',
    Version: 'E4.0',
    name: 'man firefighter',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F692'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDE92',
    Version: 'E4.0',
    name: 'man firefighter: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F692'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDE92',
    Version: 'E4.0',
    name: 'man firefighter: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F692'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDE92',
    Version: 'E4.0',
    name: 'man firefighter: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F692'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDE92',
    Version: 'E4.0',
    name: 'man firefighter: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F692'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDE92',
    Version: 'E4.0',
    name: 'man firefighter: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F692'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83D\uDE92',
    Version: 'E4.0',
    name: 'woman firefighter',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F692'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDE92',
    Version: 'E4.0',
    name: 'woman firefighter: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F692'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDE92',
    Version: 'E4.0',
    name: 'woman firefighter: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F692'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDE92',
    Version: 'E4.0',
    name: 'woman firefighter: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F692'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDE92',
    Version: 'E4.0',
    name: 'woman firefighter: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F692'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDE92',
    Version: 'E4.0',
    name: 'woman firefighter: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6E',
    Version: 'E0.6',
    name: 'police officer',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'police officer: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'police officer: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'police officer: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'police officer: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'police officer: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6E\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man police officer',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6E\u200D\u2642',
    Version: 'E4.0',
    name: 'man police officer',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man police officer: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man police officer: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man police officer: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man police officer: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man police officer: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man police officer: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man police officer: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man police officer: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man police officer: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man police officer: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6E\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman police officer',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6E\u200D\u2640',
    Version: 'E4.0',
    name: 'woman police officer',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman police officer: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman police officer: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman police officer: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman police officer: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman police officer: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman police officer: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman police officer: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman police officer: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman police officer: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F46E', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6E\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman police officer: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD75\uFE0F',
    Version: 'E0.7',
    name: 'detective',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575'],
    Status: 'unqualified',
    char: '\uD83D\uDD75',
    Version: 'E0.7',
    name: 'detective',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFB',
    Version: 'E2.0',
    name: 'detective: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFC',
    Version: 'E2.0',
    name: 'detective: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFD',
    Version: 'E2.0',
    name: 'detective: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFE',
    Version: 'E2.0',
    name: 'detective: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFF',
    Version: 'E2.0',
    name: 'detective: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', 'FE0F', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man detective',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '200D', '2642', 'FE0F'],
    Status: 'unqualified',
    char: '\uD83D\uDD75\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man detective',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', 'FE0F', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDD75\uFE0F\u200D\u2642',
    Version: 'E4.0',
    name: 'man detective',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '200D', '2642'],
    Status: 'unqualified',
    char: '\uD83D\uDD75\u200D\u2642',
    Version: 'E4.0',
    name: 'man detective',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man detective: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man detective: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man detective: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man detective: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man detective: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man detective: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man detective: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man detective: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man detective: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man detective: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', 'FE0F', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman detective',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '200D', '2640', 'FE0F'],
    Status: 'unqualified',
    char: '\uD83D\uDD75\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman detective',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', 'FE0F', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDD75\uFE0F\u200D\u2640',
    Version: 'E4.0',
    name: 'woman detective',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '200D', '2640'],
    Status: 'unqualified',
    char: '\uD83D\uDD75\u200D\u2640',
    Version: 'E4.0',
    name: 'woman detective',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman detective: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman detective: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman detective: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman detective: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman detective: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman detective: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman detective: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman detective: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman detective: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F575', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDD75\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman detective: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC82',
    Version: 'E0.6',
    name: 'guard',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'guard: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'guard: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'guard: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'guard: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'guard: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC82\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man guard',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC82\u200D\u2642',
    Version: 'E4.0',
    name: 'man guard',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man guard: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man guard: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man guard: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man guard: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man guard: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man guard: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man guard: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man guard: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man guard: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man guard: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC82\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman guard',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC82\u200D\u2640',
    Version: 'E4.0',
    name: 'woman guard',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman guard: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman guard: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman guard: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman guard: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman guard: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman guard: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman guard: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman guard: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman guard: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F482', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC82\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman guard: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F977'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD77',
    Version: 'E13.0',
    name: 'ninja',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F977', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD77\uD83C\uDFFB',
    Version: 'E13.0',
    name: 'ninja: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F977', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD77\uD83C\uDFFC',
    Version: 'E13.0',
    name: 'ninja: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F977', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD77\uD83C\uDFFD',
    Version: 'E13.0',
    name: 'ninja: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F977', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD77\uD83C\uDFFE',
    Version: 'E13.0',
    name: 'ninja: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F977', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD77\uD83C\uDFFF',
    Version: 'E13.0',
    name: 'ninja: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC77',
    Version: 'E0.6',
    name: 'construction worker',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'construction worker: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'construction worker: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'construction worker: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'construction worker: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'construction worker: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC77\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man construction worker',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC77\u200D\u2642',
    Version: 'E4.0',
    name: 'man construction worker',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man construction worker: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man construction worker: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man construction worker: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man construction worker: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man construction worker: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man construction worker: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man construction worker: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man construction worker: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man construction worker: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man construction worker: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC77\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman construction worker',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC77\u200D\u2640',
    Version: 'E4.0',
    name: 'woman construction worker',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman construction worker: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman construction worker: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman construction worker: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman construction worker: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman construction worker: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman construction worker: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman construction worker: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman construction worker: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman construction worker: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F477', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC77\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman construction worker: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1FAC5'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC5',
    Version: 'E14.0',
    name: 'person with crown',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1FAC5', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC5\uD83C\uDFFB',
    Version: 'E14.0',
    name: 'person with crown: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1FAC5', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC5\uD83C\uDFFC',
    Version: 'E14.0',
    name: 'person with crown: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1FAC5', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC5\uD83C\uDFFD',
    Version: 'E14.0',
    name: 'person with crown: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1FAC5', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC5\uD83C\uDFFE',
    Version: 'E14.0',
    name: 'person with crown: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1FAC5', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC5\uD83C\uDFFF',
    Version: 'E14.0',
    name: 'person with crown: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F934'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD34',
    Version: 'E3.0',
    name: 'prince',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F934', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD34\uD83C\uDFFB',
    Version: 'E3.0',
    name: 'prince: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F934', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD34\uD83C\uDFFC',
    Version: 'E3.0',
    name: 'prince: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F934', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD34\uD83C\uDFFD',
    Version: 'E3.0',
    name: 'prince: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F934', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD34\uD83C\uDFFE',
    Version: 'E3.0',
    name: 'prince: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F934', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD34\uD83C\uDFFF',
    Version: 'E3.0',
    name: 'prince: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F478'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC78',
    Version: 'E0.6',
    name: 'princess',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F478', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC78\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'princess: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F478', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC78\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'princess: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F478', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC78\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'princess: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F478', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC78\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'princess: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F478', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC78\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'princess: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC73',
    Version: 'E0.6',
    name: 'person wearing turban',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person wearing turban: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person wearing turban: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person wearing turban: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person wearing turban: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person wearing turban: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC73\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man wearing turban',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC73\u200D\u2642',
    Version: 'E4.0',
    name: 'man wearing turban',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man wearing turban: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man wearing turban: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man wearing turban: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man wearing turban: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man wearing turban: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man wearing turban: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man wearing turban: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man wearing turban: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man wearing turban: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man wearing turban: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC73\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman wearing turban',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC73\u200D\u2640',
    Version: 'E4.0',
    name: 'woman wearing turban',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman wearing turban: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman wearing turban: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman wearing turban: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman wearing turban: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman wearing turban: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman wearing turban: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman wearing turban: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman wearing turban: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman wearing turban: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F473', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC73\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman wearing turban: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F472'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC72',
    Version: 'E0.6',
    name: 'person with skullcap',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F472', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC72\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person with skullcap: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F472', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC72\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person with skullcap: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F472', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC72\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person with skullcap: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F472', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC72\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person with skullcap: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F472', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC72\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person with skullcap: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D5'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD5',
    Version: 'E5.0',
    name: 'woman with headscarf',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D5', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD5\uD83C\uDFFB',
    Version: 'E5.0',
    name: 'woman with headscarf: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D5', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD5\uD83C\uDFFC',
    Version: 'E5.0',
    name: 'woman with headscarf: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D5', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD5\uD83C\uDFFD',
    Version: 'E5.0',
    name: 'woman with headscarf: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D5', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD5\uD83C\uDFFE',
    Version: 'E5.0',
    name: 'woman with headscarf: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D5', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD5\uD83C\uDFFF',
    Version: 'E5.0',
    name: 'woman with headscarf: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD35',
    Version: 'E3.0',
    name: 'person in tuxedo',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFB',
    Version: 'E3.0',
    name: 'person in tuxedo: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFC',
    Version: 'E3.0',
    name: 'person in tuxedo: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFD',
    Version: 'E3.0',
    name: 'person in tuxedo: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFE',
    Version: 'E3.0',
    name: 'person in tuxedo: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFF',
    Version: 'E3.0',
    name: 'person in tuxedo: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD35\u200D\u2642\uFE0F',
    Version: 'E13.0',
    name: 'man in tuxedo',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD35\u200D\u2642',
    Version: 'E13.0',
    name: 'man in tuxedo',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E13.0',
    name: 'man in tuxedo: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFB\u200D\u2642',
    Version: 'E13.0',
    name: 'man in tuxedo: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E13.0',
    name: 'man in tuxedo: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFC\u200D\u2642',
    Version: 'E13.0',
    name: 'man in tuxedo: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E13.0',
    name: 'man in tuxedo: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFD\u200D\u2642',
    Version: 'E13.0',
    name: 'man in tuxedo: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E13.0',
    name: 'man in tuxedo: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFE\u200D\u2642',
    Version: 'E13.0',
    name: 'man in tuxedo: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E13.0',
    name: 'man in tuxedo: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFF\u200D\u2642',
    Version: 'E13.0',
    name: 'man in tuxedo: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD35\u200D\u2640\uFE0F',
    Version: 'E13.0',
    name: 'woman in tuxedo',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD35\u200D\u2640',
    Version: 'E13.0',
    name: 'woman in tuxedo',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E13.0',
    name: 'woman in tuxedo: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFB\u200D\u2640',
    Version: 'E13.0',
    name: 'woman in tuxedo: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E13.0',
    name: 'woman in tuxedo: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFC\u200D\u2640',
    Version: 'E13.0',
    name: 'woman in tuxedo: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E13.0',
    name: 'woman in tuxedo: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFD\u200D\u2640',
    Version: 'E13.0',
    name: 'woman in tuxedo: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E13.0',
    name: 'woman in tuxedo: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFE\u200D\u2640',
    Version: 'E13.0',
    name: 'woman in tuxedo: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E13.0',
    name: 'woman in tuxedo: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F935', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD35\uD83C\uDFFF\u200D\u2640',
    Version: 'E13.0',
    name: 'woman in tuxedo: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC70',
    Version: 'E0.6',
    name: 'person with veil',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person with veil: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person with veil: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person with veil: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person with veil: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person with veil: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC70\u200D\u2642\uFE0F',
    Version: 'E13.0',
    name: 'man with veil',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC70\u200D\u2642',
    Version: 'E13.0',
    name: 'man with veil',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E13.0',
    name: 'man with veil: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFB\u200D\u2642',
    Version: 'E13.0',
    name: 'man with veil: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E13.0',
    name: 'man with veil: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFC\u200D\u2642',
    Version: 'E13.0',
    name: 'man with veil: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E13.0',
    name: 'man with veil: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFD\u200D\u2642',
    Version: 'E13.0',
    name: 'man with veil: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E13.0',
    name: 'man with veil: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFE\u200D\u2642',
    Version: 'E13.0',
    name: 'man with veil: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E13.0',
    name: 'man with veil: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFF\u200D\u2642',
    Version: 'E13.0',
    name: 'man with veil: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC70\u200D\u2640\uFE0F',
    Version: 'E13.0',
    name: 'woman with veil',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC70\u200D\u2640',
    Version: 'E13.0',
    name: 'woman with veil',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E13.0',
    name: 'woman with veil: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFB\u200D\u2640',
    Version: 'E13.0',
    name: 'woman with veil: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E13.0',
    name: 'woman with veil: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFC\u200D\u2640',
    Version: 'E13.0',
    name: 'woman with veil: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E13.0',
    name: 'woman with veil: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFD\u200D\u2640',
    Version: 'E13.0',
    name: 'woman with veil: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E13.0',
    name: 'woman with veil: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFE\u200D\u2640',
    Version: 'E13.0',
    name: 'woman with veil: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E13.0',
    name: 'woman with veil: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F470', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC70\uD83C\uDFFF\u200D\u2640',
    Version: 'E13.0',
    name: 'woman with veil: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F930'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD30',
    Version: 'E3.0',
    name: 'pregnant woman',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F930', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD30\uD83C\uDFFB',
    Version: 'E3.0',
    name: 'pregnant woman: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F930', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD30\uD83C\uDFFC',
    Version: 'E3.0',
    name: 'pregnant woman: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F930', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD30\uD83C\uDFFD',
    Version: 'E3.0',
    name: 'pregnant woman: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F930', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD30\uD83C\uDFFE',
    Version: 'E3.0',
    name: 'pregnant woman: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F930', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD30\uD83C\uDFFF',
    Version: 'E3.0',
    name: 'pregnant woman: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1FAC3'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC3',
    Version: 'E14.0',
    name: 'pregnant man',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1FAC3', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC3\uD83C\uDFFB',
    Version: 'E14.0',
    name: 'pregnant man: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1FAC3', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC3\uD83C\uDFFC',
    Version: 'E14.0',
    name: 'pregnant man: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1FAC3', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC3\uD83C\uDFFD',
    Version: 'E14.0',
    name: 'pregnant man: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1FAC3', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC3\uD83C\uDFFE',
    Version: 'E14.0',
    name: 'pregnant man: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1FAC3', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC3\uD83C\uDFFF',
    Version: 'E14.0',
    name: 'pregnant man: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1FAC4'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC4',
    Version: 'E14.0',
    name: 'pregnant person',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1FAC4', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC4\uD83C\uDFFB',
    Version: 'E14.0',
    name: 'pregnant person: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1FAC4', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC4\uD83C\uDFFC',
    Version: 'E14.0',
    name: 'pregnant person: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1FAC4', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC4\uD83C\uDFFD',
    Version: 'E14.0',
    name: 'pregnant person: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1FAC4', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC4\uD83C\uDFFE',
    Version: 'E14.0',
    name: 'pregnant person: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1FAC4', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC4\uD83C\uDFFF',
    Version: 'E14.0',
    name: 'pregnant person: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F931'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD31',
    Version: 'E5.0',
    name: 'breast-feeding',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F931', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD31\uD83C\uDFFB',
    Version: 'E5.0',
    name: 'breast-feeding: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F931', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD31\uD83C\uDFFC',
    Version: 'E5.0',
    name: 'breast-feeding: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F931', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD31\uD83C\uDFFD',
    Version: 'E5.0',
    name: 'breast-feeding: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F931', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD31\uD83C\uDFFE',
    Version: 'E5.0',
    name: 'breast-feeding: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F931', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD31\uD83C\uDFFF',
    Version: 'E5.0',
    name: 'breast-feeding: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F37C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83C\uDF7C',
    Version: 'E13.0',
    name: 'woman feeding baby',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F37C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF7C',
    Version: 'E13.0',
    name: 'woman feeding baby: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F37C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF7C',
    Version: 'E13.0',
    name: 'woman feeding baby: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F37C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF7C',
    Version: 'E13.0',
    name: 'woman feeding baby: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F37C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF7C',
    Version: 'E13.0',
    name: 'woman feeding baby: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F37C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF7C',
    Version: 'E13.0',
    name: 'woman feeding baby: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F37C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83C\uDF7C',
    Version: 'E13.0',
    name: 'man feeding baby',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F37C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF7C',
    Version: 'E13.0',
    name: 'man feeding baby: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F37C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF7C',
    Version: 'E13.0',
    name: 'man feeding baby: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F37C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF7C',
    Version: 'E13.0',
    name: 'man feeding baby: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F37C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF7C',
    Version: 'E13.0',
    name: 'man feeding baby: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F37C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF7C',
    Version: 'E13.0',
    name: 'man feeding baby: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F37C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83C\uDF7C',
    Version: 'E13.0',
    name: 'person feeding baby',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F37C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF7C',
    Version: 'E13.0',
    name: 'person feeding baby: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F37C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF7C',
    Version: 'E13.0',
    name: 'person feeding baby: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F37C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF7C',
    Version: 'E13.0',
    name: 'person feeding baby: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F37C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF7C',
    Version: 'E13.0',
    name: 'person feeding baby: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F37C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF7C',
    Version: 'E13.0',
    name: 'person feeding baby: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-role'
  },
  {
    CodePointsHex: ['1F47C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC7C',
    Version: 'E0.6',
    name: 'baby angel',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F47C', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC7C\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'baby angel: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F47C', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC7C\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'baby angel: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F47C', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC7C\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'baby angel: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F47C', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC7C\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'baby angel: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F47C', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC7C\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'baby angel: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F385'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF85',
    Version: 'E0.6',
    name: 'Santa Claus',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F385', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF85\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'Santa Claus: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F385', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF85\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'Santa Claus: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F385', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF85\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'Santa Claus: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F385', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF85\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'Santa Claus: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F385', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF85\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'Santa Claus: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F936'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD36',
    Version: 'E3.0',
    name: 'Mrs. Claus',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F936', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD36\uD83C\uDFFB',
    Version: 'E3.0',
    name: 'Mrs. Claus: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F936', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD36\uD83C\uDFFC',
    Version: 'E3.0',
    name: 'Mrs. Claus: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F936', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD36\uD83C\uDFFD',
    Version: 'E3.0',
    name: 'Mrs. Claus: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F936', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD36\uD83C\uDFFE',
    Version: 'E3.0',
    name: 'Mrs. Claus: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F936', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD36\uD83C\uDFFF',
    Version: 'E3.0',
    name: 'Mrs. Claus: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F384'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83C\uDF84',
    Version: 'E13.0',
    name: 'Mx Claus',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F384'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF84',
    Version: 'E13.0',
    name: 'Mx Claus: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F384'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF84',
    Version: 'E13.0',
    name: 'Mx Claus: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F384'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF84',
    Version: 'E13.0',
    name: 'Mx Claus: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F384'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF84',
    Version: 'E13.0',
    name: 'Mx Claus: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F384'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF84',
    Version: 'E13.0',
    name: 'Mx Claus: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB8',
    Version: 'E11.0',
    name: 'superhero',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFB',
    Version: 'E11.0',
    name: 'superhero: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFC',
    Version: 'E11.0',
    name: 'superhero: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFD',
    Version: 'E11.0',
    name: 'superhero: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFE',
    Version: 'E11.0',
    name: 'superhero: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFF',
    Version: 'E11.0',
    name: 'superhero: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB8\u200D\u2642\uFE0F',
    Version: 'E11.0',
    name: 'man superhero',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB8\u200D\u2642',
    Version: 'E11.0',
    name: 'man superhero',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E11.0',
    name: 'man superhero: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFB\u200D\u2642',
    Version: 'E11.0',
    name: 'man superhero: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E11.0',
    name: 'man superhero: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFC\u200D\u2642',
    Version: 'E11.0',
    name: 'man superhero: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E11.0',
    name: 'man superhero: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFD\u200D\u2642',
    Version: 'E11.0',
    name: 'man superhero: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E11.0',
    name: 'man superhero: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFE\u200D\u2642',
    Version: 'E11.0',
    name: 'man superhero: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E11.0',
    name: 'man superhero: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFF\u200D\u2642',
    Version: 'E11.0',
    name: 'man superhero: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB8\u200D\u2640\uFE0F',
    Version: 'E11.0',
    name: 'woman superhero',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB8\u200D\u2640',
    Version: 'E11.0',
    name: 'woman superhero',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E11.0',
    name: 'woman superhero: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFB\u200D\u2640',
    Version: 'E11.0',
    name: 'woman superhero: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E11.0',
    name: 'woman superhero: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFC\u200D\u2640',
    Version: 'E11.0',
    name: 'woman superhero: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E11.0',
    name: 'woman superhero: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFD\u200D\u2640',
    Version: 'E11.0',
    name: 'woman superhero: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E11.0',
    name: 'woman superhero: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFE\u200D\u2640',
    Version: 'E11.0',
    name: 'woman superhero: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E11.0',
    name: 'woman superhero: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B8', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB8\uD83C\uDFFF\u200D\u2640',
    Version: 'E11.0',
    name: 'woman superhero: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB9',
    Version: 'E11.0',
    name: 'supervillain',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFB',
    Version: 'E11.0',
    name: 'supervillain: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFC',
    Version: 'E11.0',
    name: 'supervillain: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFD',
    Version: 'E11.0',
    name: 'supervillain: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFE',
    Version: 'E11.0',
    name: 'supervillain: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFF',
    Version: 'E11.0',
    name: 'supervillain: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB9\u200D\u2642\uFE0F',
    Version: 'E11.0',
    name: 'man supervillain',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB9\u200D\u2642',
    Version: 'E11.0',
    name: 'man supervillain',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E11.0',
    name: 'man supervillain: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFB\u200D\u2642',
    Version: 'E11.0',
    name: 'man supervillain: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E11.0',
    name: 'man supervillain: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFC\u200D\u2642',
    Version: 'E11.0',
    name: 'man supervillain: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E11.0',
    name: 'man supervillain: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFD\u200D\u2642',
    Version: 'E11.0',
    name: 'man supervillain: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E11.0',
    name: 'man supervillain: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFE\u200D\u2642',
    Version: 'E11.0',
    name: 'man supervillain: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E11.0',
    name: 'man supervillain: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFF\u200D\u2642',
    Version: 'E11.0',
    name: 'man supervillain: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB9\u200D\u2640\uFE0F',
    Version: 'E11.0',
    name: 'woman supervillain',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB9\u200D\u2640',
    Version: 'E11.0',
    name: 'woman supervillain',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E11.0',
    name: 'woman supervillain: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFB\u200D\u2640',
    Version: 'E11.0',
    name: 'woman supervillain: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E11.0',
    name: 'woman supervillain: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFC\u200D\u2640',
    Version: 'E11.0',
    name: 'woman supervillain: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E11.0',
    name: 'woman supervillain: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFD\u200D\u2640',
    Version: 'E11.0',
    name: 'woman supervillain: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E11.0',
    name: 'woman supervillain: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFE\u200D\u2640',
    Version: 'E11.0',
    name: 'woman supervillain: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E11.0',
    name: 'woman supervillain: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9B9', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDB9\uD83C\uDFFF\u200D\u2640',
    Version: 'E11.0',
    name: 'woman supervillain: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD9',
    Version: 'E5.0',
    name: 'mage',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFB',
    Version: 'E5.0',
    name: 'mage: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFC',
    Version: 'E5.0',
    name: 'mage: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFD',
    Version: 'E5.0',
    name: 'mage: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFE',
    Version: 'E5.0',
    name: 'mage: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFF',
    Version: 'E5.0',
    name: 'mage: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD9\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man mage',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD9\u200D\u2642',
    Version: 'E5.0',
    name: 'man mage',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man mage: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFB\u200D\u2642',
    Version: 'E5.0',
    name: 'man mage: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man mage: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFC\u200D\u2642',
    Version: 'E5.0',
    name: 'man mage: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man mage: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFD\u200D\u2642',
    Version: 'E5.0',
    name: 'man mage: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man mage: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFE\u200D\u2642',
    Version: 'E5.0',
    name: 'man mage: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man mage: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFF\u200D\u2642',
    Version: 'E5.0',
    name: 'man mage: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD9\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman mage',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD9\u200D\u2640',
    Version: 'E5.0',
    name: 'woman mage',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman mage: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFB\u200D\u2640',
    Version: 'E5.0',
    name: 'woman mage: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman mage: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFC\u200D\u2640',
    Version: 'E5.0',
    name: 'woman mage: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman mage: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFD\u200D\u2640',
    Version: 'E5.0',
    name: 'woman mage: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman mage: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFE\u200D\u2640',
    Version: 'E5.0',
    name: 'woman mage: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman mage: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9D9', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD9\uD83C\uDFFF\u200D\u2640',
    Version: 'E5.0',
    name: 'woman mage: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDA',
    Version: 'E5.0',
    name: 'fairy',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFB',
    Version: 'E5.0',
    name: 'fairy: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFC',
    Version: 'E5.0',
    name: 'fairy: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFD',
    Version: 'E5.0',
    name: 'fairy: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFE',
    Version: 'E5.0',
    name: 'fairy: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFF',
    Version: 'E5.0',
    name: 'fairy: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDA\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man fairy',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDA\u200D\u2642',
    Version: 'E5.0',
    name: 'man fairy',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man fairy: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFB\u200D\u2642',
    Version: 'E5.0',
    name: 'man fairy: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man fairy: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFC\u200D\u2642',
    Version: 'E5.0',
    name: 'man fairy: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man fairy: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFD\u200D\u2642',
    Version: 'E5.0',
    name: 'man fairy: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man fairy: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFE\u200D\u2642',
    Version: 'E5.0',
    name: 'man fairy: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man fairy: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFF\u200D\u2642',
    Version: 'E5.0',
    name: 'man fairy: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDA\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman fairy',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDA\u200D\u2640',
    Version: 'E5.0',
    name: 'woman fairy',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman fairy: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFB\u200D\u2640',
    Version: 'E5.0',
    name: 'woman fairy: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman fairy: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFC\u200D\u2640',
    Version: 'E5.0',
    name: 'woman fairy: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman fairy: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFD\u200D\u2640',
    Version: 'E5.0',
    name: 'woman fairy: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman fairy: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFE\u200D\u2640',
    Version: 'E5.0',
    name: 'woman fairy: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman fairy: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DA', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDA\uD83C\uDFFF\u200D\u2640',
    Version: 'E5.0',
    name: 'woman fairy: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDB',
    Version: 'E5.0',
    name: 'vampire',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFB',
    Version: 'E5.0',
    name: 'vampire: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFC',
    Version: 'E5.0',
    name: 'vampire: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFD',
    Version: 'E5.0',
    name: 'vampire: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFE',
    Version: 'E5.0',
    name: 'vampire: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFF',
    Version: 'E5.0',
    name: 'vampire: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDB\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man vampire',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDB\u200D\u2642',
    Version: 'E5.0',
    name: 'man vampire',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man vampire: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFB\u200D\u2642',
    Version: 'E5.0',
    name: 'man vampire: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man vampire: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFC\u200D\u2642',
    Version: 'E5.0',
    name: 'man vampire: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man vampire: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFD\u200D\u2642',
    Version: 'E5.0',
    name: 'man vampire: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man vampire: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFE\u200D\u2642',
    Version: 'E5.0',
    name: 'man vampire: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man vampire: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFF\u200D\u2642',
    Version: 'E5.0',
    name: 'man vampire: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDB\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman vampire',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDB\u200D\u2640',
    Version: 'E5.0',
    name: 'woman vampire',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman vampire: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFB\u200D\u2640',
    Version: 'E5.0',
    name: 'woman vampire: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman vampire: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFC\u200D\u2640',
    Version: 'E5.0',
    name: 'woman vampire: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman vampire: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFD\u200D\u2640',
    Version: 'E5.0',
    name: 'woman vampire: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman vampire: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFE\u200D\u2640',
    Version: 'E5.0',
    name: 'woman vampire: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman vampire: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DB', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDB\uD83C\uDFFF\u200D\u2640',
    Version: 'E5.0',
    name: 'woman vampire: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDC',
    Version: 'E5.0',
    name: 'merperson',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFB',
    Version: 'E5.0',
    name: 'merperson: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFC',
    Version: 'E5.0',
    name: 'merperson: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFD',
    Version: 'E5.0',
    name: 'merperson: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFE',
    Version: 'E5.0',
    name: 'merperson: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFF',
    Version: 'E5.0',
    name: 'merperson: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDC\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'merman',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDC\u200D\u2642',
    Version: 'E5.0',
    name: 'merman',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'merman: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFB\u200D\u2642',
    Version: 'E5.0',
    name: 'merman: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'merman: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFC\u200D\u2642',
    Version: 'E5.0',
    name: 'merman: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'merman: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFD\u200D\u2642',
    Version: 'E5.0',
    name: 'merman: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'merman: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFE\u200D\u2642',
    Version: 'E5.0',
    name: 'merman: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'merman: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFF\u200D\u2642',
    Version: 'E5.0',
    name: 'merman: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDC\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'mermaid',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDC\u200D\u2640',
    Version: 'E5.0',
    name: 'mermaid',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'mermaid: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFB\u200D\u2640',
    Version: 'E5.0',
    name: 'mermaid: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'mermaid: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFC\u200D\u2640',
    Version: 'E5.0',
    name: 'mermaid: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'mermaid: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFD\u200D\u2640',
    Version: 'E5.0',
    name: 'mermaid: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'mermaid: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFE\u200D\u2640',
    Version: 'E5.0',
    name: 'mermaid: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'mermaid: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DC', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDC\uD83C\uDFFF\u200D\u2640',
    Version: 'E5.0',
    name: 'mermaid: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDD',
    Version: 'E5.0',
    name: 'elf',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFB',
    Version: 'E5.0',
    name: 'elf: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFC',
    Version: 'E5.0',
    name: 'elf: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFD',
    Version: 'E5.0',
    name: 'elf: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFE',
    Version: 'E5.0',
    name: 'elf: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFF',
    Version: 'E5.0',
    name: 'elf: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDD\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man elf',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDD\u200D\u2642',
    Version: 'E5.0',
    name: 'man elf',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man elf: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFB\u200D\u2642',
    Version: 'E5.0',
    name: 'man elf: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man elf: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFC\u200D\u2642',
    Version: 'E5.0',
    name: 'man elf: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man elf: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFD\u200D\u2642',
    Version: 'E5.0',
    name: 'man elf: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man elf: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFE\u200D\u2642',
    Version: 'E5.0',
    name: 'man elf: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man elf: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFF\u200D\u2642',
    Version: 'E5.0',
    name: 'man elf: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDD\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman elf',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDD\u200D\u2640',
    Version: 'E5.0',
    name: 'woman elf',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman elf: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFB\u200D\u2640',
    Version: 'E5.0',
    name: 'woman elf: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman elf: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFC\u200D\u2640',
    Version: 'E5.0',
    name: 'woman elf: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman elf: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFD\u200D\u2640',
    Version: 'E5.0',
    name: 'woman elf: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman elf: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFE\u200D\u2640',
    Version: 'E5.0',
    name: 'woman elf: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman elf: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DD', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDD\uD83C\uDFFF\u200D\u2640',
    Version: 'E5.0',
    name: 'woman elf: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDE',
    Version: 'E5.0',
    name: 'genie',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDE\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man genie',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDE\u200D\u2642',
    Version: 'E5.0',
    name: 'man genie',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDE\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman genie',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDE\u200D\u2640',
    Version: 'E5.0',
    name: 'woman genie',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDF',
    Version: 'E5.0',
    name: 'zombie',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDF\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man zombie',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDF\u200D\u2642',
    Version: 'E5.0',
    name: 'man zombie',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDDF\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman zombie',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9DF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDDF\u200D\u2640',
    Version: 'E5.0',
    name: 'woman zombie',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F9CC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCC',
    Version: 'E14.0',
    name: 'troll',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1FAC8'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC8',
    Version: 'E17.0',
    name: 'hairy creature',
    category: 'People \u0026 Body',
    SubGroup: 'person-fantasy'
  },
  {
    CodePointsHex: ['1F486'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC86',
    Version: 'E0.6',
    name: 'person getting massage',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person getting massage: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person getting massage: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person getting massage: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person getting massage: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person getting massage: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC86\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man getting massage',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC86\u200D\u2642',
    Version: 'E4.0',
    name: 'man getting massage',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man getting massage: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man getting massage: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man getting massage: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man getting massage: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man getting massage: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man getting massage: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man getting massage: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man getting massage: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man getting massage: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man getting massage: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC86\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman getting massage',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC86\u200D\u2640',
    Version: 'E4.0',
    name: 'woman getting massage',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman getting massage: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman getting massage: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman getting massage: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman getting massage: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman getting massage: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman getting massage: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman getting massage: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman getting massage: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman getting massage: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F486', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC86\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman getting massage: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC87',
    Version: 'E0.6',
    name: 'person getting haircut',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person getting haircut: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person getting haircut: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person getting haircut: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person getting haircut: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person getting haircut: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC87\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man getting haircut',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC87\u200D\u2642',
    Version: 'E4.0',
    name: 'man getting haircut',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man getting haircut: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man getting haircut: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man getting haircut: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man getting haircut: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man getting haircut: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man getting haircut: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man getting haircut: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man getting haircut: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man getting haircut: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man getting haircut: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC87\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman getting haircut',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC87\u200D\u2640',
    Version: 'E4.0',
    name: 'woman getting haircut',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman getting haircut: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman getting haircut: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman getting haircut: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman getting haircut: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman getting haircut: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman getting haircut: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman getting haircut: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman getting haircut: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman getting haircut: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F487', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC87\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman getting haircut: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6',
    Version: 'E0.6',
    name: 'person walking',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person walking: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person walking: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person walking: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person walking: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person walking: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man walking',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\u200D\u2642',
    Version: 'E4.0',
    name: 'man walking',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man walking: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man walking: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man walking: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man walking: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man walking: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man walking: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man walking: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man walking: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man walking: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man walking: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman walking',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\u200D\u2640',
    Version: 'E4.0',
    name: 'woman walking',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman walking: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman walking: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman walking: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman walking: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman walking: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman walking: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman walking: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman walking: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman walking: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman walking: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person walking facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\u200D\u27A1',
    Version: 'E15.1',
    name: 'person walking facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FB', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFB\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person walking facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FB', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFB\u200D\u27A1',
    Version: 'E15.1',
    name: 'person walking facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person walking facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFC\u200D\u27A1',
    Version: 'E15.1',
    name: 'person walking facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person walking facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFD\u200D\u27A1',
    Version: 'E15.1',
    name: 'person walking facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FE', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFE\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person walking facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FE', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFE\u200D\u27A1',
    Version: 'E15.1',
    name: 'person walking facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person walking facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFF\u200D\u27A1',
    Version: 'E15.1',
    name: 'person walking facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '200D', '2640', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\u200D\u2640\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman walking facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '200D', '2640', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\u200D\u2640\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman walking facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '200D', '2640', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\u200D\u2640\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman walking facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '200D', '2640', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\u200D\u2640\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman walking facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FB', '200D', '2640', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFB\u200D\u2640\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman walking facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FB', '200D', '2640', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFB\u200D\u2640\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman walking facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FB', '200D', '2640', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFB\u200D\u2640\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman walking facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FB', '200D', '2640', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFB\u200D\u2640\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman walking facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FC', '200D', '2640', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFC\u200D\u2640\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman walking facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FC', '200D', '2640', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFC\u200D\u2640\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman walking facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FC', '200D', '2640', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFC\u200D\u2640\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman walking facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FC', '200D', '2640', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFC\u200D\u2640\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman walking facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FD', '200D', '2640', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFD\u200D\u2640\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman walking facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FD', '200D', '2640', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFD\u200D\u2640\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman walking facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FD', '200D', '2640', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFD\u200D\u2640\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman walking facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FD', '200D', '2640', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFD\u200D\u2640\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman walking facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FE', '200D', '2640', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFE\u200D\u2640\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman walking facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FE', '200D', '2640', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFE\u200D\u2640\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman walking facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FE', '200D', '2640', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFE\u200D\u2640\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman walking facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FE', '200D', '2640', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFE\u200D\u2640\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman walking facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FF', '200D', '2640', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFF\u200D\u2640\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman walking facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FF', '200D', '2640', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFF\u200D\u2640\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman walking facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FF', '200D', '2640', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFF\u200D\u2640\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman walking facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FF', '200D', '2640', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFF\u200D\u2640\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman walking facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '200D', '2642', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\u200D\u2642\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man walking facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '200D', '2642', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\u200D\u2642\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man walking facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '200D', '2642', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\u200D\u2642\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'man walking facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '200D', '2642', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\u200D\u2642\u200D\u27A1',
    Version: 'E15.1',
    name: 'man walking facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FB', '200D', '2642', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFB\u200D\u2642\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man walking facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FB', '200D', '2642', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFB\u200D\u2642\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man walking facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FB', '200D', '2642', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFB\u200D\u2642\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'man walking facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FB', '200D', '2642', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFB\u200D\u2642\u200D\u27A1',
    Version: 'E15.1',
    name: 'man walking facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FC', '200D', '2642', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFC\u200D\u2642\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man walking facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FC', '200D', '2642', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFC\u200D\u2642\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man walking facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FC', '200D', '2642', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFC\u200D\u2642\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'man walking facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FC', '200D', '2642', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFC\u200D\u2642\u200D\u27A1',
    Version: 'E15.1',
    name: 'man walking facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FD', '200D', '2642', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFD\u200D\u2642\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man walking facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FD', '200D', '2642', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFD\u200D\u2642\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man walking facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FD', '200D', '2642', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFD\u200D\u2642\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'man walking facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FD', '200D', '2642', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFD\u200D\u2642\u200D\u27A1',
    Version: 'E15.1',
    name: 'man walking facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FE', '200D', '2642', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFE\u200D\u2642\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man walking facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FE', '200D', '2642', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFE\u200D\u2642\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man walking facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FE', '200D', '2642', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFE\u200D\u2642\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'man walking facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FE', '200D', '2642', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFE\u200D\u2642\u200D\u27A1',
    Version: 'E15.1',
    name: 'man walking facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FF', '200D', '2642', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFF\u200D\u2642\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man walking facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FF', '200D', '2642', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFF\u200D\u2642\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man walking facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FF', '200D', '2642', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFF\u200D\u2642\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'man walking facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F6B6', '1F3FF', '200D', '2642', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB6\uD83C\uDFFF\u200D\u2642\u200D\u27A1',
    Version: 'E15.1',
    name: 'man walking facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCD',
    Version: 'E12.0',
    name: 'person standing',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'person standing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'person standing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'person standing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFE',
    Version: 'E12.0',
    name: 'person standing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFF',
    Version: 'E12.0',
    name: 'person standing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCD\u200D\u2642\uFE0F',
    Version: 'E12.0',
    name: 'man standing',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCD\u200D\u2642',
    Version: 'E12.0',
    name: 'man standing',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E12.0',
    name: 'man standing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFB\u200D\u2642',
    Version: 'E12.0',
    name: 'man standing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E12.0',
    name: 'man standing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFC\u200D\u2642',
    Version: 'E12.0',
    name: 'man standing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E12.0',
    name: 'man standing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFD\u200D\u2642',
    Version: 'E12.0',
    name: 'man standing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E12.0',
    name: 'man standing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFE\u200D\u2642',
    Version: 'E12.0',
    name: 'man standing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E12.0',
    name: 'man standing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFF\u200D\u2642',
    Version: 'E12.0',
    name: 'man standing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCD\u200D\u2640\uFE0F',
    Version: 'E12.0',
    name: 'woman standing',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCD\u200D\u2640',
    Version: 'E12.0',
    name: 'woman standing',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E12.0',
    name: 'woman standing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFB\u200D\u2640',
    Version: 'E12.0',
    name: 'woman standing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E12.0',
    name: 'woman standing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFC\u200D\u2640',
    Version: 'E12.0',
    name: 'woman standing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E12.0',
    name: 'woman standing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFD\u200D\u2640',
    Version: 'E12.0',
    name: 'woman standing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E12.0',
    name: 'woman standing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFE\u200D\u2640',
    Version: 'E12.0',
    name: 'woman standing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E12.0',
    name: 'woman standing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CD', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCD\uD83C\uDFFF\u200D\u2640',
    Version: 'E12.0',
    name: 'woman standing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE',
    Version: 'E12.0',
    name: 'person kneeling',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'person kneeling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'person kneeling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'person kneeling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFE',
    Version: 'E12.0',
    name: 'person kneeling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFF',
    Version: 'E12.0',
    name: 'person kneeling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\u200D\u2642\uFE0F',
    Version: 'E12.0',
    name: 'man kneeling',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\u200D\u2642',
    Version: 'E12.0',
    name: 'man kneeling',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E12.0',
    name: 'man kneeling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFB\u200D\u2642',
    Version: 'E12.0',
    name: 'man kneeling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E12.0',
    name: 'man kneeling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFC\u200D\u2642',
    Version: 'E12.0',
    name: 'man kneeling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E12.0',
    name: 'man kneeling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFD\u200D\u2642',
    Version: 'E12.0',
    name: 'man kneeling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E12.0',
    name: 'man kneeling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFE\u200D\u2642',
    Version: 'E12.0',
    name: 'man kneeling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E12.0',
    name: 'man kneeling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFF\u200D\u2642',
    Version: 'E12.0',
    name: 'man kneeling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\u200D\u2640\uFE0F',
    Version: 'E12.0',
    name: 'woman kneeling',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\u200D\u2640',
    Version: 'E12.0',
    name: 'woman kneeling',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E12.0',
    name: 'woman kneeling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFB\u200D\u2640',
    Version: 'E12.0',
    name: 'woman kneeling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E12.0',
    name: 'woman kneeling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFC\u200D\u2640',
    Version: 'E12.0',
    name: 'woman kneeling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E12.0',
    name: 'woman kneeling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFD\u200D\u2640',
    Version: 'E12.0',
    name: 'woman kneeling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E12.0',
    name: 'woman kneeling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFE\u200D\u2640',
    Version: 'E12.0',
    name: 'woman kneeling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E12.0',
    name: 'woman kneeling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFF\u200D\u2640',
    Version: 'E12.0',
    name: 'woman kneeling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person kneeling facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\u200D\u27A1',
    Version: 'E15.1',
    name: 'person kneeling facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FB', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFB\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person kneeling facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FB', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFB\u200D\u27A1',
    Version: 'E15.1',
    name: 'person kneeling facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person kneeling facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFC\u200D\u27A1',
    Version: 'E15.1',
    name: 'person kneeling facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person kneeling facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFD\u200D\u27A1',
    Version: 'E15.1',
    name: 'person kneeling facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FE', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFE\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person kneeling facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FE', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFE\u200D\u27A1',
    Version: 'E15.1',
    name: 'person kneeling facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person kneeling facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFF\u200D\u27A1',
    Version: 'E15.1',
    name: 'person kneeling facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '200D', '2640', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\u200D\u2640\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman kneeling facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '200D', '2640', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\u200D\u2640\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman kneeling facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '200D', '2640', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\u200D\u2640\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman kneeling facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '200D', '2640', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\u200D\u2640\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman kneeling facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FB', '200D', '2640', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFB\u200D\u2640\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman kneeling facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FB', '200D', '2640', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFB\u200D\u2640\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman kneeling facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FB', '200D', '2640', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFB\u200D\u2640\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman kneeling facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FB', '200D', '2640', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFB\u200D\u2640\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman kneeling facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FC', '200D', '2640', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFC\u200D\u2640\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman kneeling facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FC', '200D', '2640', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFC\u200D\u2640\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman kneeling facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FC', '200D', '2640', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFC\u200D\u2640\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman kneeling facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FC', '200D', '2640', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFC\u200D\u2640\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman kneeling facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FD', '200D', '2640', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFD\u200D\u2640\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman kneeling facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FD', '200D', '2640', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFD\u200D\u2640\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman kneeling facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FD', '200D', '2640', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFD\u200D\u2640\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman kneeling facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FD', '200D', '2640', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFD\u200D\u2640\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman kneeling facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FE', '200D', '2640', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFE\u200D\u2640\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman kneeling facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FE', '200D', '2640', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFE\u200D\u2640\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman kneeling facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FE', '200D', '2640', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFE\u200D\u2640\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman kneeling facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FE', '200D', '2640', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFE\u200D\u2640\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman kneeling facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FF', '200D', '2640', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFF\u200D\u2640\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman kneeling facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FF', '200D', '2640', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFF\u200D\u2640\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman kneeling facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FF', '200D', '2640', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFF\u200D\u2640\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman kneeling facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FF', '200D', '2640', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFF\u200D\u2640\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman kneeling facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '200D', '2642', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\u200D\u2642\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man kneeling facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '200D', '2642', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\u200D\u2642\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man kneeling facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '200D', '2642', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\u200D\u2642\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'man kneeling facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '200D', '2642', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\u200D\u2642\u200D\u27A1',
    Version: 'E15.1',
    name: 'man kneeling facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FB', '200D', '2642', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFB\u200D\u2642\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man kneeling facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FB', '200D', '2642', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFB\u200D\u2642\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man kneeling facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FB', '200D', '2642', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFB\u200D\u2642\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'man kneeling facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FB', '200D', '2642', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFB\u200D\u2642\u200D\u27A1',
    Version: 'E15.1',
    name: 'man kneeling facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FC', '200D', '2642', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFC\u200D\u2642\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man kneeling facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FC', '200D', '2642', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFC\u200D\u2642\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man kneeling facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FC', '200D', '2642', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFC\u200D\u2642\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'man kneeling facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FC', '200D', '2642', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFC\u200D\u2642\u200D\u27A1',
    Version: 'E15.1',
    name: 'man kneeling facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FD', '200D', '2642', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFD\u200D\u2642\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man kneeling facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FD', '200D', '2642', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFD\u200D\u2642\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man kneeling facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FD', '200D', '2642', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFD\u200D\u2642\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'man kneeling facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FD', '200D', '2642', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFD\u200D\u2642\u200D\u27A1',
    Version: 'E15.1',
    name: 'man kneeling facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FE', '200D', '2642', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFE\u200D\u2642\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man kneeling facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FE', '200D', '2642', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFE\u200D\u2642\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man kneeling facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FE', '200D', '2642', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFE\u200D\u2642\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'man kneeling facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FE', '200D', '2642', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFE\u200D\u2642\u200D\u27A1',
    Version: 'E15.1',
    name: 'man kneeling facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FF', '200D', '2642', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFF\u200D\u2642\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man kneeling facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FF', '200D', '2642', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFF\u200D\u2642\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man kneeling facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FF', '200D', '2642', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFF\u200D\u2642\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'man kneeling facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9CE', '1F3FF', '200D', '2642', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDCE\uD83C\uDFFF\u200D\u2642\u200D\u27A1',
    Version: 'E15.1',
    name: 'man kneeling facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDDAF',
    Version: 'E12.1',
    name: 'person with white cane',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDAF',
    Version: 'E12.1',
    name: 'person with white cane: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDAF',
    Version: 'E12.1',
    name: 'person with white cane: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDAF',
    Version: 'E12.1',
    name: 'person with white cane: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDAF',
    Version: 'E12.1',
    name: 'person with white cane: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDAF',
    Version: 'E12.1',
    name: 'person with white cane: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F9AF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person with white cane facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F9AF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDDAF\u200D\u27A1',
    Version: 'E15.1',
    name: 'person with white cane facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F9AF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person with white cane facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F9AF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDAF\u200D\u27A1',
    Version: 'E15.1',
    name: 'person with white cane facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F9AF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person with white cane facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F9AF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDAF\u200D\u27A1',
    Version: 'E15.1',
    name: 'person with white cane facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F9AF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person with white cane facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F9AF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDAF\u200D\u27A1',
    Version: 'E15.1',
    name: 'person with white cane facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F9AF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person with white cane facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F9AF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDAF\u200D\u27A1',
    Version: 'E15.1',
    name: 'person with white cane facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F9AF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person with white cane facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F9AF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDAF\u200D\u27A1',
    Version: 'E15.1',
    name: 'person with white cane facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83E\uDDAF',
    Version: 'E12.0',
    name: 'man with white cane',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDAF',
    Version: 'E12.0',
    name: 'man with white cane: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDAF',
    Version: 'E12.0',
    name: 'man with white cane: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDAF',
    Version: 'E12.0',
    name: 'man with white cane: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDAF',
    Version: 'E12.0',
    name: 'man with white cane: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDAF',
    Version: 'E12.0',
    name: 'man with white cane: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F9AF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man with white cane facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F9AF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\u200D\uD83E\uDDAF\u200D\u27A1',
    Version: 'E15.1',
    name: 'man with white cane facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F9AF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man with white cane facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F9AF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDAF\u200D\u27A1',
    Version: 'E15.1',
    name: 'man with white cane facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F9AF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man with white cane facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F9AF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDAF\u200D\u27A1',
    Version: 'E15.1',
    name: 'man with white cane facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F9AF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man with white cane facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F9AF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDAF\u200D\u27A1',
    Version: 'E15.1',
    name: 'man with white cane facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F9AF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man with white cane facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F9AF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDAF\u200D\u27A1',
    Version: 'E15.1',
    name: 'man with white cane facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F9AF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man with white cane facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F9AF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDAF\u200D\u27A1',
    Version: 'E15.1',
    name: 'man with white cane facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83E\uDDAF',
    Version: 'E12.0',
    name: 'woman with white cane',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDAF',
    Version: 'E12.0',
    name: 'woman with white cane: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDAF',
    Version: 'E12.0',
    name: 'woman with white cane: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDAF',
    Version: 'E12.0',
    name: 'woman with white cane: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDAF',
    Version: 'E12.0',
    name: 'woman with white cane: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDAF',
    Version: 'E12.0',
    name: 'woman with white cane: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F9AF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman with white cane facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F9AF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\u200D\uD83E\uDDAF\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman with white cane facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F9AF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman with white cane facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F9AF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDAF\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman with white cane facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F9AF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman with white cane facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F9AF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDAF\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman with white cane facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F9AF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman with white cane facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F9AF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDAF\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman with white cane facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F9AF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman with white cane facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F9AF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDAF\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman with white cane facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F9AF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman with white cane facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F9AF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDAF\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman with white cane facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDDBC',
    Version: 'E12.1',
    name: 'person in motorized wheelchair',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDBC',
    Version: 'E12.1',
    name: 'person in motorized wheelchair: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDBC',
    Version: 'E12.1',
    name: 'person in motorized wheelchair: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDBC',
    Version: 'E12.1',
    name: 'person in motorized wheelchair: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDBC',
    Version: 'E12.1',
    name: 'person in motorized wheelchair: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDBC',
    Version: 'E12.1',
    name: 'person in motorized wheelchair: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F9BC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person in motorized wheelchair facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F9BC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDDBC\u200D\u27A1',
    Version: 'E15.1',
    name: 'person in motorized wheelchair facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F9BC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person in motorized wheelchair facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F9BC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDBC\u200D\u27A1',
    Version: 'E15.1',
    name: 'person in motorized wheelchair facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F9BC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person in motorized wheelchair facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F9BC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDBC\u200D\u27A1',
    Version: 'E15.1',
    name: 'person in motorized wheelchair facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F9BC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person in motorized wheelchair facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F9BC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDBC\u200D\u27A1',
    Version: 'E15.1',
    name: 'person in motorized wheelchair facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F9BC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person in motorized wheelchair facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F9BC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDBC\u200D\u27A1',
    Version: 'E15.1',
    name: 'person in motorized wheelchair facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F9BC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person in motorized wheelchair facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F9BC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDBC\u200D\u27A1',
    Version: 'E15.1',
    name: 'person in motorized wheelchair facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83E\uDDBC',
    Version: 'E12.0',
    name: 'man in motorized wheelchair',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDBC',
    Version: 'E12.0',
    name: 'man in motorized wheelchair: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDBC',
    Version: 'E12.0',
    name: 'man in motorized wheelchair: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDBC',
    Version: 'E12.0',
    name: 'man in motorized wheelchair: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDBC',
    Version: 'E12.0',
    name: 'man in motorized wheelchair: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDBC',
    Version: 'E12.0',
    name: 'man in motorized wheelchair: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F9BC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man in motorized wheelchair facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F9BC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\u200D\uD83E\uDDBC\u200D\u27A1',
    Version: 'E15.1',
    name: 'man in motorized wheelchair facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F9BC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man in motorized wheelchair facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F9BC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDBC\u200D\u27A1',
    Version: 'E15.1',
    name: 'man in motorized wheelchair facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F9BC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man in motorized wheelchair facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F9BC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDBC\u200D\u27A1',
    Version: 'E15.1',
    name: 'man in motorized wheelchair facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F9BC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man in motorized wheelchair facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F9BC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDBC\u200D\u27A1',
    Version: 'E15.1',
    name: 'man in motorized wheelchair facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F9BC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man in motorized wheelchair facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F9BC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDBC\u200D\u27A1',
    Version: 'E15.1',
    name: 'man in motorized wheelchair facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F9BC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man in motorized wheelchair facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F9BC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDBC\u200D\u27A1',
    Version: 'E15.1',
    name: 'man in motorized wheelchair facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83E\uDDBC',
    Version: 'E12.0',
    name: 'woman in motorized wheelchair',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDBC',
    Version: 'E12.0',
    name: 'woman in motorized wheelchair: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDBC',
    Version: 'E12.0',
    name: 'woman in motorized wheelchair: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDBC',
    Version: 'E12.0',
    name: 'woman in motorized wheelchair: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDBC',
    Version: 'E12.0',
    name: 'woman in motorized wheelchair: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDBC',
    Version: 'E12.0',
    name: 'woman in motorized wheelchair: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F9BC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman in motorized wheelchair facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F9BC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\u200D\uD83E\uDDBC\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman in motorized wheelchair facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F9BC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman in motorized wheelchair facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F9BC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDBC\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman in motorized wheelchair facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F9BC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman in motorized wheelchair facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F9BC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDBC\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman in motorized wheelchair facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F9BC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman in motorized wheelchair facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F9BC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDBC\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman in motorized wheelchair facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F9BC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman in motorized wheelchair facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F9BC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDBC\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman in motorized wheelchair facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F9BC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman in motorized wheelchair facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F9BC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDBC\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman in motorized wheelchair facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDDBD',
    Version: 'E12.1',
    name: 'person in manual wheelchair',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDBD',
    Version: 'E12.1',
    name: 'person in manual wheelchair: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDBD',
    Version: 'E12.1',
    name: 'person in manual wheelchair: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDBD',
    Version: 'E12.1',
    name: 'person in manual wheelchair: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDBD',
    Version: 'E12.1',
    name: 'person in manual wheelchair: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDBD',
    Version: 'E12.1',
    name: 'person in manual wheelchair: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F9BD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person in manual wheelchair facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F9BD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDDBD\u200D\u27A1',
    Version: 'E15.1',
    name: 'person in manual wheelchair facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F9BD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person in manual wheelchair facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F9BD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDBD\u200D\u27A1',
    Version: 'E15.1',
    name: 'person in manual wheelchair facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F9BD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person in manual wheelchair facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F9BD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDBD\u200D\u27A1',
    Version: 'E15.1',
    name: 'person in manual wheelchair facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F9BD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person in manual wheelchair facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F9BD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDBD\u200D\u27A1',
    Version: 'E15.1',
    name: 'person in manual wheelchair facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F9BD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person in manual wheelchair facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F9BD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDBD\u200D\u27A1',
    Version: 'E15.1',
    name: 'person in manual wheelchair facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F9BD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person in manual wheelchair facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F9BD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDBD\u200D\u27A1',
    Version: 'E15.1',
    name: 'person in manual wheelchair facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83E\uDDBD',
    Version: 'E12.0',
    name: 'man in manual wheelchair',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDBD',
    Version: 'E12.0',
    name: 'man in manual wheelchair: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDBD',
    Version: 'E12.0',
    name: 'man in manual wheelchair: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDBD',
    Version: 'E12.0',
    name: 'man in manual wheelchair: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDBD',
    Version: 'E12.0',
    name: 'man in manual wheelchair: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDBD',
    Version: 'E12.0',
    name: 'man in manual wheelchair: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F9BD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man in manual wheelchair facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F9BD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\u200D\uD83E\uDDBD\u200D\u27A1',
    Version: 'E15.1',
    name: 'man in manual wheelchair facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F9BD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man in manual wheelchair facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F9BD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDBD\u200D\u27A1',
    Version: 'E15.1',
    name: 'man in manual wheelchair facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F9BD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man in manual wheelchair facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F9BD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDBD\u200D\u27A1',
    Version: 'E15.1',
    name: 'man in manual wheelchair facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F9BD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man in manual wheelchair facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F9BD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDBD\u200D\u27A1',
    Version: 'E15.1',
    name: 'man in manual wheelchair facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F9BD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man in manual wheelchair facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F9BD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDBD\u200D\u27A1',
    Version: 'E15.1',
    name: 'man in manual wheelchair facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F9BD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man in manual wheelchair facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F9BD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDBD\u200D\u27A1',
    Version: 'E15.1',
    name: 'man in manual wheelchair facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83E\uDDBD',
    Version: 'E12.0',
    name: 'woman in manual wheelchair',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDBD',
    Version: 'E12.0',
    name: 'woman in manual wheelchair: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDBD',
    Version: 'E12.0',
    name: 'woman in manual wheelchair: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDBD',
    Version: 'E12.0',
    name: 'woman in manual wheelchair: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDBD',
    Version: 'E12.0',
    name: 'woman in manual wheelchair: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDBD',
    Version: 'E12.0',
    name: 'woman in manual wheelchair: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F9BD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman in manual wheelchair facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F9BD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\u200D\uD83E\uDDBD\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman in manual wheelchair facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F9BD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman in manual wheelchair facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F9BD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDBD\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman in manual wheelchair facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F9BD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman in manual wheelchair facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F9BD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDBD\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman in manual wheelchair facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F9BD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman in manual wheelchair facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F9BD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDBD\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman in manual wheelchair facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F9BD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman in manual wheelchair facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F9BD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDBD\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman in manual wheelchair facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F9BD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman in manual wheelchair facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F9BD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDBD\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman in manual wheelchair facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3',
    Version: 'E0.6',
    name: 'person running',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person running: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person running: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person running: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person running: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person running: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man running',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\u200D\u2642',
    Version: 'E4.0',
    name: 'man running',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man running: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man running: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man running: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man running: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man running: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man running: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man running: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man running: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man running: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man running: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman running',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\u200D\u2640',
    Version: 'E4.0',
    name: 'woman running',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman running: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman running: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman running: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman running: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman running: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman running: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman running: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman running: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman running: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman running: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person running facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\u200D\u27A1',
    Version: 'E15.1',
    name: 'person running facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FB', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFB\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person running facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FB', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFB\u200D\u27A1',
    Version: 'E15.1',
    name: 'person running facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FC', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFC\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person running facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FC', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFC\u200D\u27A1',
    Version: 'E15.1',
    name: 'person running facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FD', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFD\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person running facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FD', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFD\u200D\u27A1',
    Version: 'E15.1',
    name: 'person running facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FE', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFE\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person running facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FE', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFE\u200D\u27A1',
    Version: 'E15.1',
    name: 'person running facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FF', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFF\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'person running facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FF', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFF\u200D\u27A1',
    Version: 'E15.1',
    name: 'person running facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '200D', '2640', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\u200D\u2640\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman running facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '200D', '2640', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\u200D\u2640\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman running facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '200D', '2640', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\u200D\u2640\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman running facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '200D', '2640', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\u200D\u2640\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman running facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FB', '200D', '2640', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFB\u200D\u2640\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman running facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FB', '200D', '2640', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFB\u200D\u2640\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman running facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FB', '200D', '2640', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFB\u200D\u2640\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman running facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FB', '200D', '2640', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFB\u200D\u2640\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman running facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FC', '200D', '2640', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFC\u200D\u2640\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman running facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FC', '200D', '2640', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFC\u200D\u2640\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman running facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FC', '200D', '2640', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFC\u200D\u2640\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman running facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FC', '200D', '2640', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFC\u200D\u2640\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman running facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FD', '200D', '2640', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFD\u200D\u2640\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman running facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FD', '200D', '2640', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFD\u200D\u2640\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman running facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FD', '200D', '2640', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFD\u200D\u2640\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman running facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FD', '200D', '2640', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFD\u200D\u2640\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman running facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FE', '200D', '2640', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFE\u200D\u2640\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman running facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FE', '200D', '2640', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFE\u200D\u2640\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman running facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FE', '200D', '2640', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFE\u200D\u2640\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman running facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FE', '200D', '2640', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFE\u200D\u2640\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman running facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FF', '200D', '2640', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFF\u200D\u2640\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman running facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FF', '200D', '2640', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFF\u200D\u2640\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'woman running facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FF', '200D', '2640', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFF\u200D\u2640\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman running facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FF', '200D', '2640', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFF\u200D\u2640\u200D\u27A1',
    Version: 'E15.1',
    name: 'woman running facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '200D', '2642', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\u200D\u2642\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man running facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '200D', '2642', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\u200D\u2642\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man running facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '200D', '2642', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\u200D\u2642\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'man running facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '200D', '2642', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\u200D\u2642\u200D\u27A1',
    Version: 'E15.1',
    name: 'man running facing right',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FB', '200D', '2642', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFB\u200D\u2642\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man running facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FB', '200D', '2642', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFB\u200D\u2642\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man running facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FB', '200D', '2642', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFB\u200D\u2642\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'man running facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FB', '200D', '2642', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFB\u200D\u2642\u200D\u27A1',
    Version: 'E15.1',
    name: 'man running facing right: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FC', '200D', '2642', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFC\u200D\u2642\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man running facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FC', '200D', '2642', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFC\u200D\u2642\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man running facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FC', '200D', '2642', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFC\u200D\u2642\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'man running facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FC', '200D', '2642', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFC\u200D\u2642\u200D\u27A1',
    Version: 'E15.1',
    name: 'man running facing right: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FD', '200D', '2642', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFD\u200D\u2642\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man running facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FD', '200D', '2642', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFD\u200D\u2642\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man running facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FD', '200D', '2642', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFD\u200D\u2642\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'man running facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FD', '200D', '2642', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFD\u200D\u2642\u200D\u27A1',
    Version: 'E15.1',
    name: 'man running facing right: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FE', '200D', '2642', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFE\u200D\u2642\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man running facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FE', '200D', '2642', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFE\u200D\u2642\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man running facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FE', '200D', '2642', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFE\u200D\u2642\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'man running facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FE', '200D', '2642', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFE\u200D\u2642\u200D\u27A1',
    Version: 'E15.1',
    name: 'man running facing right: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FF', '200D', '2642', 'FE0F', '200D', '27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFF\u200D\u2642\uFE0F\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man running facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FF', '200D', '2642', '200D', '27A1', 'FE0F'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFF\u200D\u2642\u200D\u27A1\uFE0F',
    Version: 'E15.1',
    name: 'man running facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FF', '200D', '2642', 'FE0F', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFF\u200D\u2642\uFE0F\u200D\u27A1',
    Version: 'E15.1',
    name: 'man running facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F3C3', '1F3FF', '200D', '2642', '200D', '27A1'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC3\uD83C\uDFFF\u200D\u2642\u200D\u27A1',
    Version: 'E15.1',
    name: 'man running facing right: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1FA70'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDE70',
    Version: 'E17.0',
    name: 'ballet dancer',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1FA70'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDE70',
    Version: 'E17.0',
    name: 'ballet dancer: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1FA70'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDE70',
    Version: 'E17.0',
    name: 'ballet dancer: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1FA70'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDE70',
    Version: 'E17.0',
    name: 'ballet dancer: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1FA70'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDE70',
    Version: 'E17.0',
    name: 'ballet dancer: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1FA70'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDE70',
    Version: 'E17.0',
    name: 'ballet dancer: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F483'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC83',
    Version: 'E0.6',
    name: 'woman dancing',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F483', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC83\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'woman dancing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F483', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC83\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'woman dancing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F483', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC83\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'woman dancing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F483', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC83\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'woman dancing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F483', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC83\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'woman dancing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F57A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD7A',
    Version: 'E3.0',
    name: 'man dancing',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F57A', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD7A\uD83C\uDFFB',
    Version: 'E3.0',
    name: 'man dancing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F57A', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD7A\uD83C\uDFFC',
    Version: 'E3.0',
    name: 'man dancing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F57A', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD7A\uD83C\uDFFD',
    Version: 'E3.0',
    name: 'man dancing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F57A', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD7A\uD83C\uDFFE',
    Version: 'E3.0',
    name: 'man dancing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F57A', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD7A\uD83C\uDFFF',
    Version: 'E3.0',
    name: 'man dancing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F574', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD74\uFE0F',
    Version: 'E0.7',
    name: 'person in suit levitating',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F574'],
    Status: 'unqualified',
    char: '\uD83D\uDD74',
    Version: 'E0.7',
    name: 'person in suit levitating',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F574', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD74\uD83C\uDFFB',
    Version: 'E4.0',
    name: 'person in suit levitating: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F574', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD74\uD83C\uDFFC',
    Version: 'E4.0',
    name: 'person in suit levitating: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F574', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD74\uD83C\uDFFD',
    Version: 'E4.0',
    name: 'person in suit levitating: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F574', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD74\uD83C\uDFFE',
    Version: 'E4.0',
    name: 'person in suit levitating: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F574', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD74\uD83C\uDFFF',
    Version: 'E4.0',
    name: 'person in suit levitating: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6F',
    Version: 'E0.6',
    name: 'people with bunny ears',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'people with bunny ears: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'people with bunny ears: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'people with bunny ears: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'people with bunny ears: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'people with bunny ears: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6F\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'men with bunny ears',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6F\u200D\u2642',
    Version: 'E4.0',
    name: 'men with bunny ears',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E17.0',
    name: 'men with bunny ears: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFB\u200D\u2642',
    Version: 'E17.0',
    name: 'men with bunny ears: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E17.0',
    name: 'men with bunny ears: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFC\u200D\u2642',
    Version: 'E17.0',
    name: 'men with bunny ears: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E17.0',
    name: 'men with bunny ears: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFD\u200D\u2642',
    Version: 'E17.0',
    name: 'men with bunny ears: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E17.0',
    name: 'men with bunny ears: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFE\u200D\u2642',
    Version: 'E17.0',
    name: 'men with bunny ears: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E17.0',
    name: 'men with bunny ears: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFF\u200D\u2642',
    Version: 'E17.0',
    name: 'men with bunny ears: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6F\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'women with bunny ears',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6F\u200D\u2640',
    Version: 'E4.0',
    name: 'women with bunny ears',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E17.0',
    name: 'women with bunny ears: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFB\u200D\u2640',
    Version: 'E17.0',
    name: 'women with bunny ears: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E17.0',
    name: 'women with bunny ears: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFC\u200D\u2640',
    Version: 'E17.0',
    name: 'women with bunny ears: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E17.0',
    name: 'women with bunny ears: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFD\u200D\u2640',
    Version: 'E17.0',
    name: 'women with bunny ears: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E17.0',
    name: 'women with bunny ears: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFE\u200D\u2640',
    Version: 'E17.0',
    name: 'women with bunny ears: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E17.0',
    name: 'women with bunny ears: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F46F', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC6F\uD83C\uDFFF\u200D\u2640',
    Version: 'E17.0',
    name: 'women with bunny ears: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F430', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'people with bunny ears: light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F430', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'people with bunny ears: light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F430', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'people with bunny ears: light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F430', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'people with bunny ears: light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F430', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'people with bunny ears: medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F430', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'people with bunny ears: medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F430', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'people with bunny ears: medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F430', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'people with bunny ears: medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F430', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'people with bunny ears: medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F430', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'people with bunny ears: medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F430', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'people with bunny ears: medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F430', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'people with bunny ears: medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F430', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'people with bunny ears: medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F430', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'people with bunny ears: medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F430', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'people with bunny ears: medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F430', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'people with bunny ears: medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F430', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'people with bunny ears: dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F430', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'people with bunny ears: dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F430', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'people with bunny ears: dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F430', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'people with bunny ears: dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F430', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'men with bunny ears: light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F430', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'men with bunny ears: light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F430', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'men with bunny ears: light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F430', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'men with bunny ears: light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F430', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'men with bunny ears: medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F430', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'men with bunny ears: medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F430', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'men with bunny ears: medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F430', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'men with bunny ears: medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F430', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'men with bunny ears: medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F430', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'men with bunny ears: medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F430', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'men with bunny ears: medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F430', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'men with bunny ears: medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F430', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'men with bunny ears: medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F430', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'men with bunny ears: medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F430', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'men with bunny ears: medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F430', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'men with bunny ears: medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F430', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'men with bunny ears: dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F430', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'men with bunny ears: dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F430', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'men with bunny ears: dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F430', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'men with bunny ears: dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F430', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'women with bunny ears: light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F430', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'women with bunny ears: light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F430', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'women with bunny ears: light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F430', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'women with bunny ears: light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F430', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'women with bunny ears: medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F430', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'women with bunny ears: medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F430', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'women with bunny ears: medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F430', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'women with bunny ears: medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F430', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'women with bunny ears: medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F430', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'women with bunny ears: medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F430', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'women with bunny ears: medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F430', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'women with bunny ears: medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F430', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'women with bunny ears: medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F430', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'women with bunny ears: medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F430', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'women with bunny ears: medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F430', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'women with bunny ears: medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F430', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'women with bunny ears: dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F430', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'women with bunny ears: dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F430', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'women with bunny ears: dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F430', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDC30\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'women with bunny ears: dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD6',
    Version: 'E5.0',
    name: 'person in steamy room',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFB',
    Version: 'E5.0',
    name: 'person in steamy room: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFC',
    Version: 'E5.0',
    name: 'person in steamy room: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFD',
    Version: 'E5.0',
    name: 'person in steamy room: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFE',
    Version: 'E5.0',
    name: 'person in steamy room: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFF',
    Version: 'E5.0',
    name: 'person in steamy room: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD6\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man in steamy room',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD6\u200D\u2642',
    Version: 'E5.0',
    name: 'man in steamy room',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man in steamy room: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFB\u200D\u2642',
    Version: 'E5.0',
    name: 'man in steamy room: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man in steamy room: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFC\u200D\u2642',
    Version: 'E5.0',
    name: 'man in steamy room: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man in steamy room: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFD\u200D\u2642',
    Version: 'E5.0',
    name: 'man in steamy room: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man in steamy room: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFE\u200D\u2642',
    Version: 'E5.0',
    name: 'man in steamy room: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man in steamy room: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFF\u200D\u2642',
    Version: 'E5.0',
    name: 'man in steamy room: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD6\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman in steamy room',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD6\u200D\u2640',
    Version: 'E5.0',
    name: 'woman in steamy room',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman in steamy room: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFB\u200D\u2640',
    Version: 'E5.0',
    name: 'woman in steamy room: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman in steamy room: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFC\u200D\u2640',
    Version: 'E5.0',
    name: 'woman in steamy room: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman in steamy room: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFD\u200D\u2640',
    Version: 'E5.0',
    name: 'woman in steamy room: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman in steamy room: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFE\u200D\u2640',
    Version: 'E5.0',
    name: 'woman in steamy room: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman in steamy room: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D6', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD6\uD83C\uDFFF\u200D\u2640',
    Version: 'E5.0',
    name: 'woman in steamy room: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD7',
    Version: 'E5.0',
    name: 'person climbing',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFB',
    Version: 'E5.0',
    name: 'person climbing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFC',
    Version: 'E5.0',
    name: 'person climbing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFD',
    Version: 'E5.0',
    name: 'person climbing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFE',
    Version: 'E5.0',
    name: 'person climbing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFF',
    Version: 'E5.0',
    name: 'person climbing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD7\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man climbing',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD7\u200D\u2642',
    Version: 'E5.0',
    name: 'man climbing',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man climbing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFB\u200D\u2642',
    Version: 'E5.0',
    name: 'man climbing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man climbing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFC\u200D\u2642',
    Version: 'E5.0',
    name: 'man climbing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man climbing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFD\u200D\u2642',
    Version: 'E5.0',
    name: 'man climbing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man climbing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFE\u200D\u2642',
    Version: 'E5.0',
    name: 'man climbing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man climbing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFF\u200D\u2642',
    Version: 'E5.0',
    name: 'man climbing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD7\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman climbing',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD7\u200D\u2640',
    Version: 'E5.0',
    name: 'woman climbing',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman climbing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFB\u200D\u2640',
    Version: 'E5.0',
    name: 'woman climbing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman climbing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFC\u200D\u2640',
    Version: 'E5.0',
    name: 'woman climbing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman climbing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFD\u200D\u2640',
    Version: 'E5.0',
    name: 'woman climbing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman climbing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFE\u200D\u2640',
    Version: 'E5.0',
    name: 'woman climbing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman climbing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F9D7', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD7\uD83C\uDFFF\u200D\u2640',
    Version: 'E5.0',
    name: 'woman climbing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-activity'
  },
  {
    CodePointsHex: ['1F93A'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3A',
    Version: 'E3.0',
    name: 'person fencing',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC7',
    Version: 'E1.0',
    name: 'horse racing',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C7', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC7\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'horse racing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C7', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC7\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'horse racing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C7', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC7\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'horse racing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C7', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC7\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'horse racing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C7', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC7\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'horse racing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F7', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26F7\uFE0F',
    Version: 'E0.7',
    name: 'skier',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F7'],
    Status: 'unqualified',
    char: '\u26F7',
    Version: 'E0.7',
    name: 'skier',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC2',
    Version: 'E0.6',
    name: 'snowboarder',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C2', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC2\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'snowboarder: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C2', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC2\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'snowboarder: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C2', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC2\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'snowboarder: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C2', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC2\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'snowboarder: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C2', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC2\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'snowboarder: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCC\uFE0F',
    Version: 'E0.7',
    name: 'person golfing',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC'],
    Status: 'unqualified',
    char: '\uD83C\uDFCC',
    Version: 'E0.7',
    name: 'person golfing',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFB',
    Version: 'E4.0',
    name: 'person golfing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFC',
    Version: 'E4.0',
    name: 'person golfing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFD',
    Version: 'E4.0',
    name: 'person golfing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFE',
    Version: 'E4.0',
    name: 'person golfing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFF',
    Version: 'E4.0',
    name: 'person golfing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', 'FE0F', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man golfing',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '200D', '2642', 'FE0F'],
    Status: 'unqualified',
    char: '\uD83C\uDFCC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man golfing',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', 'FE0F', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCC\uFE0F\u200D\u2642',
    Version: 'E4.0',
    name: 'man golfing',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '200D', '2642'],
    Status: 'unqualified',
    char: '\uD83C\uDFCC\u200D\u2642',
    Version: 'E4.0',
    name: 'man golfing',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man golfing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man golfing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man golfing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man golfing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man golfing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man golfing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man golfing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man golfing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man golfing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man golfing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', 'FE0F', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman golfing',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '200D', '2640', 'FE0F'],
    Status: 'unqualified',
    char: '\uD83C\uDFCC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman golfing',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', 'FE0F', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCC\uFE0F\u200D\u2640',
    Version: 'E4.0',
    name: 'woman golfing',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '200D', '2640'],
    Status: 'unqualified',
    char: '\uD83C\uDFCC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman golfing',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman golfing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman golfing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman golfing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman golfing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman golfing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman golfing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman golfing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman golfing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman golfing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CC', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCC\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman golfing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC4',
    Version: 'E0.6',
    name: 'person surfing',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person surfing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person surfing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person surfing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person surfing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person surfing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC4\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man surfing',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC4\u200D\u2642',
    Version: 'E4.0',
    name: 'man surfing',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man surfing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man surfing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man surfing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man surfing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man surfing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man surfing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man surfing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man surfing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man surfing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man surfing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC4\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman surfing',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC4\u200D\u2640',
    Version: 'E4.0',
    name: 'woman surfing',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman surfing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman surfing: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman surfing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman surfing: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman surfing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman surfing: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman surfing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman surfing: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman surfing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3C4', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFC4\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman surfing: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA3',
    Version: 'E1.0',
    name: 'person rowing boat',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person rowing boat: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person rowing boat: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person rowing boat: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person rowing boat: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person rowing boat: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA3\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man rowing boat',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEA3\u200D\u2642',
    Version: 'E4.0',
    name: 'man rowing boat',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man rowing boat: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man rowing boat: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man rowing boat: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man rowing boat: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man rowing boat: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man rowing boat: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man rowing boat: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man rowing boat: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man rowing boat: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man rowing boat: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA3\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman rowing boat',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEA3\u200D\u2640',
    Version: 'E4.0',
    name: 'woman rowing boat',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman rowing boat: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman rowing boat: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman rowing boat: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman rowing boat: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman rowing boat: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman rowing boat: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman rowing boat: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman rowing boat: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman rowing boat: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6A3', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEA3\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman rowing boat: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCA',
    Version: 'E0.6',
    name: 'person swimming',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person swimming: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person swimming: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person swimming: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person swimming: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person swimming: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCA\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man swimming',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCA\u200D\u2642',
    Version: 'E4.0',
    name: 'man swimming',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man swimming: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man swimming: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man swimming: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man swimming: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man swimming: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man swimming: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man swimming: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man swimming: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man swimming: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man swimming: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCA\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman swimming',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCA\u200D\u2640',
    Version: 'E4.0',
    name: 'woman swimming',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman swimming: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman swimming: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman swimming: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman swimming: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman swimming: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman swimming: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman swimming: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman swimming: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman swimming: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CA', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCA\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman swimming: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26F9\uFE0F',
    Version: 'E0.7',
    name: 'person bouncing ball',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9'],
    Status: 'unqualified',
    char: '\u26F9',
    Version: 'E0.7',
    name: 'person bouncing ball',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FB'],
    Status: 'fully-qualified',
    char: '\u26F9\uD83C\uDFFB',
    Version: 'E2.0',
    name: 'person bouncing ball: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FC'],
    Status: 'fully-qualified',
    char: '\u26F9\uD83C\uDFFC',
    Version: 'E2.0',
    name: 'person bouncing ball: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FD'],
    Status: 'fully-qualified',
    char: '\u26F9\uD83C\uDFFD',
    Version: 'E2.0',
    name: 'person bouncing ball: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FE'],
    Status: 'fully-qualified',
    char: '\u26F9\uD83C\uDFFE',
    Version: 'E2.0',
    name: 'person bouncing ball: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FF'],
    Status: 'fully-qualified',
    char: '\u26F9\uD83C\uDFFF',
    Version: 'E2.0',
    name: 'person bouncing ball: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', 'FE0F', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26F9\uFE0F\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man bouncing ball',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '200D', '2642', 'FE0F'],
    Status: 'unqualified',
    char: '\u26F9\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man bouncing ball',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', 'FE0F', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\u26F9\uFE0F\u200D\u2642',
    Version: 'E4.0',
    name: 'man bouncing ball',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '200D', '2642'],
    Status: 'unqualified',
    char: '\u26F9\u200D\u2642',
    Version: 'E4.0',
    name: 'man bouncing ball',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26F9\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man bouncing ball: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\u26F9\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man bouncing ball: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26F9\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man bouncing ball: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\u26F9\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man bouncing ball: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26F9\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man bouncing ball: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\u26F9\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man bouncing ball: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26F9\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man bouncing ball: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\u26F9\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man bouncing ball: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26F9\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man bouncing ball: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\u26F9\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man bouncing ball: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', 'FE0F', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26F9\uFE0F\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman bouncing ball',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '200D', '2640', 'FE0F'],
    Status: 'unqualified',
    char: '\u26F9\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman bouncing ball',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', 'FE0F', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\u26F9\uFE0F\u200D\u2640',
    Version: 'E4.0',
    name: 'woman bouncing ball',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '200D', '2640'],
    Status: 'unqualified',
    char: '\u26F9\u200D\u2640',
    Version: 'E4.0',
    name: 'woman bouncing ball',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26F9\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman bouncing ball: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\u26F9\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman bouncing ball: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26F9\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman bouncing ball: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\u26F9\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman bouncing ball: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26F9\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman bouncing ball: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\u26F9\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman bouncing ball: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26F9\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman bouncing ball: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\u26F9\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman bouncing ball: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26F9\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman bouncing ball: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['26F9', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\u26F9\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman bouncing ball: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCB\uFE0F',
    Version: 'E0.7',
    name: 'person lifting weights',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB'],
    Status: 'unqualified',
    char: '\uD83C\uDFCB',
    Version: 'E0.7',
    name: 'person lifting weights',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFB',
    Version: 'E2.0',
    name: 'person lifting weights: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFC',
    Version: 'E2.0',
    name: 'person lifting weights: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFD',
    Version: 'E2.0',
    name: 'person lifting weights: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFE',
    Version: 'E2.0',
    name: 'person lifting weights: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFF',
    Version: 'E2.0',
    name: 'person lifting weights: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', 'FE0F', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man lifting weights',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '200D', '2642', 'FE0F'],
    Status: 'unqualified',
    char: '\uD83C\uDFCB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man lifting weights',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', 'FE0F', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCB\uFE0F\u200D\u2642',
    Version: 'E4.0',
    name: 'man lifting weights',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '200D', '2642'],
    Status: 'unqualified',
    char: '\uD83C\uDFCB\u200D\u2642',
    Version: 'E4.0',
    name: 'man lifting weights',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man lifting weights: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man lifting weights: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man lifting weights: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man lifting weights: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man lifting weights: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man lifting weights: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man lifting weights: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man lifting weights: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man lifting weights: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man lifting weights: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', 'FE0F', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman lifting weights',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '200D', '2640', 'FE0F'],
    Status: 'unqualified',
    char: '\uD83C\uDFCB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman lifting weights',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', 'FE0F', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCB\uFE0F\u200D\u2640',
    Version: 'E4.0',
    name: 'woman lifting weights',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '200D', '2640'],
    Status: 'unqualified',
    char: '\uD83C\uDFCB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman lifting weights',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman lifting weights: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman lifting weights: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman lifting weights: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman lifting weights: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman lifting weights: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman lifting weights: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman lifting weights: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman lifting weights: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman lifting weights: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F3CB', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFCB\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman lifting weights: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB4',
    Version: 'E1.0',
    name: 'person biking',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person biking: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person biking: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person biking: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person biking: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person biking: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB4\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man biking',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB4\u200D\u2642',
    Version: 'E4.0',
    name: 'man biking',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man biking: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man biking: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man biking: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man biking: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man biking: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man biking: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man biking: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man biking: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man biking: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man biking: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB4\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman biking',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB4\u200D\u2640',
    Version: 'E4.0',
    name: 'woman biking',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman biking: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman biking: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman biking: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman biking: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman biking: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman biking: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman biking: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman biking: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman biking: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B4', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB4\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman biking: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB5',
    Version: 'E1.0',
    name: 'person mountain biking',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person mountain biking: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person mountain biking: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person mountain biking: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person mountain biking: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person mountain biking: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB5\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man mountain biking',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB5\u200D\u2642',
    Version: 'E4.0',
    name: 'man mountain biking',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man mountain biking: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man mountain biking: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man mountain biking: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man mountain biking: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man mountain biking: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man mountain biking: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man mountain biking: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man mountain biking: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man mountain biking: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man mountain biking: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB5\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman mountain biking',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB5\u200D\u2640',
    Version: 'E4.0',
    name: 'woman mountain biking',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman mountain biking: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman mountain biking: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman mountain biking: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman mountain biking: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman mountain biking: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman mountain biking: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman mountain biking: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman mountain biking: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman mountain biking: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F6B5', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDEB5\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman mountain biking: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD38',
    Version: 'E3.0',
    name: 'person cartwheeling',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFB',
    Version: 'E3.0',
    name: 'person cartwheeling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFC',
    Version: 'E3.0',
    name: 'person cartwheeling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFD',
    Version: 'E3.0',
    name: 'person cartwheeling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFE',
    Version: 'E3.0',
    name: 'person cartwheeling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFF',
    Version: 'E3.0',
    name: 'person cartwheeling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD38\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man cartwheeling',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD38\u200D\u2642',
    Version: 'E4.0',
    name: 'man cartwheeling',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man cartwheeling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man cartwheeling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man cartwheeling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man cartwheeling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man cartwheeling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man cartwheeling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man cartwheeling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man cartwheeling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man cartwheeling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man cartwheeling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD38\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman cartwheeling',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD38\u200D\u2640',
    Version: 'E4.0',
    name: 'woman cartwheeling',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman cartwheeling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman cartwheeling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman cartwheeling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman cartwheeling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman cartwheeling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman cartwheeling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman cartwheeling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman cartwheeling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman cartwheeling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F938', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD38\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman cartwheeling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3C',
    Version: 'E3.0',
    name: 'people wrestling',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'people wrestling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'people wrestling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'people wrestling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'people wrestling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'people wrestling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3C\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'men wrestling',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3C\u200D\u2642',
    Version: 'E4.0',
    name: 'men wrestling',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E17.0',
    name: 'men wrestling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFB\u200D\u2642',
    Version: 'E17.0',
    name: 'men wrestling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E17.0',
    name: 'men wrestling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFC\u200D\u2642',
    Version: 'E17.0',
    name: 'men wrestling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E17.0',
    name: 'men wrestling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFD\u200D\u2642',
    Version: 'E17.0',
    name: 'men wrestling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E17.0',
    name: 'men wrestling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFE\u200D\u2642',
    Version: 'E17.0',
    name: 'men wrestling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E17.0',
    name: 'men wrestling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFF\u200D\u2642',
    Version: 'E17.0',
    name: 'men wrestling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3C\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'women wrestling',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3C\u200D\u2640',
    Version: 'E4.0',
    name: 'women wrestling',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E17.0',
    name: 'women wrestling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFB\u200D\u2640',
    Version: 'E17.0',
    name: 'women wrestling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E17.0',
    name: 'women wrestling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFC\u200D\u2640',
    Version: 'E17.0',
    name: 'women wrestling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E17.0',
    name: 'women wrestling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFD\u200D\u2640',
    Version: 'E17.0',
    name: 'women wrestling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E17.0',
    name: 'women wrestling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFE\u200D\u2640',
    Version: 'E17.0',
    name: 'women wrestling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E17.0',
    name: 'women wrestling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93C', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3C\uD83C\uDFFF\u200D\u2640',
    Version: 'E17.0',
    name: 'women wrestling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1FAEF', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'people wrestling: light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1FAEF', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'people wrestling: light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1FAEF', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'people wrestling: light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1FAEF', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'people wrestling: light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1FAEF', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'people wrestling: medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1FAEF', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'people wrestling: medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1FAEF', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'people wrestling: medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1FAEF', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'people wrestling: medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1FAEF', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'people wrestling: medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1FAEF', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'people wrestling: medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1FAEF', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'people wrestling: medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1FAEF', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'people wrestling: medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1FAEF', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'people wrestling: medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1FAEF', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'people wrestling: medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1FAEF', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'people wrestling: medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1FAEF', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'people wrestling: medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1FAEF', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'people wrestling: dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1FAEF', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'people wrestling: dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1FAEF', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'people wrestling: dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1FAEF', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'people wrestling: dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1FAEF', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'men wrestling: light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1FAEF', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'men wrestling: light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1FAEF', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'men wrestling: light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1FAEF', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'men wrestling: light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1FAEF', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'men wrestling: medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1FAEF', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'men wrestling: medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1FAEF', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'men wrestling: medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1FAEF', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'men wrestling: medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1FAEF', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'men wrestling: medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1FAEF', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'men wrestling: medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1FAEF', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'men wrestling: medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1FAEF', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'men wrestling: medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1FAEF', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'men wrestling: medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1FAEF', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'men wrestling: medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1FAEF', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'men wrestling: medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1FAEF', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'men wrestling: medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1FAEF', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'men wrestling: dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1FAEF', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'men wrestling: dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1FAEF', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'men wrestling: dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1FAEF', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'men wrestling: dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1FAEF', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'women wrestling: light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1FAEF', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'women wrestling: light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1FAEF', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'women wrestling: light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1FAEF', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'women wrestling: light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1FAEF', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'women wrestling: medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1FAEF', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'women wrestling: medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1FAEF', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'women wrestling: medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1FAEF', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'women wrestling: medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1FAEF', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'women wrestling: medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1FAEF', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'women wrestling: medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1FAEF', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'women wrestling: medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1FAEF', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'women wrestling: medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1FAEF', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'women wrestling: medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1FAEF', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'women wrestling: medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1FAEF', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'women wrestling: medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1FAEF', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E17.0',
    name: 'women wrestling: medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1FAEF', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E17.0',
    name: 'women wrestling: dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1FAEF', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E17.0',
    name: 'women wrestling: dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1FAEF', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E17.0',
    name: 'women wrestling: dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1FAEF', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDEEF\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E17.0',
    name: 'women wrestling: dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3D',
    Version: 'E3.0',
    name: 'person playing water polo',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFB',
    Version: 'E3.0',
    name: 'person playing water polo: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFC',
    Version: 'E3.0',
    name: 'person playing water polo: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFD',
    Version: 'E3.0',
    name: 'person playing water polo: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFE',
    Version: 'E3.0',
    name: 'person playing water polo: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFF',
    Version: 'E3.0',
    name: 'person playing water polo: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3D\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man playing water polo',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3D\u200D\u2642',
    Version: 'E4.0',
    name: 'man playing water polo',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man playing water polo: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man playing water polo: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man playing water polo: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man playing water polo: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man playing water polo: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man playing water polo: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man playing water polo: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man playing water polo: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man playing water polo: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man playing water polo: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3D\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman playing water polo',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3D\u200D\u2640',
    Version: 'E4.0',
    name: 'woman playing water polo',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman playing water polo: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman playing water polo: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman playing water polo: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman playing water polo: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman playing water polo: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman playing water polo: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman playing water polo: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman playing water polo: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman playing water polo: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93D', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3D\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman playing water polo: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3E',
    Version: 'E3.0',
    name: 'person playing handball',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFB',
    Version: 'E3.0',
    name: 'person playing handball: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFC',
    Version: 'E3.0',
    name: 'person playing handball: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFD',
    Version: 'E3.0',
    name: 'person playing handball: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFE',
    Version: 'E3.0',
    name: 'person playing handball: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFF',
    Version: 'E3.0',
    name: 'person playing handball: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3E\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man playing handball',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3E\u200D\u2642',
    Version: 'E4.0',
    name: 'man playing handball',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man playing handball: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man playing handball: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man playing handball: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man playing handball: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man playing handball: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man playing handball: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man playing handball: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man playing handball: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man playing handball: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man playing handball: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3E\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman playing handball',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3E\u200D\u2640',
    Version: 'E4.0',
    name: 'woman playing handball',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman playing handball: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman playing handball: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman playing handball: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman playing handball: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman playing handball: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman playing handball: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman playing handball: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman playing handball: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman playing handball: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F93E', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD3E\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman playing handball: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD39',
    Version: 'E3.0',
    name: 'person juggling',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFB',
    Version: 'E3.0',
    name: 'person juggling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFC',
    Version: 'E3.0',
    name: 'person juggling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFD',
    Version: 'E3.0',
    name: 'person juggling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFE',
    Version: 'E3.0',
    name: 'person juggling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFF',
    Version: 'E3.0',
    name: 'person juggling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD39\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man juggling',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD39\u200D\u2642',
    Version: 'E4.0',
    name: 'man juggling',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man juggling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFB\u200D\u2642',
    Version: 'E4.0',
    name: 'man juggling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man juggling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFC\u200D\u2642',
    Version: 'E4.0',
    name: 'man juggling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man juggling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFD\u200D\u2642',
    Version: 'E4.0',
    name: 'man juggling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man juggling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFE\u200D\u2642',
    Version: 'E4.0',
    name: 'man juggling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E4.0',
    name: 'man juggling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFF\u200D\u2642',
    Version: 'E4.0',
    name: 'man juggling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD39\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman juggling',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD39\u200D\u2640',
    Version: 'E4.0',
    name: 'woman juggling',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman juggling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFB\u200D\u2640',
    Version: 'E4.0',
    name: 'woman juggling: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman juggling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFC\u200D\u2640',
    Version: 'E4.0',
    name: 'woman juggling: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman juggling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFD\u200D\u2640',
    Version: 'E4.0',
    name: 'woman juggling: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman juggling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFE\u200D\u2640',
    Version: 'E4.0',
    name: 'woman juggling: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E4.0',
    name: 'woman juggling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F939', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDD39\uD83C\uDFFF\u200D\u2640',
    Version: 'E4.0',
    name: 'woman juggling: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-sport'
  },
  {
    CodePointsHex: ['1F9D8'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD8',
    Version: 'E5.0',
    name: 'person in lotus position',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFB',
    Version: 'E5.0',
    name: 'person in lotus position: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFC',
    Version: 'E5.0',
    name: 'person in lotus position: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFD',
    Version: 'E5.0',
    name: 'person in lotus position: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFE',
    Version: 'E5.0',
    name: 'person in lotus position: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFF',
    Version: 'E5.0',
    name: 'person in lotus position: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD8\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man in lotus position',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD8\u200D\u2642',
    Version: 'E5.0',
    name: 'man in lotus position',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FB', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFB\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man in lotus position: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FB', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFB\u200D\u2642',
    Version: 'E5.0',
    name: 'man in lotus position: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FC', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFC\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man in lotus position: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FC', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFC\u200D\u2642',
    Version: 'E5.0',
    name: 'man in lotus position: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FD', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFD\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man in lotus position: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FD', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFD\u200D\u2642',
    Version: 'E5.0',
    name: 'man in lotus position: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FE', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFE\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man in lotus position: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FE', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFE\u200D\u2642',
    Version: 'E5.0',
    name: 'man in lotus position: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FF', '200D', '2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFF\u200D\u2642\uFE0F',
    Version: 'E5.0',
    name: 'man in lotus position: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FF', '200D', '2642'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFF\u200D\u2642',
    Version: 'E5.0',
    name: 'man in lotus position: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD8\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman in lotus position',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD8\u200D\u2640',
    Version: 'E5.0',
    name: 'woman in lotus position',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FB', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFB\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman in lotus position: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FB', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFB\u200D\u2640',
    Version: 'E5.0',
    name: 'woman in lotus position: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FC', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFC\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman in lotus position: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FC', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFC\u200D\u2640',
    Version: 'E5.0',
    name: 'woman in lotus position: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FD', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFD\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman in lotus position: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FD', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFD\u200D\u2640',
    Version: 'E5.0',
    name: 'woman in lotus position: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FE', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFE\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman in lotus position: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FE', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFE\u200D\u2640',
    Version: 'E5.0',
    name: 'woman in lotus position: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FF', '200D', '2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFF\u200D\u2640\uFE0F',
    Version: 'E5.0',
    name: 'woman in lotus position: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D8', '1F3FF', '200D', '2640'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD8\uD83C\uDFFF\u200D\u2640',
    Version: 'E5.0',
    name: 'woman in lotus position: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F6C0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEC0',
    Version: 'E0.6',
    name: 'person taking bath',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F6C0', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEC0\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'person taking bath: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F6C0', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEC0\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'person taking bath: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F6C0', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEC0\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'person taking bath: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F6C0', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEC0\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'person taking bath: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F6C0', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEC0\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'person taking bath: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F6CC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDECC',
    Version: 'E1.0',
    name: 'person in bed',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F6CC', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDECC\uD83C\uDFFB',
    Version: 'E4.0',
    name: 'person in bed: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F6CC', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDECC\uD83C\uDFFC',
    Version: 'E4.0',
    name: 'person in bed: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F6CC', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDECC\uD83C\uDFFD',
    Version: 'E4.0',
    name: 'person in bed: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F6CC', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDECC\uD83C\uDFFE',
    Version: 'E4.0',
    name: 'person in bed: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F6CC', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDECC\uD83C\uDFFF',
    Version: 'E4.0',
    name: 'person in bed: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'person-resting'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F91D', '200D', '1F9D1'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1',
    Version: 'E12.0',
    name: 'people holding hands',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F91D', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'people holding hands: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F91D', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E12.1',
    name: 'people holding hands: light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F91D', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E12.1',
    name: 'people holding hands: light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F91D', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E12.1',
    name: 'people holding hands: light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '1F91D', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E12.1',
    name: 'people holding hands: light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F91D', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'people holding hands: medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F91D', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'people holding hands: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F91D', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E12.1',
    name: 'people holding hands: medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F91D', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E12.1',
    name: 'people holding hands: medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '1F91D', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E12.1',
    name: 'people holding hands: medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F91D', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'people holding hands: medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F91D', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'people holding hands: medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F91D', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'people holding hands: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F91D', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E12.1',
    name: 'people holding hands: medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '1F91D', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E12.1',
    name: 'people holding hands: medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F91D', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'people holding hands: medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F91D', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'people holding hands: medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F91D', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'people holding hands: medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F91D', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E12.0',
    name: 'people holding hands: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '1F91D', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E12.1',
    name: 'people holding hands: medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F91D', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'people holding hands: dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F91D', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'people holding hands: dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F91D', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'people holding hands: dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F91D', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E12.0',
    name: 'people holding hands: dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '1F91D', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E12.0',
    name: 'people holding hands: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F46D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6D',
    Version: 'E1.0',
    name: 'women holding hands',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F46D', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6D\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'women holding hands: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F91D', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E12.1',
    name: 'women holding hands: light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F91D', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E12.1',
    name: 'women holding hands: light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F91D', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E12.1',
    name: 'women holding hands: light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F91D', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E12.1',
    name: 'women holding hands: light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F91D', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'women holding hands: medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F46D', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6D\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'women holding hands: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F91D', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E12.1',
    name: 'women holding hands: medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F91D', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E12.1',
    name: 'women holding hands: medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F91D', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E12.1',
    name: 'women holding hands: medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F91D', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'women holding hands: medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F91D', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'women holding hands: medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F46D', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6D\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'women holding hands: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F91D', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E12.1',
    name: 'women holding hands: medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F91D', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E12.1',
    name: 'women holding hands: medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F91D', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'women holding hands: medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F91D', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'women holding hands: medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F91D', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'women holding hands: medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F46D', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6D\uD83C\uDFFE',
    Version: 'E12.0',
    name: 'women holding hands: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F91D', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E12.1',
    name: 'women holding hands: medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F91D', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'women holding hands: dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F91D', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'women holding hands: dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F91D', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'women holding hands: dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F91D', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E12.0',
    name: 'women holding hands: dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F46D', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6D\uD83C\uDFFF',
    Version: 'E12.0',
    name: 'women holding hands: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F46B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6B',
    Version: 'E0.6',
    name: 'woman and man holding hands',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F46B', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6B\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'woman and man holding hands: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F91D', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'woman and man holding hands: light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F91D', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'woman and man holding hands: light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F91D', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E12.0',
    name: 'woman and man holding hands: light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '1F91D', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E12.0',
    name: 'woman and man holding hands: light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F91D', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'woman and man holding hands: medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F46B', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6B\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'woman and man holding hands: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F91D', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'woman and man holding hands: medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F91D', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E12.0',
    name: 'woman and man holding hands: medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '1F91D', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E12.0',
    name: 'woman and man holding hands: medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F91D', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'woman and man holding hands: medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F91D', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'woman and man holding hands: medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F46B', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6B\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'woman and man holding hands: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F91D', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E12.0',
    name: 'woman and man holding hands: medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '1F91D', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E12.0',
    name: 'woman and man holding hands: medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F91D', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'woman and man holding hands: medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F91D', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'woman and man holding hands: medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F91D', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'woman and man holding hands: medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F46B', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6B\uD83C\uDFFE',
    Version: 'E12.0',
    name: 'woman and man holding hands: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '1F91D', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E12.0',
    name: 'woman and man holding hands: medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F91D', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'woman and man holding hands: dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F91D', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'woman and man holding hands: dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F91D', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'woman and man holding hands: dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '1F91D', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E12.0',
    name: 'woman and man holding hands: dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F46B', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6B\uD83C\uDFFF',
    Version: 'E12.0',
    name: 'woman and man holding hands: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F46C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6C',
    Version: 'E1.0',
    name: 'men holding hands',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F46C', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6C\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'men holding hands: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F91D', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E12.1',
    name: 'men holding hands: light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F91D', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E12.1',
    name: 'men holding hands: light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F91D', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E12.1',
    name: 'men holding hands: light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '1F91D', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E12.1',
    name: 'men holding hands: light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F91D', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'men holding hands: medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F46C', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6C\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'men holding hands: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F91D', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E12.1',
    name: 'men holding hands: medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F91D', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E12.1',
    name: 'men holding hands: medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '1F91D', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E12.1',
    name: 'men holding hands: medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F91D', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'men holding hands: medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F91D', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'men holding hands: medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F46C', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6C\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'men holding hands: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F91D', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E12.1',
    name: 'men holding hands: medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '1F91D', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E12.1',
    name: 'men holding hands: medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F91D', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'men holding hands: medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F91D', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'men holding hands: medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F91D', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'men holding hands: medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F46C', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6C\uD83C\uDFFE',
    Version: 'E12.0',
    name: 'men holding hands: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '1F91D', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E12.1',
    name: 'men holding hands: medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F91D', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E12.0',
    name: 'men holding hands: dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F91D', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E12.0',
    name: 'men holding hands: dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F91D', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E12.0',
    name: 'men holding hands: dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '1F91D', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E12.0',
    name: 'men holding hands: dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F46C', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6C\uD83C\uDFFF',
    Version: 'E12.0',
    name: 'men holding hands: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F48F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC8F',
    Version: 'E0.6',
    name: 'kiss',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F48F', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC8F\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F48F', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC8F\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F48F', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC8F\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F48F', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC8F\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F48F', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC8F\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: person, person, light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: person, person, light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: person, person, light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: person, person, light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: person, person, light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: person, person, light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: person, person, light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: person, person, light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: person, person, medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: person, person, medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: person, person, medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: person, person, medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: person, person, medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: person, person, medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: person, person, medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: person, person, medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: person, person, medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: person, person, medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: person, person, medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: person, person, medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: person, person, medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: person, person, medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: person, person, medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: person, person, medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: person, person, medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: person, person, medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: person, person, medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: person, person, medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: person, person, medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: person, person, medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: person, person, medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: person, person, medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: person, person, dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: person, person, dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: person, person, dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: person, person, dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: person, person, dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: person, person, dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: person, person, dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F9D1', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: person, person, dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68',
    Version: 'E2.0',
    name: 'kiss: woman, man',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '200D', '2764', '200D', '1F48B', '200D', '1F468'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68',
    Version: 'E2.0',
    name: 'kiss: woman, man',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, man, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, man, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, man, light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, man, light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, man, light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, man, light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, man, light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, man, light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, man, light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, man, light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, man, medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, man, dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, man, dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, man, dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, man, dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, man, dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, man, dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, man, dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, man, dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, man, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, man, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68',
    Version: 'E2.0',
    name: 'kiss: man, man',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '2764', '200D', '1F48B', '200D', '1F468'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68',
    Version: 'E2.0',
    name: 'kiss: man, man',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: man, man, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: man, man, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: man, man, light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: man, man, light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: man, man, light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: man, man, light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: man, man, light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: man, man, light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: man, man, light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: man, man, light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: man, man, medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: man, man, medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: man, man, medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: man, man, medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: man, man, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: man, man, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: man, man, medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: man, man, medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: man, man, medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: man, man, medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: man, man, medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: man, man, dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: man, man, dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: man, man, dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: man, man, dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: man, man, dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: man, man, dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: man, man, dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: man, man, dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: man, man, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: man, man, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69',
    Version: 'E2.0',
    name: 'kiss: woman, woman',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '200D', '2764', '200D', '1F48B', '200D', '1F469'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69',
    Version: 'E2.0',
    name: 'kiss: woman, woman',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, woman, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, woman, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, woman, light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, woman, light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, woman, light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, woman, light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, woman, light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, woman, light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, woman, light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, woman, light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, woman, medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, woman, dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'kiss: woman, woman, dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, woman, dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'kiss: woman, woman, dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, woman, dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'kiss: woman, woman, dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, woman, dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'kiss: woman, woman, dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F48B', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, woman, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F48B', '200D', '1F469', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'kiss: woman, woman, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F491'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC91',
    Version: 'E0.6',
    name: 'couple with heart',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F491', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC91\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F491', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC91\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F491', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC91\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F491', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC91\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F491', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC91\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: person, person, light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2764', '200D', '1F9D1', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: person, person, light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: person, person, light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2764', '200D', '1F9D1', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: person, person, light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: person, person, light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2764', '200D', '1F9D1', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: person, person, light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: person, person, light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FB', '200D', '2764', '200D', '1F9D1', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: person, person, light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2764', '200D', '1F9D1', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2764', '200D', '1F9D1', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2764', '200D', '1F9D1', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FC', '200D', '2764', '200D', '1F9D1', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2764', '200D', '1F9D1', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2764', '200D', '1F9D1', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2764', '200D', '1F9D1', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FD', '200D', '2764', '200D', '1F9D1', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2764', '200D', '1F9D1', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2764', '200D', '1F9D1', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2764', '200D', '1F9D1', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FE', '200D', '2764', '200D', '1F9D1', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: person, person, medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: person, person, dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2764', '200D', '1F9D1', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: person, person, dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: person, person, dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2764', '200D', '1F9D1', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: person, person, dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: person, person, dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2764', '200D', '1F9D1', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: person, person, dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F9D1', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: person, person, dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F9D1', '1F3FF', '200D', '2764', '200D', '1F9D1', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\u200D\uD83E\uDDD1\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: person, person, dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '200D', '2764', 'FE0F', '200D', '1F468'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68',
    Version: 'E2.0',
    name: 'couple with heart: woman, man',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '200D', '2764', '200D', '1F468'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\u200D\u2764\u200D\uD83D\uDC68',
    Version: 'E2.0',
    name: 'couple with heart: woman, man',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, man, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '2764', 'FE0F', '200D', '1F468'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68',
    Version: 'E2.0',
    name: 'couple with heart: man, man',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '2764', '200D', '1F468'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\u200D\u2764\u200D\uD83D\uDC68',
    Version: 'E2.0',
    name: 'couple with heart: man, man',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: man, man, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: man, man, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: man, man, light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: man, man, light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: man, man, light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: man, man, light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: man, man, light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: man, man, light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: man, man, light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FB', '200D', '2764', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: man, man, light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FC', '200D', '2764', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FD', '200D', '2764', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FE', '200D', '2764', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: man, man, medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: man, man, dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', '200D', '1F468', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: man, man, dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: man, man, dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', '200D', '1F468', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: man, man, dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: man, man, dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', '200D', '1F468', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: man, man, dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: man, man, dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', '200D', '1F468', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: man, man, dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F468', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: man, man, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '1F3FF', '200D', '2764', '200D', '1F468', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC68\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: man, man, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '200D', '2764', 'FE0F', '200D', '1F469'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69',
    Version: 'E2.0',
    name: 'couple with heart: woman, woman',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '200D', '2764', '200D', '1F469'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\u200D\u2764\u200D\uD83D\uDC69',
    Version: 'E2.0',
    name: 'couple with heart: woman, woman',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F469', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F469', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, light skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F469', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F469', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FB', '200D', '2764', '200D', '1F469', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F469', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-light skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F469', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F469', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-light skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F469', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-light skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FC', '200D', '2764', '200D', '1F469', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-light skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F469', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F469', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F469', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F469', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FD', '200D', '2764', '200D', '1F469', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F469', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F469', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F469', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F469', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FE', '200D', '2764', '200D', '1F469', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, medium-dark skin tone, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F469', '1F3FB'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFB',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, dark skin tone, light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F469', '1F3FC'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFC',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, dark skin tone, medium-light skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F469', '1F3FD'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFD',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, dark skin tone, medium skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F469', '1F3FE'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFE',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, dark skin tone, medium-dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', 'FE0F', '200D', '1F469', '1F3FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '1F3FF', '200D', '2764', '200D', '1F469', '1F3FF'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\u200D\uD83D\uDC69\uD83C\uDFFF',
    Version: 'E13.1',
    name: 'couple with heart: woman, woman, dark skin tone',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F469', '200D', '1F466'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66',
    Version: 'E2.0',
    name: 'family: man, woman, boy',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F469', '200D', '1F467'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67',
    Version: 'E2.0',
    name: 'family: man, woman, girl',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F469', '200D', '1F467', '200D', '1F466'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66',
    Version: 'E2.0',
    name: 'family: man, woman, girl, boy',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F469', '200D', '1F466', '200D', '1F466'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66',
    Version: 'E2.0',
    name: 'family: man, woman, boy, boy',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F469', '200D', '1F467', '200D', '1F467'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67',
    Version: 'E2.0',
    name: 'family: man, woman, girl, girl',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F468', '200D', '1F466'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66',
    Version: 'E2.0',
    name: 'family: man, man, boy',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F468', '200D', '1F467'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67',
    Version: 'E2.0',
    name: 'family: man, man, girl',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F468', '200D', '1F467', '200D', '1F466'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66',
    Version: 'E2.0',
    name: 'family: man, man, girl, boy',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F468', '200D', '1F466', '200D', '1F466'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66',
    Version: 'E2.0',
    name: 'family: man, man, boy, boy',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F468', '200D', '1F467', '200D', '1F467'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67',
    Version: 'E2.0',
    name: 'family: man, man, girl, girl',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F469', '200D', '1F466'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66',
    Version: 'E2.0',
    name: 'family: woman, woman, boy',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F469', '200D', '1F467'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67',
    Version: 'E2.0',
    name: 'family: woman, woman, girl',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F469', '200D', '1F467', '200D', '1F466'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66',
    Version: 'E2.0',
    name: 'family: woman, woman, girl, boy',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F469', '200D', '1F466', '200D', '1F466'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66',
    Version: 'E2.0',
    name: 'family: woman, woman, boy, boy',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F469', '200D', '1F467', '200D', '1F467'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67',
    Version: 'E2.0',
    name: 'family: woman, woman, girl, girl',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F466'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDC66',
    Version: 'E4.0',
    name: 'family: man, boy',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F466', '200D', '1F466'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66',
    Version: 'E4.0',
    name: 'family: man, boy, boy',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F467'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDC67',
    Version: 'E4.0',
    name: 'family: man, girl',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F467', '200D', '1F466'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66',
    Version: 'E4.0',
    name: 'family: man, girl, boy',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F468', '200D', '1F467', '200D', '1F467'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67',
    Version: 'E4.0',
    name: 'family: man, girl, girl',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F466'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83D\uDC66',
    Version: 'E4.0',
    name: 'family: woman, boy',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F466', '200D', '1F466'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66',
    Version: 'E4.0',
    name: 'family: woman, boy, boy',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F467'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83D\uDC67',
    Version: 'E4.0',
    name: 'family: woman, girl',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F467', '200D', '1F466'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66',
    Version: 'E4.0',
    name: 'family: woman, girl, boy',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F469', '200D', '1F467', '200D', '1F467'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67',
    Version: 'E4.0',
    name: 'family: woman, girl, girl',
    category: 'People \u0026 Body',
    SubGroup: 'family'
  },
  {
    CodePointsHex: ['1F5E3', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDE3\uFE0F',
    Version: 'E0.7',
    name: 'speaking head',
    category: 'People \u0026 Body',
    SubGroup: 'person-symbol'
  },
  {
    CodePointsHex: ['1F5E3'],
    Status: 'unqualified',
    char: '\uD83D\uDDE3',
    Version: 'E0.7',
    name: 'speaking head',
    category: 'People \u0026 Body',
    SubGroup: 'person-symbol'
  },
  {
    CodePointsHex: ['1F464'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC64',
    Version: 'E0.6',
    name: 'bust in silhouette',
    category: 'People \u0026 Body',
    SubGroup: 'person-symbol'
  },
  {
    CodePointsHex: ['1F465'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC65',
    Version: 'E1.0',
    name: 'busts in silhouette',
    category: 'People \u0026 Body',
    SubGroup: 'person-symbol'
  },
  {
    CodePointsHex: ['1FAC2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC2',
    Version: 'E13.0',
    name: 'people hugging',
    category: 'People \u0026 Body',
    SubGroup: 'person-symbol'
  },
  {
    CodePointsHex: ['1F46A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC6A',
    Version: 'E0.6',
    name: 'family',
    category: 'People \u0026 Body',
    SubGroup: 'person-symbol'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F9D1', '200D', '1F9D2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDDD1\u200D\uD83E\uDDD2',
    Version: 'E15.1',
    name: 'family: adult, adult, child',
    category: 'People \u0026 Body',
    SubGroup: 'person-symbol'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F9D1', '200D', '1F9D2', '200D', '1F9D2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDDD1\u200D\uD83E\uDDD2\u200D\uD83E\uDDD2',
    Version: 'E15.1',
    name: 'family: adult, adult, child, child',
    category: 'People \u0026 Body',
    SubGroup: 'person-symbol'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F9D2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDDD2',
    Version: 'E15.1',
    name: 'family: adult, child',
    category: 'People \u0026 Body',
    SubGroup: 'person-symbol'
  },
  {
    CodePointsHex: ['1F9D1', '200D', '1F9D2', '200D', '1F9D2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDD1\u200D\uD83E\uDDD2\u200D\uD83E\uDDD2',
    Version: 'E15.1',
    name: 'family: adult, child, child',
    category: 'People \u0026 Body',
    SubGroup: 'person-symbol'
  },
  {
    CodePointsHex: ['1F463'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC63',
    Version: 'E0.6',
    name: 'footprints',
    category: 'People \u0026 Body',
    SubGroup: 'person-symbol'
  },
  {
    CodePointsHex: ['1FAC6'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEC6',
    Version: 'E16.0',
    name: 'fingerprint',
    category: 'People \u0026 Body',
    SubGroup: 'person-symbol'
  },
  {
    CodePointsHex: ['1F3FB'],
    Status: 'component',
    char: '\uD83C\uDFFB',
    Version: 'E1.0',
    name: 'light skin tone',
    category: 'Component',
    SubGroup: 'skin-tone'
  },
  {
    CodePointsHex: ['1F3FC'],
    Status: 'component',
    char: '\uD83C\uDFFC',
    Version: 'E1.0',
    name: 'medium-light skin tone',
    category: 'Component',
    SubGroup: 'skin-tone'
  },
  {
    CodePointsHex: ['1F3FD'],
    Status: 'component',
    char: '\uD83C\uDFFD',
    Version: 'E1.0',
    name: 'medium skin tone',
    category: 'Component',
    SubGroup: 'skin-tone'
  },
  {
    CodePointsHex: ['1F3FE'],
    Status: 'component',
    char: '\uD83C\uDFFE',
    Version: 'E1.0',
    name: 'medium-dark skin tone',
    category: 'Component',
    SubGroup: 'skin-tone'
  },
  {
    CodePointsHex: ['1F3FF'],
    Status: 'component',
    char: '\uD83C\uDFFF',
    Version: 'E1.0',
    name: 'dark skin tone',
    category: 'Component',
    SubGroup: 'skin-tone'
  },
  {
    CodePointsHex: ['1F9B0'],
    Status: 'component',
    char: '\uD83E\uDDB0',
    Version: 'E11.0',
    name: 'red hair',
    category: 'Component',
    SubGroup: 'hair-style'
  },
  {
    CodePointsHex: ['1F9B1'],
    Status: 'component',
    char: '\uD83E\uDDB1',
    Version: 'E11.0',
    name: 'curly hair',
    category: 'Component',
    SubGroup: 'hair-style'
  },
  {
    CodePointsHex: ['1F9B3'],
    Status: 'component',
    char: '\uD83E\uDDB3',
    Version: 'E11.0',
    name: 'white hair',
    category: 'Component',
    SubGroup: 'hair-style'
  },
  {
    CodePointsHex: ['1F9B2'],
    Status: 'component',
    char: '\uD83E\uDDB2',
    Version: 'E11.0',
    name: 'bald',
    category: 'Component',
    SubGroup: 'hair-style'
  },
  {
    CodePointsHex: ['1F435'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC35',
    Version: 'E0.6',
    name: 'monkey face',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F412'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC12',
    Version: 'E0.6',
    name: 'monkey',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F98D'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD8D',
    Version: 'E3.0',
    name: 'gorilla',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F9A7'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDA7',
    Version: 'E12.0',
    name: 'orangutan',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F436'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC36',
    Version: 'E0.6',
    name: 'dog face',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F415'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC15',
    Version: 'E0.7',
    name: 'dog',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F9AE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDAE',
    Version: 'E12.0',
    name: 'guide dog',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F415', '200D', '1F9BA'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC15\u200D\uD83E\uDDBA',
    Version: 'E12.0',
    name: 'service dog',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F429'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC29',
    Version: 'E0.6',
    name: 'poodle',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F43A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC3A',
    Version: 'E0.6',
    name: 'wolf',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F98A'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD8A',
    Version: 'E3.0',
    name: 'fox',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F99D'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD9D',
    Version: 'E11.0',
    name: 'raccoon',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F431'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC31',
    Version: 'E0.6',
    name: 'cat face',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F408'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC08',
    Version: 'E0.7',
    name: 'cat',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F408', '200D', '2B1B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC08\u200D\u2B1B',
    Version: 'E13.0',
    name: 'black cat',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F981'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD81',
    Version: 'E1.0',
    name: 'lion',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F42F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC2F',
    Version: 'E0.6',
    name: 'tiger face',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F405'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC05',
    Version: 'E1.0',
    name: 'tiger',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F406'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC06',
    Version: 'E1.0',
    name: 'leopard',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F434'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC34',
    Version: 'E0.6',
    name: 'horse face',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1FACE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDECE',
    Version: 'E15.0',
    name: 'moose',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1FACF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDECF',
    Version: 'E15.0',
    name: 'donkey',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F40E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC0E',
    Version: 'E0.6',
    name: 'horse',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F984'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD84',
    Version: 'E1.0',
    name: 'unicorn',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F993'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD93',
    Version: 'E5.0',
    name: 'zebra',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F98C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD8C',
    Version: 'E3.0',
    name: 'deer',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F9AC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDAC',
    Version: 'E13.0',
    name: 'bison',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F42E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC2E',
    Version: 'E0.6',
    name: 'cow face',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F402'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC02',
    Version: 'E1.0',
    name: 'ox',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F403'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC03',
    Version: 'E1.0',
    name: 'water buffalo',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F404'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC04',
    Version: 'E1.0',
    name: 'cow',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F437'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC37',
    Version: 'E0.6',
    name: 'pig face',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F416'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC16',
    Version: 'E1.0',
    name: 'pig',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F417'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC17',
    Version: 'E0.6',
    name: 'boar',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F43D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC3D',
    Version: 'E0.6',
    name: 'pig nose',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F40F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC0F',
    Version: 'E1.0',
    name: 'ram',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F411'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC11',
    Version: 'E0.6',
    name: 'ewe',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F410'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC10',
    Version: 'E1.0',
    name: 'goat',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F42A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC2A',
    Version: 'E1.0',
    name: 'camel',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F42B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC2B',
    Version: 'E0.6',
    name: 'two-hump camel',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F999'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD99',
    Version: 'E11.0',
    name: 'llama',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F992'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD92',
    Version: 'E5.0',
    name: 'giraffe',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F418'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC18',
    Version: 'E0.6',
    name: 'elephant',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F9A3'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDA3',
    Version: 'E13.0',
    name: 'mammoth',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F98F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD8F',
    Version: 'E3.0',
    name: 'rhinoceros',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F99B'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD9B',
    Version: 'E11.0',
    name: 'hippopotamus',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F42D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC2D',
    Version: 'E0.6',
    name: 'mouse face',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F401'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC01',
    Version: 'E1.0',
    name: 'mouse',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F400'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC00',
    Version: 'E1.0',
    name: 'rat',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F439'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC39',
    Version: 'E0.6',
    name: 'hamster',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F430'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC30',
    Version: 'E0.6',
    name: 'rabbit face',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F407'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC07',
    Version: 'E1.0',
    name: 'rabbit',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F43F', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC3F\uFE0F',
    Version: 'E0.7',
    name: 'chipmunk',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F43F'],
    Status: 'unqualified',
    char: '\uD83D\uDC3F',
    Version: 'E0.7',
    name: 'chipmunk',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F9AB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDAB',
    Version: 'E13.0',
    name: 'beaver',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F994'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD94',
    Version: 'E5.0',
    name: 'hedgehog',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F987'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD87',
    Version: 'E3.0',
    name: 'bat',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F43B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC3B',
    Version: 'E0.6',
    name: 'bear',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F43B', '200D', '2744', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC3B\u200D\u2744\uFE0F',
    Version: 'E13.0',
    name: 'polar bear',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F43B', '200D', '2744'],
    Status: 'minimally-qualified',
    char: '\uD83D\uDC3B\u200D\u2744',
    Version: 'E13.0',
    name: 'polar bear',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F428'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC28',
    Version: 'E0.6',
    name: 'koala',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F43C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC3C',
    Version: 'E0.6',
    name: 'panda',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F9A5'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDA5',
    Version: 'E12.0',
    name: 'sloth',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F9A6'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDA6',
    Version: 'E12.0',
    name: 'otter',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F9A8'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDA8',
    Version: 'E12.0',
    name: 'skunk',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F998'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD98',
    Version: 'E11.0',
    name: 'kangaroo',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F9A1'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDA1',
    Version: 'E11.0',
    name: 'badger',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F43E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC3E',
    Version: 'E0.6',
    name: 'paw prints',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-mammal'
  },
  {
    CodePointsHex: ['1F983'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD83',
    Version: 'E1.0',
    name: 'turkey',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F414'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC14',
    Version: 'E0.6',
    name: 'chicken',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F413'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC13',
    Version: 'E1.0',
    name: 'rooster',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F423'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC23',
    Version: 'E0.6',
    name: 'hatching chick',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F424'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC24',
    Version: 'E0.6',
    name: 'baby chick',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F425'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC25',
    Version: 'E0.6',
    name: 'front-facing baby chick',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F426'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC26',
    Version: 'E0.6',
    name: 'bird',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F427'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC27',
    Version: 'E0.6',
    name: 'penguin',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F54A', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD4A\uFE0F',
    Version: 'E0.7',
    name: 'dove',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F54A'],
    Status: 'unqualified',
    char: '\uD83D\uDD4A',
    Version: 'E0.7',
    name: 'dove',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F985'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD85',
    Version: 'E3.0',
    name: 'eagle',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F986'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD86',
    Version: 'E3.0',
    name: 'duck',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F9A2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDA2',
    Version: 'E11.0',
    name: 'swan',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F989'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD89',
    Version: 'E3.0',
    name: 'owl',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F9A4'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDA4',
    Version: 'E13.0',
    name: 'dodo',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1FAB6'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEB6',
    Version: 'E13.0',
    name: 'feather',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F9A9'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDA9',
    Version: 'E12.0',
    name: 'flamingo',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F99A'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD9A',
    Version: 'E11.0',
    name: 'peacock',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F99C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD9C',
    Version: 'E11.0',
    name: 'parrot',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1FABD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEBD',
    Version: 'E15.0',
    name: 'wing',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F426', '200D', '2B1B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC26\u200D\u2B1B',
    Version: 'E15.0',
    name: 'black bird',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1FABF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEBF',
    Version: 'E15.0',
    name: 'goose',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F426', '200D', '1F525'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC26\u200D\uD83D\uDD25',
    Version: 'E15.1',
    name: 'phoenix',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bird'
  },
  {
    CodePointsHex: ['1F438'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC38',
    Version: 'E0.6',
    name: 'frog',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-amphibian'
  },
  {
    CodePointsHex: ['1F40A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC0A',
    Version: 'E1.0',
    name: 'crocodile',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-reptile'
  },
  {
    CodePointsHex: ['1F422'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC22',
    Version: 'E0.6',
    name: 'turtle',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-reptile'
  },
  {
    CodePointsHex: ['1F98E'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD8E',
    Version: 'E3.0',
    name: 'lizard',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-reptile'
  },
  {
    CodePointsHex: ['1F40D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC0D',
    Version: 'E0.6',
    name: 'snake',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-reptile'
  },
  {
    CodePointsHex: ['1F432'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC32',
    Version: 'E0.6',
    name: 'dragon face',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-reptile'
  },
  {
    CodePointsHex: ['1F409'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC09',
    Version: 'E1.0',
    name: 'dragon',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-reptile'
  },
  {
    CodePointsHex: ['1F995'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD95',
    Version: 'E5.0',
    name: 'sauropod',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-reptile'
  },
  {
    CodePointsHex: ['1F996'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD96',
    Version: 'E5.0',
    name: 'T-Rex',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-reptile'
  },
  {
    CodePointsHex: ['1F433'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC33',
    Version: 'E0.6',
    name: 'spouting whale',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-marine'
  },
  {
    CodePointsHex: ['1F40B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC0B',
    Version: 'E1.0',
    name: 'whale',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-marine'
  },
  {
    CodePointsHex: ['1F42C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC2C',
    Version: 'E0.6',
    name: 'dolphin',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-marine'
  },
  {
    CodePointsHex: ['1FACD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDECD',
    Version: 'E17.0',
    name: 'orca',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-marine'
  },
  {
    CodePointsHex: ['1F9AD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDAD',
    Version: 'E13.0',
    name: 'seal',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-marine'
  },
  {
    CodePointsHex: ['1F41F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC1F',
    Version: 'E0.6',
    name: 'fish',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-marine'
  },
  {
    CodePointsHex: ['1F420'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC20',
    Version: 'E0.6',
    name: 'tropical fish',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-marine'
  },
  {
    CodePointsHex: ['1F421'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC21',
    Version: 'E0.6',
    name: 'blowfish',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-marine'
  },
  {
    CodePointsHex: ['1F988'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD88',
    Version: 'E3.0',
    name: 'shark',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-marine'
  },
  {
    CodePointsHex: ['1F419'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC19',
    Version: 'E0.6',
    name: 'octopus',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-marine'
  },
  {
    CodePointsHex: ['1F41A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC1A',
    Version: 'E0.6',
    name: 'spiral shell',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-marine'
  },
  {
    CodePointsHex: ['1FAB8'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEB8',
    Version: 'E14.0',
    name: 'coral',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-marine'
  },
  {
    CodePointsHex: ['1FABC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEBC',
    Version: 'E15.0',
    name: 'jellyfish',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-marine'
  },
  {
    CodePointsHex: ['1F980'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD80',
    Version: 'E1.0',
    name: 'crab',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-marine'
  },
  {
    CodePointsHex: ['1F99E'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD9E',
    Version: 'E11.0',
    name: 'lobster',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-marine'
  },
  {
    CodePointsHex: ['1F990'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD90',
    Version: 'E3.0',
    name: 'shrimp',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-marine'
  },
  {
    CodePointsHex: ['1F991'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD91',
    Version: 'E3.0',
    name: 'squid',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-marine'
  },
  {
    CodePointsHex: ['1F9AA'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDAA',
    Version: 'E12.0',
    name: 'oyster',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-marine'
  },
  {
    CodePointsHex: ['1F40C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC0C',
    Version: 'E0.6',
    name: 'snail',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bug'
  },
  {
    CodePointsHex: ['1F98B'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD8B',
    Version: 'E3.0',
    name: 'butterfly',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bug'
  },
  {
    CodePointsHex: ['1F41B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC1B',
    Version: 'E0.6',
    name: 'bug',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bug'
  },
  {
    CodePointsHex: ['1F41C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC1C',
    Version: 'E0.6',
    name: 'ant',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bug'
  },
  {
    CodePointsHex: ['1F41D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC1D',
    Version: 'E0.6',
    name: 'honeybee',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bug'
  },
  {
    CodePointsHex: ['1FAB2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEB2',
    Version: 'E13.0',
    name: 'beetle',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bug'
  },
  {
    CodePointsHex: ['1F41E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC1E',
    Version: 'E0.6',
    name: 'lady beetle',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bug'
  },
  {
    CodePointsHex: ['1F997'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD97',
    Version: 'E5.0',
    name: 'cricket',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bug'
  },
  {
    CodePointsHex: ['1FAB3'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEB3',
    Version: 'E13.0',
    name: 'cockroach',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bug'
  },
  {
    CodePointsHex: ['1F577', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD77\uFE0F',
    Version: 'E0.7',
    name: 'spider',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bug'
  },
  {
    CodePointsHex: ['1F577'],
    Status: 'unqualified',
    char: '\uD83D\uDD77',
    Version: 'E0.7',
    name: 'spider',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bug'
  },
  {
    CodePointsHex: ['1F578', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD78\uFE0F',
    Version: 'E0.7',
    name: 'spider web',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bug'
  },
  {
    CodePointsHex: ['1F578'],
    Status: 'unqualified',
    char: '\uD83D\uDD78',
    Version: 'E0.7',
    name: 'spider web',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bug'
  },
  {
    CodePointsHex: ['1F982'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD82',
    Version: 'E1.0',
    name: 'scorpion',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bug'
  },
  {
    CodePointsHex: ['1F99F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD9F',
    Version: 'E11.0',
    name: 'mosquito',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bug'
  },
  {
    CodePointsHex: ['1FAB0'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEB0',
    Version: 'E13.0',
    name: 'fly',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bug'
  },
  {
    CodePointsHex: ['1FAB1'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEB1',
    Version: 'E13.0',
    name: 'worm',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bug'
  },
  {
    CodePointsHex: ['1F9A0'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDA0',
    Version: 'E11.0',
    name: 'microbe',
    category: 'Animals \u0026 Nature',
    SubGroup: 'animal-bug'
  },
  {
    CodePointsHex: ['1F490'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC90',
    Version: 'E0.6',
    name: 'bouquet',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-flower'
  },
  {
    CodePointsHex: ['1F338'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF38',
    Version: 'E0.6',
    name: 'cherry blossom',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-flower'
  },
  {
    CodePointsHex: ['1F4AE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCAE',
    Version: 'E0.6',
    name: 'white flower',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-flower'
  },
  {
    CodePointsHex: ['1FAB7'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEB7',
    Version: 'E14.0',
    name: 'lotus',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-flower'
  },
  {
    CodePointsHex: ['1F3F5', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFF5\uFE0F',
    Version: 'E0.7',
    name: 'rosette',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-flower'
  },
  {
    CodePointsHex: ['1F3F5'],
    Status: 'unqualified',
    char: '\uD83C\uDFF5',
    Version: 'E0.7',
    name: 'rosette',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-flower'
  },
  {
    CodePointsHex: ['1F339'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF39',
    Version: 'E0.6',
    name: 'rose',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-flower'
  },
  {
    CodePointsHex: ['1F940'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD40',
    Version: 'E3.0',
    name: 'wilted flower',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-flower'
  },
  {
    CodePointsHex: ['1F33A'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF3A',
    Version: 'E0.6',
    name: 'hibiscus',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-flower'
  },
  {
    CodePointsHex: ['1F33B'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF3B',
    Version: 'E0.6',
    name: 'sunflower',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-flower'
  },
  {
    CodePointsHex: ['1F33C'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF3C',
    Version: 'E0.6',
    name: 'blossom',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-flower'
  },
  {
    CodePointsHex: ['1F337'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF37',
    Version: 'E0.6',
    name: 'tulip',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-flower'
  },
  {
    CodePointsHex: ['1FABB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEBB',
    Version: 'E15.0',
    name: 'hyacinth',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-flower'
  },
  {
    CodePointsHex: ['1F331'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF31',
    Version: 'E0.6',
    name: 'seedling',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-other'
  },
  {
    CodePointsHex: ['1FAB4'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEB4',
    Version: 'E13.0',
    name: 'potted plant',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-other'
  },
  {
    CodePointsHex: ['1F332'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF32',
    Version: 'E1.0',
    name: 'evergreen tree',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-other'
  },
  {
    CodePointsHex: ['1F333'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF33',
    Version: 'E1.0',
    name: 'deciduous tree',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-other'
  },
  {
    CodePointsHex: ['1F334'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF34',
    Version: 'E0.6',
    name: 'palm tree',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-other'
  },
  {
    CodePointsHex: ['1F335'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF35',
    Version: 'E0.6',
    name: 'cactus',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-other'
  },
  {
    CodePointsHex: ['1F33E'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF3E',
    Version: 'E0.6',
    name: 'sheaf of rice',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-other'
  },
  {
    CodePointsHex: ['1F33F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF3F',
    Version: 'E0.6',
    name: 'herb',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-other'
  },
  {
    CodePointsHex: ['2618', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2618\uFE0F',
    Version: 'E1.0',
    name: 'shamrock',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-other'
  },
  {
    CodePointsHex: ['2618'],
    Status: 'unqualified',
    char: '\u2618',
    Version: 'E1.0',
    name: 'shamrock',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-other'
  },
  {
    CodePointsHex: ['1F340'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF40',
    Version: 'E0.6',
    name: 'four leaf clover',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-other'
  },
  {
    CodePointsHex: ['1F341'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF41',
    Version: 'E0.6',
    name: 'maple leaf',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-other'
  },
  {
    CodePointsHex: ['1F342'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF42',
    Version: 'E0.6',
    name: 'fallen leaf',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-other'
  },
  {
    CodePointsHex: ['1F343'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF43',
    Version: 'E0.6',
    name: 'leaf fluttering in wind',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-other'
  },
  {
    CodePointsHex: ['1FAB9'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEB9',
    Version: 'E14.0',
    name: 'empty nest',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-other'
  },
  {
    CodePointsHex: ['1FABA'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEBA',
    Version: 'E14.0',
    name: 'nest with eggs',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-other'
  },
  {
    CodePointsHex: ['1F344'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF44',
    Version: 'E0.6',
    name: 'mushroom',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-other'
  },
  {
    CodePointsHex: ['1FABE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEBE',
    Version: 'E16.0',
    name: 'leafless tree',
    category: 'Animals \u0026 Nature',
    SubGroup: 'plant-other'
  },
  {
    CodePointsHex: ['1F347'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF47',
    Version: 'E0.6',
    name: 'grapes',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1F348'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF48',
    Version: 'E0.6',
    name: 'melon',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1F349'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF49',
    Version: 'E0.6',
    name: 'watermelon',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1F34A'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF4A',
    Version: 'E0.6',
    name: 'tangerine',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1F34B'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF4B',
    Version: 'E1.0',
    name: 'lemon',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1F34B', '200D', '1F7E9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF4B\u200D\uD83D\uDFE9',
    Version: 'E15.1',
    name: 'lime',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1F34C'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF4C',
    Version: 'E0.6',
    name: 'banana',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1F34D'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF4D',
    Version: 'E0.6',
    name: 'pineapple',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1F96D'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD6D',
    Version: 'E11.0',
    name: 'mango',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1F34E'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF4E',
    Version: 'E0.6',
    name: 'red apple',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1F34F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF4F',
    Version: 'E0.6',
    name: 'green apple',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1F350'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF50',
    Version: 'E1.0',
    name: 'pear',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1F351'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF51',
    Version: 'E0.6',
    name: 'peach',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1F352'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF52',
    Version: 'E0.6',
    name: 'cherries',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1F353'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF53',
    Version: 'E0.6',
    name: 'strawberry',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1FAD0'],
    Status: 'fully-qualified',
    char: '\uD83E\uDED0',
    Version: 'E13.0',
    name: 'blueberries',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1F95D'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD5D',
    Version: 'E3.0',
    name: 'kiwi fruit',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1F345'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF45',
    Version: 'E0.6',
    name: 'tomato',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1FAD2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDED2',
    Version: 'E13.0',
    name: 'olive',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1F965'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD65',
    Version: 'E5.0',
    name: 'coconut',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-fruit'
  },
  {
    CodePointsHex: ['1F951'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD51',
    Version: 'E3.0',
    name: 'avocado',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1F346'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF46',
    Version: 'E0.6',
    name: 'eggplant',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1F954'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD54',
    Version: 'E3.0',
    name: 'potato',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1F955'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD55',
    Version: 'E3.0',
    name: 'carrot',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1F33D'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF3D',
    Version: 'E0.6',
    name: 'ear of corn',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1F336', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF36\uFE0F',
    Version: 'E0.7',
    name: 'hot pepper',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1F336'],
    Status: 'unqualified',
    char: '\uD83C\uDF36',
    Version: 'E0.7',
    name: 'hot pepper',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1FAD1'],
    Status: 'fully-qualified',
    char: '\uD83E\uDED1',
    Version: 'E13.0',
    name: 'bell pepper',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1F952'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD52',
    Version: 'E3.0',
    name: 'cucumber',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1F96C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD6C',
    Version: 'E11.0',
    name: 'leafy green',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1F966'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD66',
    Version: 'E5.0',
    name: 'broccoli',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1F9C4'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDC4',
    Version: 'E12.0',
    name: 'garlic',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1F9C5'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDC5',
    Version: 'E12.0',
    name: 'onion',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1F95C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD5C',
    Version: 'E3.0',
    name: 'peanuts',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1FAD8'],
    Status: 'fully-qualified',
    char: '\uD83E\uDED8',
    Version: 'E14.0',
    name: 'beans',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1F330'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF30',
    Version: 'E0.6',
    name: 'chestnut',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1FADA'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEDA',
    Version: 'E15.0',
    name: 'ginger root',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1FADB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEDB',
    Version: 'E15.0',
    name: 'pea pod',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1F344', '200D', '1F7EB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF44\u200D\uD83D\uDFEB',
    Version: 'E15.1',
    name: 'brown mushroom',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1FADC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEDC',
    Version: 'E16.0',
    name: 'root vegetable',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-vegetable'
  },
  {
    CodePointsHex: ['1F35E'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF5E',
    Version: 'E0.6',
    name: 'bread',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F950'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD50',
    Version: 'E3.0',
    name: 'croissant',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F956'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD56',
    Version: 'E3.0',
    name: 'baguette bread',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1FAD3'],
    Status: 'fully-qualified',
    char: '\uD83E\uDED3',
    Version: 'E13.0',
    name: 'flatbread',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F968'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD68',
    Version: 'E5.0',
    name: 'pretzel',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F96F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD6F',
    Version: 'E11.0',
    name: 'bagel',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F95E'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD5E',
    Version: 'E3.0',
    name: 'pancakes',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F9C7'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDC7',
    Version: 'E12.0',
    name: 'waffle',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F9C0'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDC0',
    Version: 'E1.0',
    name: 'cheese wedge',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F356'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF56',
    Version: 'E0.6',
    name: 'meat on bone',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F357'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF57',
    Version: 'E0.6',
    name: 'poultry leg',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F969'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD69',
    Version: 'E5.0',
    name: 'cut of meat',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F953'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD53',
    Version: 'E3.0',
    name: 'bacon',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F354'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF54',
    Version: 'E0.6',
    name: 'hamburger',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F35F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF5F',
    Version: 'E0.6',
    name: 'french fries',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F355'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF55',
    Version: 'E0.6',
    name: 'pizza',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F32D'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF2D',
    Version: 'E1.0',
    name: 'hot dog',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F96A'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD6A',
    Version: 'E5.0',
    name: 'sandwich',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F32E'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF2E',
    Version: 'E1.0',
    name: 'taco',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F32F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF2F',
    Version: 'E1.0',
    name: 'burrito',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1FAD4'],
    Status: 'fully-qualified',
    char: '\uD83E\uDED4',
    Version: 'E13.0',
    name: 'tamale',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F959'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD59',
    Version: 'E3.0',
    name: 'stuffed flatbread',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F9C6'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDC6',
    Version: 'E12.0',
    name: 'falafel',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F95A'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD5A',
    Version: 'E3.0',
    name: 'egg',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F373'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF73',
    Version: 'E0.6',
    name: 'cooking',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F958'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD58',
    Version: 'E3.0',
    name: 'shallow pan of food',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F372'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF72',
    Version: 'E0.6',
    name: 'pot of food',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1FAD5'],
    Status: 'fully-qualified',
    char: '\uD83E\uDED5',
    Version: 'E13.0',
    name: 'fondue',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F963'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD63',
    Version: 'E5.0',
    name: 'bowl with spoon',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F957'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD57',
    Version: 'E3.0',
    name: 'green salad',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F37F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF7F',
    Version: 'E1.0',
    name: 'popcorn',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F9C8'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDC8',
    Version: 'E12.0',
    name: 'butter',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F9C2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDC2',
    Version: 'E11.0',
    name: 'salt',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F96B'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD6B',
    Version: 'E5.0',
    name: 'canned food',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-prepared'
  },
  {
    CodePointsHex: ['1F371'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF71',
    Version: 'E0.6',
    name: 'bento box',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-asian'
  },
  {
    CodePointsHex: ['1F358'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF58',
    Version: 'E0.6',
    name: 'rice cracker',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-asian'
  },
  {
    CodePointsHex: ['1F359'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF59',
    Version: 'E0.6',
    name: 'rice ball',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-asian'
  },
  {
    CodePointsHex: ['1F35A'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF5A',
    Version: 'E0.6',
    name: 'cooked rice',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-asian'
  },
  {
    CodePointsHex: ['1F35B'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF5B',
    Version: 'E0.6',
    name: 'curry rice',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-asian'
  },
  {
    CodePointsHex: ['1F35C'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF5C',
    Version: 'E0.6',
    name: 'steaming bowl',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-asian'
  },
  {
    CodePointsHex: ['1F35D'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF5D',
    Version: 'E0.6',
    name: 'spaghetti',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-asian'
  },
  {
    CodePointsHex: ['1F360'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF60',
    Version: 'E0.6',
    name: 'roasted sweet potato',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-asian'
  },
  {
    CodePointsHex: ['1F362'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF62',
    Version: 'E0.6',
    name: 'oden',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-asian'
  },
  {
    CodePointsHex: ['1F363'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF63',
    Version: 'E0.6',
    name: 'sushi',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-asian'
  },
  {
    CodePointsHex: ['1F364'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF64',
    Version: 'E0.6',
    name: 'fried shrimp',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-asian'
  },
  {
    CodePointsHex: ['1F365'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF65',
    Version: 'E0.6',
    name: 'fish cake with swirl',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-asian'
  },
  {
    CodePointsHex: ['1F96E'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD6E',
    Version: 'E11.0',
    name: 'moon cake',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-asian'
  },
  {
    CodePointsHex: ['1F361'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF61',
    Version: 'E0.6',
    name: 'dango',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-asian'
  },
  {
    CodePointsHex: ['1F95F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD5F',
    Version: 'E5.0',
    name: 'dumpling',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-asian'
  },
  {
    CodePointsHex: ['1F960'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD60',
    Version: 'E5.0',
    name: 'fortune cookie',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-asian'
  },
  {
    CodePointsHex: ['1F961'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD61',
    Version: 'E5.0',
    name: 'takeout box',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-asian'
  },
  {
    CodePointsHex: ['1F366'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF66',
    Version: 'E0.6',
    name: 'soft ice cream',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-sweet'
  },
  {
    CodePointsHex: ['1F367'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF67',
    Version: 'E0.6',
    name: 'shaved ice',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-sweet'
  },
  {
    CodePointsHex: ['1F368'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF68',
    Version: 'E0.6',
    name: 'ice cream',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-sweet'
  },
  {
    CodePointsHex: ['1F369'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF69',
    Version: 'E0.6',
    name: 'doughnut',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-sweet'
  },
  {
    CodePointsHex: ['1F36A'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF6A',
    Version: 'E0.6',
    name: 'cookie',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-sweet'
  },
  {
    CodePointsHex: ['1F382'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF82',
    Version: 'E0.6',
    name: 'birthday cake',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-sweet'
  },
  {
    CodePointsHex: ['1F370'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF70',
    Version: 'E0.6',
    name: 'shortcake',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-sweet'
  },
  {
    CodePointsHex: ['1F9C1'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDC1',
    Version: 'E11.0',
    name: 'cupcake',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-sweet'
  },
  {
    CodePointsHex: ['1F967'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD67',
    Version: 'E5.0',
    name: 'pie',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-sweet'
  },
  {
    CodePointsHex: ['1F36B'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF6B',
    Version: 'E0.6',
    name: 'chocolate bar',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-sweet'
  },
  {
    CodePointsHex: ['1F36C'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF6C',
    Version: 'E0.6',
    name: 'candy',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-sweet'
  },
  {
    CodePointsHex: ['1F36D'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF6D',
    Version: 'E0.6',
    name: 'lollipop',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-sweet'
  },
  {
    CodePointsHex: ['1F36E'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF6E',
    Version: 'E0.6',
    name: 'custard',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-sweet'
  },
  {
    CodePointsHex: ['1F36F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF6F',
    Version: 'E0.6',
    name: 'honey pot',
    category: 'Food \u0026 Drink',
    SubGroup: 'food-sweet'
  },
  {
    CodePointsHex: ['1F37C'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF7C',
    Version: 'E1.0',
    name: 'baby bottle',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1F95B'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD5B',
    Version: 'E3.0',
    name: 'glass of milk',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['2615'],
    Status: 'fully-qualified',
    char: '\u2615',
    Version: 'E0.6',
    name: 'hot beverage',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1FAD6'],
    Status: 'fully-qualified',
    char: '\uD83E\uDED6',
    Version: 'E13.0',
    name: 'teapot',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1F375'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF75',
    Version: 'E0.6',
    name: 'teacup without handle',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1F376'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF76',
    Version: 'E0.6',
    name: 'sake',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1F37E'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF7E',
    Version: 'E1.0',
    name: 'bottle with popping cork',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1F377'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF77',
    Version: 'E0.6',
    name: 'wine glass',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1F378'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF78',
    Version: 'E0.6',
    name: 'cocktail glass',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1F379'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF79',
    Version: 'E0.6',
    name: 'tropical drink',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1F37A'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF7A',
    Version: 'E0.6',
    name: 'beer mug',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1F37B'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF7B',
    Version: 'E0.6',
    name: 'clinking beer mugs',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1F942'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD42',
    Version: 'E3.0',
    name: 'clinking glasses',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1F943'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD43',
    Version: 'E3.0',
    name: 'tumbler glass',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1FAD7'],
    Status: 'fully-qualified',
    char: '\uD83E\uDED7',
    Version: 'E14.0',
    name: 'pouring liquid',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1F964'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD64',
    Version: 'E5.0',
    name: 'cup with straw',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1F9CB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCB',
    Version: 'E13.0',
    name: 'bubble tea',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1F9C3'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDC3',
    Version: 'E12.0',
    name: 'beverage box',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1F9C9'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDC9',
    Version: 'E12.0',
    name: 'mate',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1F9CA'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDCA',
    Version: 'E12.0',
    name: 'ice',
    category: 'Food \u0026 Drink',
    SubGroup: 'drink'
  },
  {
    CodePointsHex: ['1F962'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD62',
    Version: 'E5.0',
    name: 'chopsticks',
    category: 'Food \u0026 Drink',
    SubGroup: 'dishware'
  },
  {
    CodePointsHex: ['1F37D', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF7D\uFE0F',
    Version: 'E0.7',
    name: 'fork and knife with plate',
    category: 'Food \u0026 Drink',
    SubGroup: 'dishware'
  },
  {
    CodePointsHex: ['1F37D'],
    Status: 'unqualified',
    char: '\uD83C\uDF7D',
    Version: 'E0.7',
    name: 'fork and knife with plate',
    category: 'Food \u0026 Drink',
    SubGroup: 'dishware'
  },
  {
    CodePointsHex: ['1F374'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF74',
    Version: 'E0.6',
    name: 'fork and knife',
    category: 'Food \u0026 Drink',
    SubGroup: 'dishware'
  },
  {
    CodePointsHex: ['1F944'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD44',
    Version: 'E3.0',
    name: 'spoon',
    category: 'Food \u0026 Drink',
    SubGroup: 'dishware'
  },
  {
    CodePointsHex: ['1F52A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD2A',
    Version: 'E0.6',
    name: 'kitchen knife',
    category: 'Food \u0026 Drink',
    SubGroup: 'dishware'
  },
  {
    CodePointsHex: ['1FAD9'],
    Status: 'fully-qualified',
    char: '\uD83E\uDED9',
    Version: 'E14.0',
    name: 'jar',
    category: 'Food \u0026 Drink',
    SubGroup: 'dishware'
  },
  {
    CodePointsHex: ['1F3FA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFFA',
    Version: 'E1.0',
    name: 'amphora',
    category: 'Food \u0026 Drink',
    SubGroup: 'dishware'
  },
  {
    CodePointsHex: ['1F30D'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF0D',
    Version: 'E0.7',
    name: 'globe showing Europe-Africa',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-map'
  },
  {
    CodePointsHex: ['1F30E'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF0E',
    Version: 'E0.7',
    name: 'globe showing Americas',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-map'
  },
  {
    CodePointsHex: ['1F30F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF0F',
    Version: 'E0.6',
    name: 'globe showing Asia-Australia',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-map'
  },
  {
    CodePointsHex: ['1F310'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF10',
    Version: 'E1.0',
    name: 'globe with meridians',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-map'
  },
  {
    CodePointsHex: ['1F5FA', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDFA\uFE0F',
    Version: 'E0.7',
    name: 'world map',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-map'
  },
  {
    CodePointsHex: ['1F5FA'],
    Status: 'unqualified',
    char: '\uD83D\uDDFA',
    Version: 'E0.7',
    name: 'world map',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-map'
  },
  {
    CodePointsHex: ['1F5FE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDFE',
    Version: 'E0.6',
    name: 'map of Japan',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-map'
  },
  {
    CodePointsHex: ['1F9ED'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDED',
    Version: 'E11.0',
    name: 'compass',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-map'
  },
  {
    CodePointsHex: ['1F3D4', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFD4\uFE0F',
    Version: 'E0.7',
    name: 'snow-capped mountain',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-geographic'
  },
  {
    CodePointsHex: ['1F3D4'],
    Status: 'unqualified',
    char: '\uD83C\uDFD4',
    Version: 'E0.7',
    name: 'snow-capped mountain',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-geographic'
  },
  {
    CodePointsHex: ['26F0', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26F0\uFE0F',
    Version: 'E0.7',
    name: 'mountain',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-geographic'
  },
  {
    CodePointsHex: ['26F0'],
    Status: 'unqualified',
    char: '\u26F0',
    Version: 'E0.7',
    name: 'mountain',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-geographic'
  },
  {
    CodePointsHex: ['1F6D8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDED8',
    Version: 'E17.0',
    name: 'landslide',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-geographic'
  },
  {
    CodePointsHex: ['1F30B'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF0B',
    Version: 'E0.6',
    name: 'volcano',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-geographic'
  },
  {
    CodePointsHex: ['1F5FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDFB',
    Version: 'E0.6',
    name: 'mount fuji',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-geographic'
  },
  {
    CodePointsHex: ['1F3D5', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFD5\uFE0F',
    Version: 'E0.7',
    name: 'camping',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-geographic'
  },
  {
    CodePointsHex: ['1F3D5'],
    Status: 'unqualified',
    char: '\uD83C\uDFD5',
    Version: 'E0.7',
    name: 'camping',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-geographic'
  },
  {
    CodePointsHex: ['1F3D6', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFD6\uFE0F',
    Version: 'E0.7',
    name: 'beach with umbrella',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-geographic'
  },
  {
    CodePointsHex: ['1F3D6'],
    Status: 'unqualified',
    char: '\uD83C\uDFD6',
    Version: 'E0.7',
    name: 'beach with umbrella',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-geographic'
  },
  {
    CodePointsHex: ['1F3DC', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFDC\uFE0F',
    Version: 'E0.7',
    name: 'desert',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-geographic'
  },
  {
    CodePointsHex: ['1F3DC'],
    Status: 'unqualified',
    char: '\uD83C\uDFDC',
    Version: 'E0.7',
    name: 'desert',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-geographic'
  },
  {
    CodePointsHex: ['1F3DD', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFDD\uFE0F',
    Version: 'E0.7',
    name: 'desert island',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-geographic'
  },
  {
    CodePointsHex: ['1F3DD'],
    Status: 'unqualified',
    char: '\uD83C\uDFDD',
    Version: 'E0.7',
    name: 'desert island',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-geographic'
  },
  {
    CodePointsHex: ['1F3DE', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFDE\uFE0F',
    Version: 'E0.7',
    name: 'national park',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-geographic'
  },
  {
    CodePointsHex: ['1F3DE'],
    Status: 'unqualified',
    char: '\uD83C\uDFDE',
    Version: 'E0.7',
    name: 'national park',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-geographic'
  },
  {
    CodePointsHex: ['1F3DF', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFDF\uFE0F',
    Version: 'E0.7',
    name: 'stadium',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3DF'],
    Status: 'unqualified',
    char: '\uD83C\uDFDF',
    Version: 'E0.7',
    name: 'stadium',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3DB', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFDB\uFE0F',
    Version: 'E0.7',
    name: 'classical building',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3DB'],
    Status: 'unqualified',
    char: '\uD83C\uDFDB',
    Version: 'E0.7',
    name: 'classical building',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3D7', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFD7\uFE0F',
    Version: 'E0.7',
    name: 'building construction',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3D7'],
    Status: 'unqualified',
    char: '\uD83C\uDFD7',
    Version: 'E0.7',
    name: 'building construction',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F9F1'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDF1',
    Version: 'E11.0',
    name: 'brick',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1FAA8'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEA8',
    Version: 'E13.0',
    name: 'rock',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1FAB5'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEB5',
    Version: 'E13.0',
    name: 'wood',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F6D6'],
    Status: 'fully-qualified',
    char: '\uD83D\uDED6',
    Version: 'E13.0',
    name: 'hut',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3D8', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFD8\uFE0F',
    Version: 'E0.7',
    name: 'houses',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3D8'],
    Status: 'unqualified',
    char: '\uD83C\uDFD8',
    Version: 'E0.7',
    name: 'houses',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3DA', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFDA\uFE0F',
    Version: 'E0.7',
    name: 'derelict house',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3DA'],
    Status: 'unqualified',
    char: '\uD83C\uDFDA',
    Version: 'E0.7',
    name: 'derelict house',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3E0'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFE0',
    Version: 'E0.6',
    name: 'house',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3E1'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFE1',
    Version: 'E0.6',
    name: 'house with garden',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3E2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFE2',
    Version: 'E0.6',
    name: 'office building',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3E3'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFE3',
    Version: 'E0.6',
    name: 'Japanese post office',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3E4'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFE4',
    Version: 'E1.0',
    name: 'post office',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3E5'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFE5',
    Version: 'E0.6',
    name: 'hospital',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3E6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFE6',
    Version: 'E0.6',
    name: 'bank',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3E8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFE8',
    Version: 'E0.6',
    name: 'hotel',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3E9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFE9',
    Version: 'E0.6',
    name: 'love hotel',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3EA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFEA',
    Version: 'E0.6',
    name: 'convenience store',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3EB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFEB',
    Version: 'E0.6',
    name: 'school',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3EC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFEC',
    Version: 'E0.6',
    name: 'department store',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3ED'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFED',
    Version: 'E0.6',
    name: 'factory',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3EF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFEF',
    Version: 'E0.6',
    name: 'Japanese castle',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F3F0'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFF0',
    Version: 'E0.6',
    name: 'castle',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F492'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC92',
    Version: 'E0.6',
    name: 'wedding',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F5FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDFC',
    Version: 'E0.6',
    name: 'Tokyo tower',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['1F5FD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDFD',
    Version: 'E0.6',
    name: 'Statue of Liberty',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-building'
  },
  {
    CodePointsHex: ['26EA'],
    Status: 'fully-qualified',
    char: '\u26EA',
    Version: 'E0.6',
    name: 'church',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-religious'
  },
  {
    CodePointsHex: ['1F54C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD4C',
    Version: 'E1.0',
    name: 'mosque',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-religious'
  },
  {
    CodePointsHex: ['1F6D5'],
    Status: 'fully-qualified',
    char: '\uD83D\uDED5',
    Version: 'E12.0',
    name: 'hindu temple',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-religious'
  },
  {
    CodePointsHex: ['1F54D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD4D',
    Version: 'E1.0',
    name: 'synagogue',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-religious'
  },
  {
    CodePointsHex: ['26E9', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26E9\uFE0F',
    Version: 'E0.7',
    name: 'shinto shrine',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-religious'
  },
  {
    CodePointsHex: ['26E9'],
    Status: 'unqualified',
    char: '\u26E9',
    Version: 'E0.7',
    name: 'shinto shrine',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-religious'
  },
  {
    CodePointsHex: ['1F54B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD4B',
    Version: 'E1.0',
    name: 'kaaba',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-religious'
  },
  {
    CodePointsHex: ['26F2'],
    Status: 'fully-qualified',
    char: '\u26F2',
    Version: 'E0.6',
    name: 'fountain',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['26FA'],
    Status: 'fully-qualified',
    char: '\u26FA',
    Version: 'E0.6',
    name: 'tent',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['1F301'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF01',
    Version: 'E0.6',
    name: 'foggy',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['1F303'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF03',
    Version: 'E0.6',
    name: 'night with stars',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['1F3D9', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFD9\uFE0F',
    Version: 'E0.7',
    name: 'cityscape',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['1F3D9'],
    Status: 'unqualified',
    char: '\uD83C\uDFD9',
    Version: 'E0.7',
    name: 'cityscape',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['1F304'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF04',
    Version: 'E0.6',
    name: 'sunrise over mountains',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['1F305'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF05',
    Version: 'E0.6',
    name: 'sunrise',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['1F306'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF06',
    Version: 'E0.6',
    name: 'cityscape at dusk',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['1F307'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF07',
    Version: 'E0.6',
    name: 'sunset',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['1F309'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF09',
    Version: 'E0.6',
    name: 'bridge at night',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['2668', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2668\uFE0F',
    Version: 'E0.6',
    name: 'hot springs',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['2668'],
    Status: 'unqualified',
    char: '\u2668',
    Version: 'E0.6',
    name: 'hot springs',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['1F3A0'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFA0',
    Version: 'E0.6',
    name: 'carousel horse',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['1F6DD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEDD',
    Version: 'E14.0',
    name: 'playground slide',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['1F3A1'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFA1',
    Version: 'E0.6',
    name: 'ferris wheel',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['1F3A2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFA2',
    Version: 'E0.6',
    name: 'roller coaster',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['1F488'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC88',
    Version: 'E0.6',
    name: 'barber pole',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['1F3AA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFAA',
    Version: 'E0.6',
    name: 'circus tent',
    category: 'Travel \u0026 Places',
    SubGroup: 'place-other'
  },
  {
    CodePointsHex: ['1F682'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE82',
    Version: 'E1.0',
    name: 'locomotive',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F683'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE83',
    Version: 'E0.6',
    name: 'railway car',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F684'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE84',
    Version: 'E0.6',
    name: 'high-speed train',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F685'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE85',
    Version: 'E0.6',
    name: 'bullet train',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F686'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE86',
    Version: 'E1.0',
    name: 'train',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F687'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE87',
    Version: 'E0.6',
    name: 'metro',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F688'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE88',
    Version: 'E1.0',
    name: 'light rail',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F689'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE89',
    Version: 'E0.6',
    name: 'station',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F68A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE8A',
    Version: 'E1.0',
    name: 'tram',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F69D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE9D',
    Version: 'E1.0',
    name: 'monorail',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F69E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE9E',
    Version: 'E1.0',
    name: 'mountain railway',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F68B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE8B',
    Version: 'E1.0',
    name: 'tram car',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F68C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE8C',
    Version: 'E0.6',
    name: 'bus',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F68D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE8D',
    Version: 'E0.7',
    name: 'oncoming bus',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F68E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE8E',
    Version: 'E1.0',
    name: 'trolleybus',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F690'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE90',
    Version: 'E1.0',
    name: 'minibus',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F691'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE91',
    Version: 'E0.6',
    name: 'ambulance',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F692'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE92',
    Version: 'E0.6',
    name: 'fire engine',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F693'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE93',
    Version: 'E0.6',
    name: 'police car',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F694'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE94',
    Version: 'E0.7',
    name: 'oncoming police car',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F695'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE95',
    Version: 'E0.6',
    name: 'taxi',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F696'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE96',
    Version: 'E1.0',
    name: 'oncoming taxi',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F697'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE97',
    Version: 'E0.6',
    name: 'automobile',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F698'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE98',
    Version: 'E0.7',
    name: 'oncoming automobile',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F699'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE99',
    Version: 'E0.6',
    name: 'sport utility vehicle',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEFB',
    Version: 'E13.0',
    name: 'pickup truck',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F69A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE9A',
    Version: 'E0.6',
    name: 'delivery truck',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F69B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE9B',
    Version: 'E1.0',
    name: 'articulated lorry',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F69C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE9C',
    Version: 'E1.0',
    name: 'tractor',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F3CE', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCE\uFE0F',
    Version: 'E0.7',
    name: 'racing car',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F3CE'],
    Status: 'unqualified',
    char: '\uD83C\uDFCE',
    Version: 'E0.7',
    name: 'racing car',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F3CD', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCD\uFE0F',
    Version: 'E0.7',
    name: 'motorcycle',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F3CD'],
    Status: 'unqualified',
    char: '\uD83C\uDFCD',
    Version: 'E0.7',
    name: 'motorcycle',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6F5'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEF5',
    Version: 'E3.0',
    name: 'motor scooter',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F9BD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDBD',
    Version: 'E12.0',
    name: 'manual wheelchair',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F9BC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDBC',
    Version: 'E12.0',
    name: 'motorized wheelchair',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6FA'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEFA',
    Version: 'E12.0',
    name: 'auto rickshaw',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6B2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB2',
    Version: 'E0.6',
    name: 'bicycle',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6F4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEF4',
    Version: 'E3.0',
    name: 'kick scooter',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6F9'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEF9',
    Version: 'E11.0',
    name: 'skateboard',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEFC',
    Version: 'E13.0',
    name: 'roller skate',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F68F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE8F',
    Version: 'E0.6',
    name: 'bus stop',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6E3', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEE3\uFE0F',
    Version: 'E0.7',
    name: 'motorway',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6E3'],
    Status: 'unqualified',
    char: '\uD83D\uDEE3',
    Version: 'E0.7',
    name: 'motorway',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6E4', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEE4\uFE0F',
    Version: 'E0.7',
    name: 'railway track',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6E4'],
    Status: 'unqualified',
    char: '\uD83D\uDEE4',
    Version: 'E0.7',
    name: 'railway track',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6E2', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEE2\uFE0F',
    Version: 'E0.7',
    name: 'oil drum',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6E2'],
    Status: 'unqualified',
    char: '\uD83D\uDEE2',
    Version: 'E0.7',
    name: 'oil drum',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['26FD'],
    Status: 'fully-qualified',
    char: '\u26FD',
    Version: 'E0.6',
    name: 'fuel pump',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6DE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEDE',
    Version: 'E14.0',
    name: 'wheel',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6A8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA8',
    Version: 'E0.6',
    name: 'police car light',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6A5'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA5',
    Version: 'E0.6',
    name: 'horizontal traffic light',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6A6'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA6',
    Version: 'E1.0',
    name: 'vertical traffic light',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6D1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDED1',
    Version: 'E3.0',
    name: 'stop sign',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['1F6A7'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA7',
    Version: 'E0.6',
    name: 'construction',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-ground'
  },
  {
    CodePointsHex: ['2693'],
    Status: 'fully-qualified',
    char: '\u2693',
    Version: 'E0.6',
    name: 'anchor',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-water'
  },
  {
    CodePointsHex: ['1F6DF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEDF',
    Version: 'E14.0',
    name: 'ring buoy',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-water'
  },
  {
    CodePointsHex: ['26F5'],
    Status: 'fully-qualified',
    char: '\u26F5',
    Version: 'E0.6',
    name: 'sailboat',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-water'
  },
  {
    CodePointsHex: ['1F6F6'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEF6',
    Version: 'E3.0',
    name: 'canoe',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-water'
  },
  {
    CodePointsHex: ['1F6A4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA4',
    Version: 'E0.6',
    name: 'speedboat',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-water'
  },
  {
    CodePointsHex: ['1F6F3', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEF3\uFE0F',
    Version: 'E0.7',
    name: 'passenger ship',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-water'
  },
  {
    CodePointsHex: ['1F6F3'],
    Status: 'unqualified',
    char: '\uD83D\uDEF3',
    Version: 'E0.7',
    name: 'passenger ship',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-water'
  },
  {
    CodePointsHex: ['26F4', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26F4\uFE0F',
    Version: 'E0.7',
    name: 'ferry',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-water'
  },
  {
    CodePointsHex: ['26F4'],
    Status: 'unqualified',
    char: '\u26F4',
    Version: 'E0.7',
    name: 'ferry',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-water'
  },
  {
    CodePointsHex: ['1F6E5', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEE5\uFE0F',
    Version: 'E0.7',
    name: 'motor boat',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-water'
  },
  {
    CodePointsHex: ['1F6E5'],
    Status: 'unqualified',
    char: '\uD83D\uDEE5',
    Version: 'E0.7',
    name: 'motor boat',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-water'
  },
  {
    CodePointsHex: ['1F6A2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA2',
    Version: 'E0.6',
    name: 'ship',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-water'
  },
  {
    CodePointsHex: ['2708', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2708\uFE0F',
    Version: 'E0.6',
    name: 'airplane',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-air'
  },
  {
    CodePointsHex: ['2708'],
    Status: 'unqualified',
    char: '\u2708',
    Version: 'E0.6',
    name: 'airplane',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-air'
  },
  {
    CodePointsHex: ['1F6E9', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEE9\uFE0F',
    Version: 'E0.7',
    name: 'small airplane',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-air'
  },
  {
    CodePointsHex: ['1F6E9'],
    Status: 'unqualified',
    char: '\uD83D\uDEE9',
    Version: 'E0.7',
    name: 'small airplane',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-air'
  },
  {
    CodePointsHex: ['1F6EB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEEB',
    Version: 'E1.0',
    name: 'airplane departure',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-air'
  },
  {
    CodePointsHex: ['1F6EC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEEC',
    Version: 'E1.0',
    name: 'airplane arrival',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-air'
  },
  {
    CodePointsHex: ['1FA82'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE82',
    Version: 'E12.0',
    name: 'parachute',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-air'
  },
  {
    CodePointsHex: ['1F4BA'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCBA',
    Version: 'E0.6',
    name: 'seat',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-air'
  },
  {
    CodePointsHex: ['1F681'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE81',
    Version: 'E1.0',
    name: 'helicopter',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-air'
  },
  {
    CodePointsHex: ['1F69F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE9F',
    Version: 'E1.0',
    name: 'suspension railway',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-air'
  },
  {
    CodePointsHex: ['1F6A0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA0',
    Version: 'E1.0',
    name: 'mountain cableway',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-air'
  },
  {
    CodePointsHex: ['1F6A1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA1',
    Version: 'E1.0',
    name: 'aerial tramway',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-air'
  },
  {
    CodePointsHex: ['1F6F0', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEF0\uFE0F',
    Version: 'E0.7',
    name: 'satellite',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-air'
  },
  {
    CodePointsHex: ['1F6F0'],
    Status: 'unqualified',
    char: '\uD83D\uDEF0',
    Version: 'E0.7',
    name: 'satellite',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-air'
  },
  {
    CodePointsHex: ['1F680'],
    Status: 'fully-qualified',
    char: '\uD83D\uDE80',
    Version: 'E0.6',
    name: 'rocket',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-air'
  },
  {
    CodePointsHex: ['1F6F8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEF8',
    Version: 'E5.0',
    name: 'flying saucer',
    category: 'Travel \u0026 Places',
    SubGroup: 'transport-air'
  },
  {
    CodePointsHex: ['1F6CE', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDECE\uFE0F',
    Version: 'E0.7',
    name: 'bellhop bell',
    category: 'Travel \u0026 Places',
    SubGroup: 'hotel'
  },
  {
    CodePointsHex: ['1F6CE'],
    Status: 'unqualified',
    char: '\uD83D\uDECE',
    Version: 'E0.7',
    name: 'bellhop bell',
    category: 'Travel \u0026 Places',
    SubGroup: 'hotel'
  },
  {
    CodePointsHex: ['1F9F3'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDF3',
    Version: 'E11.0',
    name: 'luggage',
    category: 'Travel \u0026 Places',
    SubGroup: 'hotel'
  },
  {
    CodePointsHex: ['231B'],
    Status: 'fully-qualified',
    char: '\u231B',
    Version: 'E0.6',
    name: 'hourglass done',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['23F3'],
    Status: 'fully-qualified',
    char: '\u23F3',
    Version: 'E0.6',
    name: 'hourglass not done',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['231A'],
    Status: 'fully-qualified',
    char: '\u231A',
    Version: 'E0.6',
    name: 'watch',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['23F0'],
    Status: 'fully-qualified',
    char: '\u23F0',
    Version: 'E0.6',
    name: 'alarm clock',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['23F1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u23F1\uFE0F',
    Version: 'E1.0',
    name: 'stopwatch',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['23F1'],
    Status: 'unqualified',
    char: '\u23F1',
    Version: 'E1.0',
    name: 'stopwatch',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['23F2', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u23F2\uFE0F',
    Version: 'E1.0',
    name: 'timer clock',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['23F2'],
    Status: 'unqualified',
    char: '\u23F2',
    Version: 'E1.0',
    name: 'timer clock',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F570', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD70\uFE0F',
    Version: 'E0.7',
    name: 'mantelpiece clock',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F570'],
    Status: 'unqualified',
    char: '\uD83D\uDD70',
    Version: 'E0.7',
    name: 'mantelpiece clock',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F55B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD5B',
    Version: 'E0.6',
    name: 'twelve o\u2019clock',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F567'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD67',
    Version: 'E0.7',
    name: 'twelve-thirty',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F550'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD50',
    Version: 'E0.6',
    name: 'one o\u2019clock',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F55C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD5C',
    Version: 'E0.7',
    name: 'one-thirty',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F551'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD51',
    Version: 'E0.6',
    name: 'two o\u2019clock',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F55D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD5D',
    Version: 'E0.7',
    name: 'two-thirty',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F552'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD52',
    Version: 'E0.6',
    name: 'three o\u2019clock',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F55E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD5E',
    Version: 'E0.7',
    name: 'three-thirty',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F553'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD53',
    Version: 'E0.6',
    name: 'four o\u2019clock',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F55F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD5F',
    Version: 'E0.7',
    name: 'four-thirty',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F554'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD54',
    Version: 'E0.6',
    name: 'five o\u2019clock',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F560'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD60',
    Version: 'E0.7',
    name: 'five-thirty',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F555'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD55',
    Version: 'E0.6',
    name: 'six o\u2019clock',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F561'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD61',
    Version: 'E0.7',
    name: 'six-thirty',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F556'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD56',
    Version: 'E0.6',
    name: 'seven o\u2019clock',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F562'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD62',
    Version: 'E0.7',
    name: 'seven-thirty',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F557'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD57',
    Version: 'E0.6',
    name: 'eight o\u2019clock',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F563'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD63',
    Version: 'E0.7',
    name: 'eight-thirty',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F558'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD58',
    Version: 'E0.6',
    name: 'nine o\u2019clock',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F564'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD64',
    Version: 'E0.7',
    name: 'nine-thirty',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F559'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD59',
    Version: 'E0.6',
    name: 'ten o\u2019clock',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F565'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD65',
    Version: 'E0.7',
    name: 'ten-thirty',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F55A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD5A',
    Version: 'E0.6',
    name: 'eleven o\u2019clock',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F566'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD66',
    Version: 'E0.7',
    name: 'eleven-thirty',
    category: 'Travel \u0026 Places',
    SubGroup: 'time'
  },
  {
    CodePointsHex: ['1F311'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF11',
    Version: 'E0.6',
    name: 'new moon',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F312'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF12',
    Version: 'E1.0',
    name: 'waxing crescent moon',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F313'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF13',
    Version: 'E0.6',
    name: 'first quarter moon',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F314'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF14',
    Version: 'E0.6',
    name: 'waxing gibbous moon',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F315'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF15',
    Version: 'E0.6',
    name: 'full moon',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F316'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF16',
    Version: 'E1.0',
    name: 'waning gibbous moon',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F317'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF17',
    Version: 'E1.0',
    name: 'last quarter moon',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F318'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF18',
    Version: 'E1.0',
    name: 'waning crescent moon',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F319'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF19',
    Version: 'E0.6',
    name: 'crescent moon',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F31A'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF1A',
    Version: 'E1.0',
    name: 'new moon face',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F31B'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF1B',
    Version: 'E0.6',
    name: 'first quarter moon face',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F31C'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF1C',
    Version: 'E0.7',
    name: 'last quarter moon face',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F321', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF21\uFE0F',
    Version: 'E0.7',
    name: 'thermometer',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F321'],
    Status: 'unqualified',
    char: '\uD83C\uDF21',
    Version: 'E0.7',
    name: 'thermometer',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['2600', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2600\uFE0F',
    Version: 'E0.6',
    name: 'sun',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['2600'],
    Status: 'unqualified',
    char: '\u2600',
    Version: 'E0.6',
    name: 'sun',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F31D'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF1D',
    Version: 'E1.0',
    name: 'full moon face',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F31E'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF1E',
    Version: 'E1.0',
    name: 'sun with face',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1FA90'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE90',
    Version: 'E12.0',
    name: 'ringed planet',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['2B50'],
    Status: 'fully-qualified',
    char: '\u2B50',
    Version: 'E0.6',
    name: 'star',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F31F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF1F',
    Version: 'E0.6',
    name: 'glowing star',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F320'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF20',
    Version: 'E0.6',
    name: 'shooting star',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F30C'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF0C',
    Version: 'E0.6',
    name: 'milky way',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['2601', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2601\uFE0F',
    Version: 'E0.6',
    name: 'cloud',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['2601'],
    Status: 'unqualified',
    char: '\u2601',
    Version: 'E0.6',
    name: 'cloud',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['26C5'],
    Status: 'fully-qualified',
    char: '\u26C5',
    Version: 'E0.6',
    name: 'sun behind cloud',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['26C8', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26C8\uFE0F',
    Version: 'E0.7',
    name: 'cloud with lightning and rain',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['26C8'],
    Status: 'unqualified',
    char: '\u26C8',
    Version: 'E0.7',
    name: 'cloud with lightning and rain',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F324', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF24\uFE0F',
    Version: 'E0.7',
    name: 'sun behind small cloud',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F324'],
    Status: 'unqualified',
    char: '\uD83C\uDF24',
    Version: 'E0.7',
    name: 'sun behind small cloud',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F325', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF25\uFE0F',
    Version: 'E0.7',
    name: 'sun behind large cloud',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F325'],
    Status: 'unqualified',
    char: '\uD83C\uDF25',
    Version: 'E0.7',
    name: 'sun behind large cloud',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F326', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF26\uFE0F',
    Version: 'E0.7',
    name: 'sun behind rain cloud',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F326'],
    Status: 'unqualified',
    char: '\uD83C\uDF26',
    Version: 'E0.7',
    name: 'sun behind rain cloud',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F327', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF27\uFE0F',
    Version: 'E0.7',
    name: 'cloud with rain',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F327'],
    Status: 'unqualified',
    char: '\uD83C\uDF27',
    Version: 'E0.7',
    name: 'cloud with rain',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F328', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF28\uFE0F',
    Version: 'E0.7',
    name: 'cloud with snow',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F328'],
    Status: 'unqualified',
    char: '\uD83C\uDF28',
    Version: 'E0.7',
    name: 'cloud with snow',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F329', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF29\uFE0F',
    Version: 'E0.7',
    name: 'cloud with lightning',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F329'],
    Status: 'unqualified',
    char: '\uD83C\uDF29',
    Version: 'E0.7',
    name: 'cloud with lightning',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F32A', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF2A\uFE0F',
    Version: 'E0.7',
    name: 'tornado',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F32A'],
    Status: 'unqualified',
    char: '\uD83C\uDF2A',
    Version: 'E0.7',
    name: 'tornado',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F32B', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF2B\uFE0F',
    Version: 'E0.7',
    name: 'fog',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F32B'],
    Status: 'unqualified',
    char: '\uD83C\uDF2B',
    Version: 'E0.7',
    name: 'fog',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F32C', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF2C\uFE0F',
    Version: 'E0.7',
    name: 'wind face',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F32C'],
    Status: 'unqualified',
    char: '\uD83C\uDF2C',
    Version: 'E0.7',
    name: 'wind face',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F300'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF00',
    Version: 'E0.6',
    name: 'cyclone',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F308'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF08',
    Version: 'E0.6',
    name: 'rainbow',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F302'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF02',
    Version: 'E0.6',
    name: 'closed umbrella',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['2602', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2602\uFE0F',
    Version: 'E0.7',
    name: 'umbrella',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['2602'],
    Status: 'unqualified',
    char: '\u2602',
    Version: 'E0.7',
    name: 'umbrella',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['2614'],
    Status: 'fully-qualified',
    char: '\u2614',
    Version: 'E0.6',
    name: 'umbrella with rain drops',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['26F1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26F1\uFE0F',
    Version: 'E0.7',
    name: 'umbrella on ground',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['26F1'],
    Status: 'unqualified',
    char: '\u26F1',
    Version: 'E0.7',
    name: 'umbrella on ground',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['26A1'],
    Status: 'fully-qualified',
    char: '\u26A1',
    Version: 'E0.6',
    name: 'high voltage',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['2744', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2744\uFE0F',
    Version: 'E0.6',
    name: 'snowflake',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['2744'],
    Status: 'unqualified',
    char: '\u2744',
    Version: 'E0.6',
    name: 'snowflake',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['2603', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2603\uFE0F',
    Version: 'E0.7',
    name: 'snowman',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['2603'],
    Status: 'unqualified',
    char: '\u2603',
    Version: 'E0.7',
    name: 'snowman',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['26C4'],
    Status: 'fully-qualified',
    char: '\u26C4',
    Version: 'E0.6',
    name: 'snowman without snow',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['2604', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2604\uFE0F',
    Version: 'E1.0',
    name: 'comet',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['2604'],
    Status: 'unqualified',
    char: '\u2604',
    Version: 'E1.0',
    name: 'comet',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F525'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD25',
    Version: 'E0.6',
    name: 'fire',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F4A7'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCA7',
    Version: 'E0.6',
    name: 'droplet',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F30A'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF0A',
    Version: 'E0.6',
    name: 'water wave',
    category: 'Travel \u0026 Places',
    SubGroup: 'sky \u0026 weather'
  },
  {
    CodePointsHex: ['1F383'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF83',
    Version: 'E0.6',
    name: 'jack-o-lantern',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F384'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF84',
    Version: 'E0.6',
    name: 'Christmas tree',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F386'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF86',
    Version: 'E0.6',
    name: 'fireworks',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F387'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF87',
    Version: 'E0.6',
    name: 'sparkler',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F9E8'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDE8',
    Version: 'E11.0',
    name: 'firecracker',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['2728'],
    Status: 'fully-qualified',
    char: '\u2728',
    Version: 'E0.6',
    name: 'sparkles',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F388'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF88',
    Version: 'E0.6',
    name: 'balloon',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F389'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF89',
    Version: 'E0.6',
    name: 'party popper',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F38A'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF8A',
    Version: 'E0.6',
    name: 'confetti ball',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F38B'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF8B',
    Version: 'E0.6',
    name: 'tanabata tree',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F38D'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF8D',
    Version: 'E0.6',
    name: 'pine decoration',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F38E'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF8E',
    Version: 'E0.6',
    name: 'Japanese dolls',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F38F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF8F',
    Version: 'E0.6',
    name: 'carp streamer',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F390'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF90',
    Version: 'E0.6',
    name: 'wind chime',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F391'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF91',
    Version: 'E0.6',
    name: 'moon viewing ceremony',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F9E7'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDE7',
    Version: 'E11.0',
    name: 'red envelope',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F380'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF80',
    Version: 'E0.6',
    name: 'ribbon',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F381'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF81',
    Version: 'E0.6',
    name: 'wrapped gift',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F397', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF97\uFE0F',
    Version: 'E0.7',
    name: 'reminder ribbon',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F397'],
    Status: 'unqualified',
    char: '\uD83C\uDF97',
    Version: 'E0.7',
    name: 'reminder ribbon',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F39F', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF9F\uFE0F',
    Version: 'E0.7',
    name: 'admission tickets',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F39F'],
    Status: 'unqualified',
    char: '\uD83C\uDF9F',
    Version: 'E0.7',
    name: 'admission tickets',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F3AB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFAB',
    Version: 'E0.6',
    name: 'ticket',
    category: 'Activities',
    SubGroup: 'event'
  },
  {
    CodePointsHex: ['1F396', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF96\uFE0F',
    Version: 'E0.7',
    name: 'military medal',
    category: 'Activities',
    SubGroup: 'award-medal'
  },
  {
    CodePointsHex: ['1F396'],
    Status: 'unqualified',
    char: '\uD83C\uDF96',
    Version: 'E0.7',
    name: 'military medal',
    category: 'Activities',
    SubGroup: 'award-medal'
  },
  {
    CodePointsHex: ['1F3C6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC6',
    Version: 'E0.6',
    name: 'trophy',
    category: 'Activities',
    SubGroup: 'award-medal'
  },
  {
    CodePointsHex: ['1F3C5'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC5',
    Version: 'E1.0',
    name: 'sports medal',
    category: 'Activities',
    SubGroup: 'award-medal'
  },
  {
    CodePointsHex: ['1F947'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD47',
    Version: 'E3.0',
    name: '1st place medal',
    category: 'Activities',
    SubGroup: 'award-medal'
  },
  {
    CodePointsHex: ['1F948'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD48',
    Version: 'E3.0',
    name: '2nd place medal',
    category: 'Activities',
    SubGroup: 'award-medal'
  },
  {
    CodePointsHex: ['1F949'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD49',
    Version: 'E3.0',
    name: '3rd place medal',
    category: 'Activities',
    SubGroup: 'award-medal'
  },
  {
    CodePointsHex: ['26BD'],
    Status: 'fully-qualified',
    char: '\u26BD',
    Version: 'E0.6',
    name: 'soccer ball',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['26BE'],
    Status: 'fully-qualified',
    char: '\u26BE',
    Version: 'E0.6',
    name: 'baseball',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F94E'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD4E',
    Version: 'E11.0',
    name: 'softball',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F3C0'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC0',
    Version: 'E0.6',
    name: 'basketball',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F3D0'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFD0',
    Version: 'E1.0',
    name: 'volleyball',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F3C8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC8',
    Version: 'E0.6',
    name: 'american football',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F3C9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC9',
    Version: 'E1.0',
    name: 'rugby football',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F3BE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFBE',
    Version: 'E0.6',
    name: 'tennis',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F94F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD4F',
    Version: 'E11.0',
    name: 'flying disc',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F3B3'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFB3',
    Version: 'E0.6',
    name: 'bowling',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F3CF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFCF',
    Version: 'E1.0',
    name: 'cricket game',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F3D1'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFD1',
    Version: 'E1.0',
    name: 'field hockey',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F3D2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFD2',
    Version: 'E1.0',
    name: 'ice hockey',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F94D'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD4D',
    Version: 'E11.0',
    name: 'lacrosse',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F3D3'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFD3',
    Version: 'E1.0',
    name: 'ping pong',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F3F8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFF8',
    Version: 'E1.0',
    name: 'badminton',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F94A'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD4A',
    Version: 'E3.0',
    name: 'boxing glove',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F94B'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD4B',
    Version: 'E3.0',
    name: 'martial arts uniform',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F945'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD45',
    Version: 'E3.0',
    name: 'goal net',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['26F3'],
    Status: 'fully-qualified',
    char: '\u26F3',
    Version: 'E0.6',
    name: 'flag in hole',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['26F8', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26F8\uFE0F',
    Version: 'E0.7',
    name: 'ice skate',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['26F8'],
    Status: 'unqualified',
    char: '\u26F8',
    Version: 'E0.7',
    name: 'ice skate',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F3A3'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFA3',
    Version: 'E0.6',
    name: 'fishing pole',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F93F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD3F',
    Version: 'E12.0',
    name: 'diving mask',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F3BD'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFBD',
    Version: 'E0.6',
    name: 'running shirt',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F3BF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFBF',
    Version: 'E0.6',
    name: 'skis',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F6F7'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEF7',
    Version: 'E5.0',
    name: 'sled',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F94C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD4C',
    Version: 'E5.0',
    name: 'curling stone',
    category: 'Activities',
    SubGroup: 'sport'
  },
  {
    CodePointsHex: ['1F3AF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFAF',
    Version: 'E0.6',
    name: 'bullseye',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1FA80'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE80',
    Version: 'E12.0',
    name: 'yo-yo',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1FA81'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE81',
    Version: 'E12.0',
    name: 'kite',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1F52B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD2B',
    Version: 'E0.6',
    name: 'water pistol',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1F3B1'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFB1',
    Version: 'E0.6',
    name: 'pool 8 ball',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1F52E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD2E',
    Version: 'E0.6',
    name: 'crystal ball',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1FA84'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE84',
    Version: 'E13.0',
    name: 'magic wand',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1F3AE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFAE',
    Version: 'E0.6',
    name: 'video game',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1F579', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD79\uFE0F',
    Version: 'E0.7',
    name: 'joystick',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1F579'],
    Status: 'unqualified',
    char: '\uD83D\uDD79',
    Version: 'E0.7',
    name: 'joystick',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1F3B0'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFB0',
    Version: 'E0.6',
    name: 'slot machine',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1F3B2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFB2',
    Version: 'E0.6',
    name: 'game die',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1F9E9'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDE9',
    Version: 'E11.0',
    name: 'puzzle piece',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1F9F8'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDF8',
    Version: 'E11.0',
    name: 'teddy bear',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1FA85'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE85',
    Version: 'E13.0',
    name: 'pi\u00F1ata',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1FAA9'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEA9',
    Version: 'E14.0',
    name: 'mirror ball',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1FA86'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE86',
    Version: 'E13.0',
    name: 'nesting dolls',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['2660', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2660\uFE0F',
    Version: 'E0.6',
    name: 'spade suit',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['2660'],
    Status: 'unqualified',
    char: '\u2660',
    Version: 'E0.6',
    name: 'spade suit',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['2665', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2665\uFE0F',
    Version: 'E0.6',
    name: 'heart suit',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['2665'],
    Status: 'unqualified',
    char: '\u2665',
    Version: 'E0.6',
    name: 'heart suit',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['2666', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2666\uFE0F',
    Version: 'E0.6',
    name: 'diamond suit',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['2666'],
    Status: 'unqualified',
    char: '\u2666',
    Version: 'E0.6',
    name: 'diamond suit',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['2663', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2663\uFE0F',
    Version: 'E0.6',
    name: 'club suit',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['2663'],
    Status: 'unqualified',
    char: '\u2663',
    Version: 'E0.6',
    name: 'club suit',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['265F', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u265F\uFE0F',
    Version: 'E11.0',
    name: 'chess pawn',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['265F'],
    Status: 'unqualified',
    char: '\u265F',
    Version: 'E11.0',
    name: 'chess pawn',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1F0CF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDCCF',
    Version: 'E0.6',
    name: 'joker',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1F004'],
    Status: 'fully-qualified',
    char: '\uD83C\uDC04',
    Version: 'E0.6',
    name: 'mahjong red dragon',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1F3B4'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFB4',
    Version: 'E0.6',
    name: 'flower playing cards',
    category: 'Activities',
    SubGroup: 'game'
  },
  {
    CodePointsHex: ['1F3AD'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFAD',
    Version: 'E0.6',
    name: 'performing arts',
    category: 'Activities',
    SubGroup: 'arts \u0026 crafts'
  },
  {
    CodePointsHex: ['1F5BC', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDBC\uFE0F',
    Version: 'E0.7',
    name: 'framed picture',
    category: 'Activities',
    SubGroup: 'arts \u0026 crafts'
  },
  {
    CodePointsHex: ['1F5BC'],
    Status: 'unqualified',
    char: '\uD83D\uDDBC',
    Version: 'E0.7',
    name: 'framed picture',
    category: 'Activities',
    SubGroup: 'arts \u0026 crafts'
  },
  {
    CodePointsHex: ['1F3A8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFA8',
    Version: 'E0.6',
    name: 'artist palette',
    category: 'Activities',
    SubGroup: 'arts \u0026 crafts'
  },
  {
    CodePointsHex: ['1F9F5'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDF5',
    Version: 'E11.0',
    name: 'thread',
    category: 'Activities',
    SubGroup: 'arts \u0026 crafts'
  },
  {
    CodePointsHex: ['1FAA1'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEA1',
    Version: 'E13.0',
    name: 'sewing needle',
    category: 'Activities',
    SubGroup: 'arts \u0026 crafts'
  },
  {
    CodePointsHex: ['1F9F6'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDF6',
    Version: 'E11.0',
    name: 'yarn',
    category: 'Activities',
    SubGroup: 'arts \u0026 crafts'
  },
  {
    CodePointsHex: ['1FAA2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEA2',
    Version: 'E13.0',
    name: 'knot',
    category: 'Activities',
    SubGroup: 'arts \u0026 crafts'
  },
  {
    CodePointsHex: ['1F453'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC53',
    Version: 'E0.6',
    name: 'glasses',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F576', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD76\uFE0F',
    Version: 'E0.7',
    name: 'sunglasses',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F576'],
    Status: 'unqualified',
    char: '\uD83D\uDD76',
    Version: 'E0.7',
    name: 'sunglasses',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F97D'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD7D',
    Version: 'E11.0',
    name: 'goggles',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F97C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD7C',
    Version: 'E11.0',
    name: 'lab coat',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F9BA'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDBA',
    Version: 'E12.0',
    name: 'safety vest',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F454'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC54',
    Version: 'E0.6',
    name: 'necktie',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F455'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC55',
    Version: 'E0.6',
    name: 't-shirt',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F456'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC56',
    Version: 'E0.6',
    name: 'jeans',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F9E3'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDE3',
    Version: 'E5.0',
    name: 'scarf',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F9E4'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDE4',
    Version: 'E5.0',
    name: 'gloves',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F9E5'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDE5',
    Version: 'E5.0',
    name: 'coat',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F9E6'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDE6',
    Version: 'E5.0',
    name: 'socks',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F457'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC57',
    Version: 'E0.6',
    name: 'dress',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F458'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC58',
    Version: 'E0.6',
    name: 'kimono',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F97B'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD7B',
    Version: 'E12.0',
    name: 'sari',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1FA71'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE71',
    Version: 'E12.0',
    name: 'one-piece swimsuit',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1FA72'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE72',
    Version: 'E12.0',
    name: 'briefs',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1FA73'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE73',
    Version: 'E12.0',
    name: 'shorts',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F459'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC59',
    Version: 'E0.6',
    name: 'bikini',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F45A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC5A',
    Version: 'E0.6',
    name: 'woman\u2019s clothes',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1FAAD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEAD',
    Version: 'E15.0',
    name: 'folding hand fan',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F45B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC5B',
    Version: 'E0.6',
    name: 'purse',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F45C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC5C',
    Version: 'E0.6',
    name: 'handbag',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F45D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC5D',
    Version: 'E0.6',
    name: 'clutch bag',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F6CD', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDECD\uFE0F',
    Version: 'E0.7',
    name: 'shopping bags',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F6CD'],
    Status: 'unqualified',
    char: '\uD83D\uDECD',
    Version: 'E0.7',
    name: 'shopping bags',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F392'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF92',
    Version: 'E0.6',
    name: 'backpack',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1FA74'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE74',
    Version: 'E13.0',
    name: 'thong sandal',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F45E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC5E',
    Version: 'E0.6',
    name: 'man\u2019s shoe',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F45F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC5F',
    Version: 'E0.6',
    name: 'running shoe',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F97E'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD7E',
    Version: 'E11.0',
    name: 'hiking boot',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F97F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD7F',
    Version: 'E11.0',
    name: 'flat shoe',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F460'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC60',
    Version: 'E0.6',
    name: 'high-heeled shoe',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F461'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC61',
    Version: 'E0.6',
    name: 'woman\u2019s sandal',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1FA70'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE70',
    Version: 'E12.0',
    name: 'ballet shoes',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F462'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC62',
    Version: 'E0.6',
    name: 'woman\u2019s boot',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1FAAE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEAE',
    Version: 'E15.0',
    name: 'hair pick',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F451'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC51',
    Version: 'E0.6',
    name: 'crown',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F452'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC52',
    Version: 'E0.6',
    name: 'woman\u2019s hat',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F3A9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFA9',
    Version: 'E0.6',
    name: 'top hat',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F393'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF93',
    Version: 'E0.6',
    name: 'graduation cap',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F9E2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDE2',
    Version: 'E5.0',
    name: 'billed cap',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1FA96'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE96',
    Version: 'E13.0',
    name: 'military helmet',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['26D1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26D1\uFE0F',
    Version: 'E0.7',
    name: 'rescue worker\u2019s helmet',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['26D1'],
    Status: 'unqualified',
    char: '\u26D1',
    Version: 'E0.7',
    name: 'rescue worker\u2019s helmet',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F4FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCFF',
    Version: 'E1.0',
    name: 'prayer beads',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F484'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC84',
    Version: 'E0.6',
    name: 'lipstick',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F48D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC8D',
    Version: 'E0.6',
    name: 'ring',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F48E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC8E',
    Version: 'E0.6',
    name: 'gem stone',
    category: 'Objects',
    SubGroup: 'clothing'
  },
  {
    CodePointsHex: ['1F507'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD07',
    Version: 'E1.0',
    name: 'muted speaker',
    category: 'Objects',
    SubGroup: 'sound'
  },
  {
    CodePointsHex: ['1F508'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD08',
    Version: 'E0.7',
    name: 'speaker low volume',
    category: 'Objects',
    SubGroup: 'sound'
  },
  {
    CodePointsHex: ['1F509'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD09',
    Version: 'E1.0',
    name: 'speaker medium volume',
    category: 'Objects',
    SubGroup: 'sound'
  },
  {
    CodePointsHex: ['1F50A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD0A',
    Version: 'E0.6',
    name: 'speaker high volume',
    category: 'Objects',
    SubGroup: 'sound'
  },
  {
    CodePointsHex: ['1F4E2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCE2',
    Version: 'E0.6',
    name: 'loudspeaker',
    category: 'Objects',
    SubGroup: 'sound'
  },
  {
    CodePointsHex: ['1F4E3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCE3',
    Version: 'E0.6',
    name: 'megaphone',
    category: 'Objects',
    SubGroup: 'sound'
  },
  {
    CodePointsHex: ['1F4EF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCEF',
    Version: 'E1.0',
    name: 'postal horn',
    category: 'Objects',
    SubGroup: 'sound'
  },
  {
    CodePointsHex: ['1F514'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD14',
    Version: 'E0.6',
    name: 'bell',
    category: 'Objects',
    SubGroup: 'sound'
  },
  {
    CodePointsHex: ['1F515'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD15',
    Version: 'E1.0',
    name: 'bell with slash',
    category: 'Objects',
    SubGroup: 'sound'
  },
  {
    CodePointsHex: ['1F3BC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFBC',
    Version: 'E0.6',
    name: 'musical score',
    category: 'Objects',
    SubGroup: 'music'
  },
  {
    CodePointsHex: ['1F3B5'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFB5',
    Version: 'E0.6',
    name: 'musical note',
    category: 'Objects',
    SubGroup: 'music'
  },
  {
    CodePointsHex: ['1F3B6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFB6',
    Version: 'E0.6',
    name: 'musical notes',
    category: 'Objects',
    SubGroup: 'music'
  },
  {
    CodePointsHex: ['1F399', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF99\uFE0F',
    Version: 'E0.7',
    name: 'studio microphone',
    category: 'Objects',
    SubGroup: 'music'
  },
  {
    CodePointsHex: ['1F399'],
    Status: 'unqualified',
    char: '\uD83C\uDF99',
    Version: 'E0.7',
    name: 'studio microphone',
    category: 'Objects',
    SubGroup: 'music'
  },
  {
    CodePointsHex: ['1F39A', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF9A\uFE0F',
    Version: 'E0.7',
    name: 'level slider',
    category: 'Objects',
    SubGroup: 'music'
  },
  {
    CodePointsHex: ['1F39A'],
    Status: 'unqualified',
    char: '\uD83C\uDF9A',
    Version: 'E0.7',
    name: 'level slider',
    category: 'Objects',
    SubGroup: 'music'
  },
  {
    CodePointsHex: ['1F39B', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF9B\uFE0F',
    Version: 'E0.7',
    name: 'control knobs',
    category: 'Objects',
    SubGroup: 'music'
  },
  {
    CodePointsHex: ['1F39B'],
    Status: 'unqualified',
    char: '\uD83C\uDF9B',
    Version: 'E0.7',
    name: 'control knobs',
    category: 'Objects',
    SubGroup: 'music'
  },
  {
    CodePointsHex: ['1F3A4'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFA4',
    Version: 'E0.6',
    name: 'microphone',
    category: 'Objects',
    SubGroup: 'music'
  },
  {
    CodePointsHex: ['1F3A7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFA7',
    Version: 'E0.6',
    name: 'headphone',
    category: 'Objects',
    SubGroup: 'music'
  },
  {
    CodePointsHex: ['1F4FB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCFB',
    Version: 'E0.6',
    name: 'radio',
    category: 'Objects',
    SubGroup: 'music'
  },
  {
    CodePointsHex: ['1F3B7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFB7',
    Version: 'E0.6',
    name: 'saxophone',
    category: 'Objects',
    SubGroup: 'musical-instrument'
  },
  {
    CodePointsHex: ['1F3BA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFBA',
    Version: 'E0.6',
    name: 'trumpet',
    category: 'Objects',
    SubGroup: 'musical-instrument'
  },
  {
    CodePointsHex: ['1FA8A'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE8A',
    Version: 'E17.0',
    name: 'trombone',
    category: 'Objects',
    SubGroup: 'musical-instrument'
  },
  {
    CodePointsHex: ['1FA97'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE97',
    Version: 'E13.0',
    name: 'accordion',
    category: 'Objects',
    SubGroup: 'musical-instrument'
  },
  {
    CodePointsHex: ['1F3B8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFB8',
    Version: 'E0.6',
    name: 'guitar',
    category: 'Objects',
    SubGroup: 'musical-instrument'
  },
  {
    CodePointsHex: ['1F3B9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFB9',
    Version: 'E0.6',
    name: 'musical keyboard',
    category: 'Objects',
    SubGroup: 'musical-instrument'
  },
  {
    CodePointsHex: ['1F3BB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFBB',
    Version: 'E0.6',
    name: 'violin',
    category: 'Objects',
    SubGroup: 'musical-instrument'
  },
  {
    CodePointsHex: ['1FA95'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE95',
    Version: 'E12.0',
    name: 'banjo',
    category: 'Objects',
    SubGroup: 'musical-instrument'
  },
  {
    CodePointsHex: ['1F941'],
    Status: 'fully-qualified',
    char: '\uD83E\uDD41',
    Version: 'E3.0',
    name: 'drum',
    category: 'Objects',
    SubGroup: 'musical-instrument'
  },
  {
    CodePointsHex: ['1FA98'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE98',
    Version: 'E13.0',
    name: 'long drum',
    category: 'Objects',
    SubGroup: 'musical-instrument'
  },
  {
    CodePointsHex: ['1FA87'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE87',
    Version: 'E15.0',
    name: 'maracas',
    category: 'Objects',
    SubGroup: 'musical-instrument'
  },
  {
    CodePointsHex: ['1FA88'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE88',
    Version: 'E15.0',
    name: 'flute',
    category: 'Objects',
    SubGroup: 'musical-instrument'
  },
  {
    CodePointsHex: ['1FA89'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE89',
    Version: 'E16.0',
    name: 'harp',
    category: 'Objects',
    SubGroup: 'musical-instrument'
  },
  {
    CodePointsHex: ['1F4F1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCF1',
    Version: 'E0.6',
    name: 'mobile phone',
    category: 'Objects',
    SubGroup: 'phone'
  },
  {
    CodePointsHex: ['1F4F2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCF2',
    Version: 'E0.6',
    name: 'mobile phone with arrow',
    category: 'Objects',
    SubGroup: 'phone'
  },
  {
    CodePointsHex: ['260E', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u260E\uFE0F',
    Version: 'E0.6',
    name: 'telephone',
    category: 'Objects',
    SubGroup: 'phone'
  },
  {
    CodePointsHex: ['260E'],
    Status: 'unqualified',
    char: '\u260E',
    Version: 'E0.6',
    name: 'telephone',
    category: 'Objects',
    SubGroup: 'phone'
  },
  {
    CodePointsHex: ['1F4DE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCDE',
    Version: 'E0.6',
    name: 'telephone receiver',
    category: 'Objects',
    SubGroup: 'phone'
  },
  {
    CodePointsHex: ['1F4DF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCDF',
    Version: 'E0.6',
    name: 'pager',
    category: 'Objects',
    SubGroup: 'phone'
  },
  {
    CodePointsHex: ['1F4E0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCE0',
    Version: 'E0.6',
    name: 'fax machine',
    category: 'Objects',
    SubGroup: 'phone'
  },
  {
    CodePointsHex: ['1F50B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD0B',
    Version: 'E0.6',
    name: 'battery',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['1FAAB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEAB',
    Version: 'E14.0',
    name: 'low battery',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['1F50C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD0C',
    Version: 'E0.6',
    name: 'electric plug',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['1F4BB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCBB',
    Version: 'E0.6',
    name: 'laptop',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['1F5A5', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDA5\uFE0F',
    Version: 'E0.7',
    name: 'desktop computer',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['1F5A5'],
    Status: 'unqualified',
    char: '\uD83D\uDDA5',
    Version: 'E0.7',
    name: 'desktop computer',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['1F5A8', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDA8\uFE0F',
    Version: 'E0.7',
    name: 'printer',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['1F5A8'],
    Status: 'unqualified',
    char: '\uD83D\uDDA8',
    Version: 'E0.7',
    name: 'printer',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['2328', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2328\uFE0F',
    Version: 'E1.0',
    name: 'keyboard',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['2328'],
    Status: 'unqualified',
    char: '\u2328',
    Version: 'E1.0',
    name: 'keyboard',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['1F5B1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDB1\uFE0F',
    Version: 'E0.7',
    name: 'computer mouse',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['1F5B1'],
    Status: 'unqualified',
    char: '\uD83D\uDDB1',
    Version: 'E0.7',
    name: 'computer mouse',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['1F5B2', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDB2\uFE0F',
    Version: 'E0.7',
    name: 'trackball',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['1F5B2'],
    Status: 'unqualified',
    char: '\uD83D\uDDB2',
    Version: 'E0.7',
    name: 'trackball',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['1F4BD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCBD',
    Version: 'E0.6',
    name: 'computer disk',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['1F4BE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCBE',
    Version: 'E0.6',
    name: 'floppy disk',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['1F4BF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCBF',
    Version: 'E0.6',
    name: 'optical disk',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['1F4C0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCC0',
    Version: 'E0.6',
    name: 'dvd',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['1F9EE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDEE',
    Version: 'E11.0',
    name: 'abacus',
    category: 'Objects',
    SubGroup: 'computer'
  },
  {
    CodePointsHex: ['1F3A5'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFA5',
    Version: 'E0.6',
    name: 'movie camera',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1F39E', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF9E\uFE0F',
    Version: 'E0.7',
    name: 'film frames',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1F39E'],
    Status: 'unqualified',
    char: '\uD83C\uDF9E',
    Version: 'E0.7',
    name: 'film frames',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1F4FD', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCFD\uFE0F',
    Version: 'E0.7',
    name: 'film projector',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1F4FD'],
    Status: 'unqualified',
    char: '\uD83D\uDCFD',
    Version: 'E0.7',
    name: 'film projector',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1F3AC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFAC',
    Version: 'E0.6',
    name: 'clapper board',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1F4FA'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCFA',
    Version: 'E0.6',
    name: 'television',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1F4F7'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCF7',
    Version: 'E0.6',
    name: 'camera',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1F4F8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCF8',
    Version: 'E1.0',
    name: 'camera with flash',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1F4F9'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCF9',
    Version: 'E0.6',
    name: 'video camera',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1F4FC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCFC',
    Version: 'E0.6',
    name: 'videocassette',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1F50D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD0D',
    Version: 'E0.6',
    name: 'magnifying glass tilted left',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1F50E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD0E',
    Version: 'E0.6',
    name: 'magnifying glass tilted right',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1F56F', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD6F\uFE0F',
    Version: 'E0.7',
    name: 'candle',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1F56F'],
    Status: 'unqualified',
    char: '\uD83D\uDD6F',
    Version: 'E0.7',
    name: 'candle',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1F4A1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCA1',
    Version: 'E0.6',
    name: 'light bulb',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1F526'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD26',
    Version: 'E0.6',
    name: 'flashlight',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1F3EE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFEE',
    Version: 'E0.6',
    name: 'red paper lantern',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1FA94'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE94',
    Version: 'E12.0',
    name: 'diya lamp',
    category: 'Objects',
    SubGroup: 'light \u0026 video'
  },
  {
    CodePointsHex: ['1F4D4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCD4',
    Version: 'E0.6',
    name: 'notebook with decorative cover',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1F4D5'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCD5',
    Version: 'E0.6',
    name: 'closed book',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1F4D6'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCD6',
    Version: 'E0.6',
    name: 'open book',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1F4D7'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCD7',
    Version: 'E0.6',
    name: 'green book',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1F4D8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCD8',
    Version: 'E0.6',
    name: 'blue book',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1F4D9'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCD9',
    Version: 'E0.6',
    name: 'orange book',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1F4DA'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCDA',
    Version: 'E0.6',
    name: 'books',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1F4D3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCD3',
    Version: 'E0.6',
    name: 'notebook',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1F4D2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCD2',
    Version: 'E0.6',
    name: 'ledger',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1F4C3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCC3',
    Version: 'E0.6',
    name: 'page with curl',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1F4DC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCDC',
    Version: 'E0.6',
    name: 'scroll',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1F4C4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCC4',
    Version: 'E0.6',
    name: 'page facing up',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1F4F0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCF0',
    Version: 'E0.6',
    name: 'newspaper',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1F5DE', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDDE\uFE0F',
    Version: 'E0.7',
    name: 'rolled-up newspaper',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1F5DE'],
    Status: 'unqualified',
    char: '\uD83D\uDDDE',
    Version: 'E0.7',
    name: 'rolled-up newspaper',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1F4D1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCD1',
    Version: 'E0.6',
    name: 'bookmark tabs',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1F516'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD16',
    Version: 'E0.6',
    name: 'bookmark',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1F3F7', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFF7\uFE0F',
    Version: 'E0.7',
    name: 'label',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1F3F7'],
    Status: 'unqualified',
    char: '\uD83C\uDFF7',
    Version: 'E0.7',
    name: 'label',
    category: 'Objects',
    SubGroup: 'book-paper'
  },
  {
    CodePointsHex: ['1FA99'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE99',
    Version: 'E13.0',
    name: 'coin',
    category: 'Objects',
    SubGroup: 'money'
  },
  {
    CodePointsHex: ['1F4B0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCB0',
    Version: 'E0.6',
    name: 'money bag',
    category: 'Objects',
    SubGroup: 'money'
  },
  {
    CodePointsHex: ['1FA8E'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE8E',
    Version: 'E17.0',
    name: 'treasure chest',
    category: 'Objects',
    SubGroup: 'money'
  },
  {
    CodePointsHex: ['1F4B4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCB4',
    Version: 'E0.6',
    name: 'yen banknote',
    category: 'Objects',
    SubGroup: 'money'
  },
  {
    CodePointsHex: ['1F4B5'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCB5',
    Version: 'E0.6',
    name: 'dollar banknote',
    category: 'Objects',
    SubGroup: 'money'
  },
  {
    CodePointsHex: ['1F4B6'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCB6',
    Version: 'E1.0',
    name: 'euro banknote',
    category: 'Objects',
    SubGroup: 'money'
  },
  {
    CodePointsHex: ['1F4B7'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCB7',
    Version: 'E1.0',
    name: 'pound banknote',
    category: 'Objects',
    SubGroup: 'money'
  },
  {
    CodePointsHex: ['1F4B8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCB8',
    Version: 'E0.6',
    name: 'money with wings',
    category: 'Objects',
    SubGroup: 'money'
  },
  {
    CodePointsHex: ['1F4B3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCB3',
    Version: 'E0.6',
    name: 'credit card',
    category: 'Objects',
    SubGroup: 'money'
  },
  {
    CodePointsHex: ['1F9FE'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDFE',
    Version: 'E11.0',
    name: 'receipt',
    category: 'Objects',
    SubGroup: 'money'
  },
  {
    CodePointsHex: ['1F4B9'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCB9',
    Version: 'E0.6',
    name: 'chart increasing with yen',
    category: 'Objects',
    SubGroup: 'money'
  },
  {
    CodePointsHex: ['2709', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2709\uFE0F',
    Version: 'E0.6',
    name: 'envelope',
    category: 'Objects',
    SubGroup: 'mail'
  },
  {
    CodePointsHex: ['2709'],
    Status: 'unqualified',
    char: '\u2709',
    Version: 'E0.6',
    name: 'envelope',
    category: 'Objects',
    SubGroup: 'mail'
  },
  {
    CodePointsHex: ['1F4E7'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCE7',
    Version: 'E0.6',
    name: 'e-mail',
    category: 'Objects',
    SubGroup: 'mail'
  },
  {
    CodePointsHex: ['1F4E8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCE8',
    Version: 'E0.6',
    name: 'incoming envelope',
    category: 'Objects',
    SubGroup: 'mail'
  },
  {
    CodePointsHex: ['1F4E9'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCE9',
    Version: 'E0.6',
    name: 'envelope with arrow',
    category: 'Objects',
    SubGroup: 'mail'
  },
  {
    CodePointsHex: ['1F4E4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCE4',
    Version: 'E0.6',
    name: 'outbox tray',
    category: 'Objects',
    SubGroup: 'mail'
  },
  {
    CodePointsHex: ['1F4E5'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCE5',
    Version: 'E0.6',
    name: 'inbox tray',
    category: 'Objects',
    SubGroup: 'mail'
  },
  {
    CodePointsHex: ['1F4E6'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCE6',
    Version: 'E0.6',
    name: 'package',
    category: 'Objects',
    SubGroup: 'mail'
  },
  {
    CodePointsHex: ['1F4EB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCEB',
    Version: 'E0.6',
    name: 'closed mailbox with raised flag',
    category: 'Objects',
    SubGroup: 'mail'
  },
  {
    CodePointsHex: ['1F4EA'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCEA',
    Version: 'E0.6',
    name: 'closed mailbox with lowered flag',
    category: 'Objects',
    SubGroup: 'mail'
  },
  {
    CodePointsHex: ['1F4EC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCEC',
    Version: 'E0.7',
    name: 'open mailbox with raised flag',
    category: 'Objects',
    SubGroup: 'mail'
  },
  {
    CodePointsHex: ['1F4ED'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCED',
    Version: 'E0.7',
    name: 'open mailbox with lowered flag',
    category: 'Objects',
    SubGroup: 'mail'
  },
  {
    CodePointsHex: ['1F4EE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCEE',
    Version: 'E0.6',
    name: 'postbox',
    category: 'Objects',
    SubGroup: 'mail'
  },
  {
    CodePointsHex: ['1F5F3', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDF3\uFE0F',
    Version: 'E0.7',
    name: 'ballot box with ballot',
    category: 'Objects',
    SubGroup: 'mail'
  },
  {
    CodePointsHex: ['1F5F3'],
    Status: 'unqualified',
    char: '\uD83D\uDDF3',
    Version: 'E0.7',
    name: 'ballot box with ballot',
    category: 'Objects',
    SubGroup: 'mail'
  },
  {
    CodePointsHex: ['270F', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u270F\uFE0F',
    Version: 'E0.6',
    name: 'pencil',
    category: 'Objects',
    SubGroup: 'writing'
  },
  {
    CodePointsHex: ['270F'],
    Status: 'unqualified',
    char: '\u270F',
    Version: 'E0.6',
    name: 'pencil',
    category: 'Objects',
    SubGroup: 'writing'
  },
  {
    CodePointsHex: ['2712', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2712\uFE0F',
    Version: 'E0.6',
    name: 'black nib',
    category: 'Objects',
    SubGroup: 'writing'
  },
  {
    CodePointsHex: ['2712'],
    Status: 'unqualified',
    char: '\u2712',
    Version: 'E0.6',
    name: 'black nib',
    category: 'Objects',
    SubGroup: 'writing'
  },
  {
    CodePointsHex: ['1F58B', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD8B\uFE0F',
    Version: 'E0.7',
    name: 'fountain pen',
    category: 'Objects',
    SubGroup: 'writing'
  },
  {
    CodePointsHex: ['1F58B'],
    Status: 'unqualified',
    char: '\uD83D\uDD8B',
    Version: 'E0.7',
    name: 'fountain pen',
    category: 'Objects',
    SubGroup: 'writing'
  },
  {
    CodePointsHex: ['1F58A', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD8A\uFE0F',
    Version: 'E0.7',
    name: 'pen',
    category: 'Objects',
    SubGroup: 'writing'
  },
  {
    CodePointsHex: ['1F58A'],
    Status: 'unqualified',
    char: '\uD83D\uDD8A',
    Version: 'E0.7',
    name: 'pen',
    category: 'Objects',
    SubGroup: 'writing'
  },
  {
    CodePointsHex: ['1F58C', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD8C\uFE0F',
    Version: 'E0.7',
    name: 'paintbrush',
    category: 'Objects',
    SubGroup: 'writing'
  },
  {
    CodePointsHex: ['1F58C'],
    Status: 'unqualified',
    char: '\uD83D\uDD8C',
    Version: 'E0.7',
    name: 'paintbrush',
    category: 'Objects',
    SubGroup: 'writing'
  },
  {
    CodePointsHex: ['1F58D', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD8D\uFE0F',
    Version: 'E0.7',
    name: 'crayon',
    category: 'Objects',
    SubGroup: 'writing'
  },
  {
    CodePointsHex: ['1F58D'],
    Status: 'unqualified',
    char: '\uD83D\uDD8D',
    Version: 'E0.7',
    name: 'crayon',
    category: 'Objects',
    SubGroup: 'writing'
  },
  {
    CodePointsHex: ['1F4DD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCDD',
    Version: 'E0.6',
    name: 'memo',
    category: 'Objects',
    SubGroup: 'writing'
  },
  {
    CodePointsHex: ['1F4BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCBC',
    Version: 'E0.6',
    name: 'briefcase',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F4C1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCC1',
    Version: 'E0.6',
    name: 'file folder',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F4C2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCC2',
    Version: 'E0.6',
    name: 'open file folder',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F5C2', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDC2\uFE0F',
    Version: 'E0.7',
    name: 'card index dividers',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F5C2'],
    Status: 'unqualified',
    char: '\uD83D\uDDC2',
    Version: 'E0.7',
    name: 'card index dividers',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F4C5'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCC5',
    Version: 'E0.6',
    name: 'calendar',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F4C6'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCC6',
    Version: 'E0.6',
    name: 'tear-off calendar',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F5D2', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDD2\uFE0F',
    Version: 'E0.7',
    name: 'spiral notepad',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F5D2'],
    Status: 'unqualified',
    char: '\uD83D\uDDD2',
    Version: 'E0.7',
    name: 'spiral notepad',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F5D3', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDD3\uFE0F',
    Version: 'E0.7',
    name: 'spiral calendar',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F5D3'],
    Status: 'unqualified',
    char: '\uD83D\uDDD3',
    Version: 'E0.7',
    name: 'spiral calendar',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F4C7'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCC7',
    Version: 'E0.6',
    name: 'card index',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F4C8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCC8',
    Version: 'E0.6',
    name: 'chart increasing',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F4C9'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCC9',
    Version: 'E0.6',
    name: 'chart decreasing',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F4CA'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCCA',
    Version: 'E0.6',
    name: 'bar chart',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F4CB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCCB',
    Version: 'E0.6',
    name: 'clipboard',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F4CC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCCC',
    Version: 'E0.6',
    name: 'pushpin',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F4CD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCCD',
    Version: 'E0.6',
    name: 'round pushpin',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F4CE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCCE',
    Version: 'E0.6',
    name: 'paperclip',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F587', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD87\uFE0F',
    Version: 'E0.7',
    name: 'linked paperclips',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F587'],
    Status: 'unqualified',
    char: '\uD83D\uDD87',
    Version: 'E0.7',
    name: 'linked paperclips',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F4CF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCCF',
    Version: 'E0.6',
    name: 'straight ruler',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F4D0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCD0',
    Version: 'E0.6',
    name: 'triangular ruler',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['2702', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2702\uFE0F',
    Version: 'E0.6',
    name: 'scissors',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['2702'],
    Status: 'unqualified',
    char: '\u2702',
    Version: 'E0.6',
    name: 'scissors',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F5C3', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDC3\uFE0F',
    Version: 'E0.7',
    name: 'card file box',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F5C3'],
    Status: 'unqualified',
    char: '\uD83D\uDDC3',
    Version: 'E0.7',
    name: 'card file box',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F5C4', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDC4\uFE0F',
    Version: 'E0.7',
    name: 'file cabinet',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F5C4'],
    Status: 'unqualified',
    char: '\uD83D\uDDC4',
    Version: 'E0.7',
    name: 'file cabinet',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F5D1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDD1\uFE0F',
    Version: 'E0.7',
    name: 'wastebasket',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F5D1'],
    Status: 'unqualified',
    char: '\uD83D\uDDD1',
    Version: 'E0.7',
    name: 'wastebasket',
    category: 'Objects',
    SubGroup: 'office'
  },
  {
    CodePointsHex: ['1F512'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD12',
    Version: 'E0.6',
    name: 'locked',
    category: 'Objects',
    SubGroup: 'lock'
  },
  {
    CodePointsHex: ['1F513'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD13',
    Version: 'E0.6',
    name: 'unlocked',
    category: 'Objects',
    SubGroup: 'lock'
  },
  {
    CodePointsHex: ['1F50F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD0F',
    Version: 'E0.6',
    name: 'locked with pen',
    category: 'Objects',
    SubGroup: 'lock'
  },
  {
    CodePointsHex: ['1F510'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD10',
    Version: 'E0.6',
    name: 'locked with key',
    category: 'Objects',
    SubGroup: 'lock'
  },
  {
    CodePointsHex: ['1F511'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD11',
    Version: 'E0.6',
    name: 'key',
    category: 'Objects',
    SubGroup: 'lock'
  },
  {
    CodePointsHex: ['1F5DD', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDDD\uFE0F',
    Version: 'E0.7',
    name: 'old key',
    category: 'Objects',
    SubGroup: 'lock'
  },
  {
    CodePointsHex: ['1F5DD'],
    Status: 'unqualified',
    char: '\uD83D\uDDDD',
    Version: 'E0.7',
    name: 'old key',
    category: 'Objects',
    SubGroup: 'lock'
  },
  {
    CodePointsHex: ['1F528'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD28',
    Version: 'E0.6',
    name: 'hammer',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1FA93'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE93',
    Version: 'E12.0',
    name: 'axe',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['26CF', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26CF\uFE0F',
    Version: 'E0.7',
    name: 'pick',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['26CF'],
    Status: 'unqualified',
    char: '\u26CF',
    Version: 'E0.7',
    name: 'pick',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['2692', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2692\uFE0F',
    Version: 'E1.0',
    name: 'hammer and pick',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['2692'],
    Status: 'unqualified',
    char: '\u2692',
    Version: 'E1.0',
    name: 'hammer and pick',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1F6E0', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEE0\uFE0F',
    Version: 'E0.7',
    name: 'hammer and wrench',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1F6E0'],
    Status: 'unqualified',
    char: '\uD83D\uDEE0',
    Version: 'E0.7',
    name: 'hammer and wrench',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1F5E1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDE1\uFE0F',
    Version: 'E0.7',
    name: 'dagger',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1F5E1'],
    Status: 'unqualified',
    char: '\uD83D\uDDE1',
    Version: 'E0.7',
    name: 'dagger',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['2694', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2694\uFE0F',
    Version: 'E1.0',
    name: 'crossed swords',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['2694'],
    Status: 'unqualified',
    char: '\u2694',
    Version: 'E1.0',
    name: 'crossed swords',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1F4A3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCA3',
    Version: 'E0.6',
    name: 'bomb',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1FA83'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE83',
    Version: 'E13.0',
    name: 'boomerang',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1F3F9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFF9',
    Version: 'E1.0',
    name: 'bow and arrow',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1F6E1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEE1\uFE0F',
    Version: 'E0.7',
    name: 'shield',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1F6E1'],
    Status: 'unqualified',
    char: '\uD83D\uDEE1',
    Version: 'E0.7',
    name: 'shield',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1FA9A'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE9A',
    Version: 'E13.0',
    name: 'carpentry saw',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1F527'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD27',
    Version: 'E0.6',
    name: 'wrench',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1FA9B'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE9B',
    Version: 'E13.0',
    name: 'screwdriver',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1F529'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD29',
    Version: 'E0.6',
    name: 'nut and bolt',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['2699', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2699\uFE0F',
    Version: 'E1.0',
    name: 'gear',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['2699'],
    Status: 'unqualified',
    char: '\u2699',
    Version: 'E1.0',
    name: 'gear',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1F5DC', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDDC\uFE0F',
    Version: 'E0.7',
    name: 'clamp',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1F5DC'],
    Status: 'unqualified',
    char: '\uD83D\uDDDC',
    Version: 'E0.7',
    name: 'clamp',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['2696', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2696\uFE0F',
    Version: 'E1.0',
    name: 'balance scale',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['2696'],
    Status: 'unqualified',
    char: '\u2696',
    Version: 'E1.0',
    name: 'balance scale',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1F9AF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDAF',
    Version: 'E12.0',
    name: 'white cane',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1F517'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD17',
    Version: 'E0.6',
    name: 'link',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['26D3', 'FE0F', '200D', '1F4A5'],
    Status: 'fully-qualified',
    char: '\u26D3\uFE0F\u200D\uD83D\uDCA5',
    Version: 'E15.1',
    name: 'broken chain',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['26D3', '200D', '1F4A5'],
    Status: 'unqualified',
    char: '\u26D3\u200D\uD83D\uDCA5',
    Version: 'E15.1',
    name: 'broken chain',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['26D3', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26D3\uFE0F',
    Version: 'E0.7',
    name: 'chains',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['26D3'],
    Status: 'unqualified',
    char: '\u26D3',
    Version: 'E0.7',
    name: 'chains',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1FA9D'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE9D',
    Version: 'E13.0',
    name: 'hook',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1F9F0'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDF0',
    Version: 'E11.0',
    name: 'toolbox',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1F9F2'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDF2',
    Version: 'E11.0',
    name: 'magnet',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1FA9C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE9C',
    Version: 'E13.0',
    name: 'ladder',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['1FA8F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE8F',
    Version: 'E16.0',
    name: 'shovel',
    category: 'Objects',
    SubGroup: 'tool'
  },
  {
    CodePointsHex: ['2697', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2697\uFE0F',
    Version: 'E1.0',
    name: 'alembic',
    category: 'Objects',
    SubGroup: 'science'
  },
  {
    CodePointsHex: ['2697'],
    Status: 'unqualified',
    char: '\u2697',
    Version: 'E1.0',
    name: 'alembic',
    category: 'Objects',
    SubGroup: 'science'
  },
  {
    CodePointsHex: ['1F9EA'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDEA',
    Version: 'E11.0',
    name: 'test tube',
    category: 'Objects',
    SubGroup: 'science'
  },
  {
    CodePointsHex: ['1F9EB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDEB',
    Version: 'E11.0',
    name: 'petri dish',
    category: 'Objects',
    SubGroup: 'science'
  },
  {
    CodePointsHex: ['1F9EC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDEC',
    Version: 'E11.0',
    name: 'dna',
    category: 'Objects',
    SubGroup: 'science'
  },
  {
    CodePointsHex: ['1F52C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD2C',
    Version: 'E1.0',
    name: 'microscope',
    category: 'Objects',
    SubGroup: 'science'
  },
  {
    CodePointsHex: ['1F52D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD2D',
    Version: 'E1.0',
    name: 'telescope',
    category: 'Objects',
    SubGroup: 'science'
  },
  {
    CodePointsHex: ['1F4E1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCE1',
    Version: 'E0.6',
    name: 'satellite antenna',
    category: 'Objects',
    SubGroup: 'science'
  },
  {
    CodePointsHex: ['1F489'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC89',
    Version: 'E0.6',
    name: 'syringe',
    category: 'Objects',
    SubGroup: 'medical'
  },
  {
    CodePointsHex: ['1FA78'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE78',
    Version: 'E12.0',
    name: 'drop of blood',
    category: 'Objects',
    SubGroup: 'medical'
  },
  {
    CodePointsHex: ['1F48A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDC8A',
    Version: 'E0.6',
    name: 'pill',
    category: 'Objects',
    SubGroup: 'medical'
  },
  {
    CodePointsHex: ['1FA79'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE79',
    Version: 'E12.0',
    name: 'adhesive bandage',
    category: 'Objects',
    SubGroup: 'medical'
  },
  {
    CodePointsHex: ['1FA7C'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE7C',
    Version: 'E14.0',
    name: 'crutch',
    category: 'Objects',
    SubGroup: 'medical'
  },
  {
    CodePointsHex: ['1FA7A'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE7A',
    Version: 'E12.0',
    name: 'stethoscope',
    category: 'Objects',
    SubGroup: 'medical'
  },
  {
    CodePointsHex: ['1FA7B'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE7B',
    Version: 'E14.0',
    name: 'x-ray',
    category: 'Objects',
    SubGroup: 'medical'
  },
  {
    CodePointsHex: ['1F6AA'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEAA',
    Version: 'E0.6',
    name: 'door',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1F6D7'],
    Status: 'fully-qualified',
    char: '\uD83D\uDED7',
    Version: 'E13.0',
    name: 'elevator',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1FA9E'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE9E',
    Version: 'E13.0',
    name: 'mirror',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1FA9F'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE9F',
    Version: 'E13.0',
    name: 'window',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1F6CF', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDECF\uFE0F',
    Version: 'E0.7',
    name: 'bed',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1F6CF'],
    Status: 'unqualified',
    char: '\uD83D\uDECF',
    Version: 'E0.7',
    name: 'bed',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1F6CB', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDECB\uFE0F',
    Version: 'E0.7',
    name: 'couch and lamp',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1F6CB'],
    Status: 'unqualified',
    char: '\uD83D\uDECB',
    Version: 'E0.7',
    name: 'couch and lamp',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1FA91'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE91',
    Version: 'E12.0',
    name: 'chair',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1F6BD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEBD',
    Version: 'E0.6',
    name: 'toilet',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1FAA0'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEA0',
    Version: 'E13.0',
    name: 'plunger',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1F6BF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEBF',
    Version: 'E1.0',
    name: 'shower',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1F6C1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEC1',
    Version: 'E1.0',
    name: 'bathtub',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1FAA4'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEA4',
    Version: 'E13.0',
    name: 'mouse trap',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1FA92'],
    Status: 'fully-qualified',
    char: '\uD83E\uDE92',
    Version: 'E12.0',
    name: 'razor',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1F9F4'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDF4',
    Version: 'E11.0',
    name: 'lotion bottle',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1F9F7'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDF7',
    Version: 'E11.0',
    name: 'safety pin',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1F9F9'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDF9',
    Version: 'E11.0',
    name: 'broom',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1F9FA'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDFA',
    Version: 'E11.0',
    name: 'basket',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1F9FB'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDFB',
    Version: 'E11.0',
    name: 'roll of paper',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1FAA3'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEA3',
    Version: 'E13.0',
    name: 'bucket',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1F9FC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDFC',
    Version: 'E11.0',
    name: 'soap',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1FAE7'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEE7',
    Version: 'E14.0',
    name: 'bubbles',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1FAA5'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEA5',
    Version: 'E13.0',
    name: 'toothbrush',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1F9FD'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDFD',
    Version: 'E11.0',
    name: 'sponge',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1F9EF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDEF',
    Version: 'E11.0',
    name: 'fire extinguisher',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1F6D2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDED2',
    Version: 'E3.0',
    name: 'shopping cart',
    category: 'Objects',
    SubGroup: 'household'
  },
  {
    CodePointsHex: ['1F6AC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEAC',
    Version: 'E0.6',
    name: 'cigarette',
    category: 'Objects',
    SubGroup: 'other-object'
  },
  {
    CodePointsHex: ['26B0', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26B0\uFE0F',
    Version: 'E1.0',
    name: 'coffin',
    category: 'Objects',
    SubGroup: 'other-object'
  },
  {
    CodePointsHex: ['26B0'],
    Status: 'unqualified',
    char: '\u26B0',
    Version: 'E1.0',
    name: 'coffin',
    category: 'Objects',
    SubGroup: 'other-object'
  },
  {
    CodePointsHex: ['1FAA6'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEA6',
    Version: 'E13.0',
    name: 'headstone',
    category: 'Objects',
    SubGroup: 'other-object'
  },
  {
    CodePointsHex: ['26B1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26B1\uFE0F',
    Version: 'E1.0',
    name: 'funeral urn',
    category: 'Objects',
    SubGroup: 'other-object'
  },
  {
    CodePointsHex: ['26B1'],
    Status: 'unqualified',
    char: '\u26B1',
    Version: 'E1.0',
    name: 'funeral urn',
    category: 'Objects',
    SubGroup: 'other-object'
  },
  {
    CodePointsHex: ['1F9FF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDDFF',
    Version: 'E11.0',
    name: 'nazar amulet',
    category: 'Objects',
    SubGroup: 'other-object'
  },
  {
    CodePointsHex: ['1FAAC'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEAC',
    Version: 'E14.0',
    name: 'hamsa',
    category: 'Objects',
    SubGroup: 'other-object'
  },
  {
    CodePointsHex: ['1F5FF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDDFF',
    Version: 'E0.6',
    name: 'moai',
    category: 'Objects',
    SubGroup: 'other-object'
  },
  {
    CodePointsHex: ['1FAA7'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEA7',
    Version: 'E13.0',
    name: 'placard',
    category: 'Objects',
    SubGroup: 'other-object'
  },
  {
    CodePointsHex: ['1FAAA'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEAA',
    Version: 'E14.0',
    name: 'identification card',
    category: 'Objects',
    SubGroup: 'other-object'
  },
  {
    CodePointsHex: ['1F3E7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFE7',
    Version: 'E0.6',
    name: 'ATM sign',
    category: 'Symbols',
    SubGroup: 'transport-sign'
  },
  {
    CodePointsHex: ['1F6AE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEAE',
    Version: 'E1.0',
    name: 'litter in bin sign',
    category: 'Symbols',
    SubGroup: 'transport-sign'
  },
  {
    CodePointsHex: ['1F6B0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB0',
    Version: 'E1.0',
    name: 'potable water',
    category: 'Symbols',
    SubGroup: 'transport-sign'
  },
  {
    CodePointsHex: ['267F'],
    Status: 'fully-qualified',
    char: '\u267F',
    Version: 'E0.6',
    name: 'wheelchair symbol',
    category: 'Symbols',
    SubGroup: 'transport-sign'
  },
  {
    CodePointsHex: ['1F6B9'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB9',
    Version: 'E0.6',
    name: 'men\u2019s room',
    category: 'Symbols',
    SubGroup: 'transport-sign'
  },
  {
    CodePointsHex: ['1F6BA'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEBA',
    Version: 'E0.6',
    name: 'women\u2019s room',
    category: 'Symbols',
    SubGroup: 'transport-sign'
  },
  {
    CodePointsHex: ['1F6BB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEBB',
    Version: 'E0.6',
    name: 'restroom',
    category: 'Symbols',
    SubGroup: 'transport-sign'
  },
  {
    CodePointsHex: ['1F6BC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEBC',
    Version: 'E0.6',
    name: 'baby symbol',
    category: 'Symbols',
    SubGroup: 'transport-sign'
  },
  {
    CodePointsHex: ['1F6BE'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEBE',
    Version: 'E0.6',
    name: 'water closet',
    category: 'Symbols',
    SubGroup: 'transport-sign'
  },
  {
    CodePointsHex: ['1F6C2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEC2',
    Version: 'E1.0',
    name: 'passport control',
    category: 'Symbols',
    SubGroup: 'transport-sign'
  },
  {
    CodePointsHex: ['1F6C3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEC3',
    Version: 'E1.0',
    name: 'customs',
    category: 'Symbols',
    SubGroup: 'transport-sign'
  },
  {
    CodePointsHex: ['1F6C4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEC4',
    Version: 'E1.0',
    name: 'baggage claim',
    category: 'Symbols',
    SubGroup: 'transport-sign'
  },
  {
    CodePointsHex: ['1F6C5'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEC5',
    Version: 'E1.0',
    name: 'left luggage',
    category: 'Symbols',
    SubGroup: 'transport-sign'
  },
  {
    CodePointsHex: ['26A0', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26A0\uFE0F',
    Version: 'E0.6',
    name: 'warning',
    category: 'Symbols',
    SubGroup: 'warning'
  },
  {
    CodePointsHex: ['26A0'],
    Status: 'unqualified',
    char: '\u26A0',
    Version: 'E0.6',
    name: 'warning',
    category: 'Symbols',
    SubGroup: 'warning'
  },
  {
    CodePointsHex: ['1F6B8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB8',
    Version: 'E1.0',
    name: 'children crossing',
    category: 'Symbols',
    SubGroup: 'warning'
  },
  {
    CodePointsHex: ['26D4'],
    Status: 'fully-qualified',
    char: '\u26D4',
    Version: 'E0.6',
    name: 'no entry',
    category: 'Symbols',
    SubGroup: 'warning'
  },
  {
    CodePointsHex: ['1F6AB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEAB',
    Version: 'E0.6',
    name: 'prohibited',
    category: 'Symbols',
    SubGroup: 'warning'
  },
  {
    CodePointsHex: ['1F6B3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB3',
    Version: 'E1.0',
    name: 'no bicycles',
    category: 'Symbols',
    SubGroup: 'warning'
  },
  {
    CodePointsHex: ['1F6AD'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEAD',
    Version: 'E0.6',
    name: 'no smoking',
    category: 'Symbols',
    SubGroup: 'warning'
  },
  {
    CodePointsHex: ['1F6AF'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEAF',
    Version: 'E1.0',
    name: 'no littering',
    category: 'Symbols',
    SubGroup: 'warning'
  },
  {
    CodePointsHex: ['1F6B1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB1',
    Version: 'E1.0',
    name: 'non-potable water',
    category: 'Symbols',
    SubGroup: 'warning'
  },
  {
    CodePointsHex: ['1F6B7'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEB7',
    Version: 'E1.0',
    name: 'no pedestrians',
    category: 'Symbols',
    SubGroup: 'warning'
  },
  {
    CodePointsHex: ['1F4F5'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCF5',
    Version: 'E1.0',
    name: 'no mobile phones',
    category: 'Symbols',
    SubGroup: 'warning'
  },
  {
    CodePointsHex: ['1F51E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD1E',
    Version: 'E0.6',
    name: 'no one under eighteen',
    category: 'Symbols',
    SubGroup: 'warning'
  },
  {
    CodePointsHex: ['2622', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2622\uFE0F',
    Version: 'E1.0',
    name: 'radioactive',
    category: 'Symbols',
    SubGroup: 'warning'
  },
  {
    CodePointsHex: ['2622'],
    Status: 'unqualified',
    char: '\u2622',
    Version: 'E1.0',
    name: 'radioactive',
    category: 'Symbols',
    SubGroup: 'warning'
  },
  {
    CodePointsHex: ['2623', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2623\uFE0F',
    Version: 'E1.0',
    name: 'biohazard',
    category: 'Symbols',
    SubGroup: 'warning'
  },
  {
    CodePointsHex: ['2623'],
    Status: 'unqualified',
    char: '\u2623',
    Version: 'E1.0',
    name: 'biohazard',
    category: 'Symbols',
    SubGroup: 'warning'
  },
  {
    CodePointsHex: ['2B06', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2B06\uFE0F',
    Version: 'E0.6',
    name: 'up arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2B06'],
    Status: 'unqualified',
    char: '\u2B06',
    Version: 'E0.6',
    name: 'up arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2197', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2197\uFE0F',
    Version: 'E0.6',
    name: 'up-right arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2197'],
    Status: 'unqualified',
    char: '\u2197',
    Version: 'E0.6',
    name: 'up-right arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['27A1', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u27A1\uFE0F',
    Version: 'E0.6',
    name: 'right arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['27A1'],
    Status: 'unqualified',
    char: '\u27A1',
    Version: 'E0.6',
    name: 'right arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2198', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2198\uFE0F',
    Version: 'E0.6',
    name: 'down-right arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2198'],
    Status: 'unqualified',
    char: '\u2198',
    Version: 'E0.6',
    name: 'down-right arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2B07', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2B07\uFE0F',
    Version: 'E0.6',
    name: 'down arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2B07'],
    Status: 'unqualified',
    char: '\u2B07',
    Version: 'E0.6',
    name: 'down arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2199', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2199\uFE0F',
    Version: 'E0.6',
    name: 'down-left arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2199'],
    Status: 'unqualified',
    char: '\u2199',
    Version: 'E0.6',
    name: 'down-left arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2B05', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2B05\uFE0F',
    Version: 'E0.6',
    name: 'left arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2B05'],
    Status: 'unqualified',
    char: '\u2B05',
    Version: 'E0.6',
    name: 'left arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2196', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2196\uFE0F',
    Version: 'E0.6',
    name: 'up-left arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2196'],
    Status: 'unqualified',
    char: '\u2196',
    Version: 'E0.6',
    name: 'up-left arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2195', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2195\uFE0F',
    Version: 'E0.6',
    name: 'up-down arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2195'],
    Status: 'unqualified',
    char: '\u2195',
    Version: 'E0.6',
    name: 'up-down arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2194', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2194\uFE0F',
    Version: 'E0.6',
    name: 'left-right arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2194'],
    Status: 'unqualified',
    char: '\u2194',
    Version: 'E0.6',
    name: 'left-right arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['21A9', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u21A9\uFE0F',
    Version: 'E0.6',
    name: 'right arrow curving left',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['21A9'],
    Status: 'unqualified',
    char: '\u21A9',
    Version: 'E0.6',
    name: 'right arrow curving left',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['21AA', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u21AA\uFE0F',
    Version: 'E0.6',
    name: 'left arrow curving right',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['21AA'],
    Status: 'unqualified',
    char: '\u21AA',
    Version: 'E0.6',
    name: 'left arrow curving right',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2934', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2934\uFE0F',
    Version: 'E0.6',
    name: 'right arrow curving up',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2934'],
    Status: 'unqualified',
    char: '\u2934',
    Version: 'E0.6',
    name: 'right arrow curving up',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2935', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2935\uFE0F',
    Version: 'E0.6',
    name: 'right arrow curving down',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['2935'],
    Status: 'unqualified',
    char: '\u2935',
    Version: 'E0.6',
    name: 'right arrow curving down',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['1F503'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD03',
    Version: 'E0.6',
    name: 'clockwise vertical arrows',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['1F504'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD04',
    Version: 'E1.0',
    name: 'counterclockwise arrows button',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['1F519'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD19',
    Version: 'E0.6',
    name: 'BACK arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['1F51A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD1A',
    Version: 'E0.6',
    name: 'END arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['1F51B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD1B',
    Version: 'E0.6',
    name: 'ON! arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['1F51C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD1C',
    Version: 'E0.6',
    name: 'SOON arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['1F51D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD1D',
    Version: 'E0.6',
    name: 'TOP arrow',
    category: 'Symbols',
    SubGroup: 'arrow'
  },
  {
    CodePointsHex: ['1F6D0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDED0',
    Version: 'E1.0',
    name: 'place of worship',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['269B', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u269B\uFE0F',
    Version: 'E1.0',
    name: 'atom symbol',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['269B'],
    Status: 'unqualified',
    char: '\u269B',
    Version: 'E1.0',
    name: 'atom symbol',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['1F549', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD49\uFE0F',
    Version: 'E0.7',
    name: 'om',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['1F549'],
    Status: 'unqualified',
    char: '\uD83D\uDD49',
    Version: 'E0.7',
    name: 'om',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['2721', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2721\uFE0F',
    Version: 'E0.7',
    name: 'star of David',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['2721'],
    Status: 'unqualified',
    char: '\u2721',
    Version: 'E0.7',
    name: 'star of David',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['2638', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2638\uFE0F',
    Version: 'E0.7',
    name: 'wheel of dharma',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['2638'],
    Status: 'unqualified',
    char: '\u2638',
    Version: 'E0.7',
    name: 'wheel of dharma',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['262F', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u262F\uFE0F',
    Version: 'E0.7',
    name: 'yin yang',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['262F'],
    Status: 'unqualified',
    char: '\u262F',
    Version: 'E0.7',
    name: 'yin yang',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['271D', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u271D\uFE0F',
    Version: 'E0.7',
    name: 'latin cross',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['271D'],
    Status: 'unqualified',
    char: '\u271D',
    Version: 'E0.7',
    name: 'latin cross',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['2626', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2626\uFE0F',
    Version: 'E1.0',
    name: 'orthodox cross',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['2626'],
    Status: 'unqualified',
    char: '\u2626',
    Version: 'E1.0',
    name: 'orthodox cross',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['262A', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u262A\uFE0F',
    Version: 'E0.7',
    name: 'star and crescent',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['262A'],
    Status: 'unqualified',
    char: '\u262A',
    Version: 'E0.7',
    name: 'star and crescent',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['262E', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u262E\uFE0F',
    Version: 'E1.0',
    name: 'peace symbol',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['262E'],
    Status: 'unqualified',
    char: '\u262E',
    Version: 'E1.0',
    name: 'peace symbol',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['1F54E'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD4E',
    Version: 'E1.0',
    name: 'menorah',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['1F52F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD2F',
    Version: 'E0.6',
    name: 'dotted six-pointed star',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['1FAAF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEAF',
    Version: 'E15.0',
    name: 'khanda',
    category: 'Symbols',
    SubGroup: 'religion'
  },
  {
    CodePointsHex: ['2648'],
    Status: 'fully-qualified',
    char: '\u2648',
    Version: 'E0.6',
    name: 'Aries',
    category: 'Symbols',
    SubGroup: 'zodiac'
  },
  {
    CodePointsHex: ['2649'],
    Status: 'fully-qualified',
    char: '\u2649',
    Version: 'E0.6',
    name: 'Taurus',
    category: 'Symbols',
    SubGroup: 'zodiac'
  },
  {
    CodePointsHex: ['264A'],
    Status: 'fully-qualified',
    char: '\u264A',
    Version: 'E0.6',
    name: 'Gemini',
    category: 'Symbols',
    SubGroup: 'zodiac'
  },
  {
    CodePointsHex: ['264B'],
    Status: 'fully-qualified',
    char: '\u264B',
    Version: 'E0.6',
    name: 'Cancer',
    category: 'Symbols',
    SubGroup: 'zodiac'
  },
  {
    CodePointsHex: ['264C'],
    Status: 'fully-qualified',
    char: '\u264C',
    Version: 'E0.6',
    name: 'Leo',
    category: 'Symbols',
    SubGroup: 'zodiac'
  },
  {
    CodePointsHex: ['264D'],
    Status: 'fully-qualified',
    char: '\u264D',
    Version: 'E0.6',
    name: 'Virgo',
    category: 'Symbols',
    SubGroup: 'zodiac'
  },
  {
    CodePointsHex: ['264E'],
    Status: 'fully-qualified',
    char: '\u264E',
    Version: 'E0.6',
    name: 'Libra',
    category: 'Symbols',
    SubGroup: 'zodiac'
  },
  {
    CodePointsHex: ['264F'],
    Status: 'fully-qualified',
    char: '\u264F',
    Version: 'E0.6',
    name: 'Scorpio',
    category: 'Symbols',
    SubGroup: 'zodiac'
  },
  {
    CodePointsHex: ['2650'],
    Status: 'fully-qualified',
    char: '\u2650',
    Version: 'E0.6',
    name: 'Sagittarius',
    category: 'Symbols',
    SubGroup: 'zodiac'
  },
  {
    CodePointsHex: ['2651'],
    Status: 'fully-qualified',
    char: '\u2651',
    Version: 'E0.6',
    name: 'Capricorn',
    category: 'Symbols',
    SubGroup: 'zodiac'
  },
  {
    CodePointsHex: ['2652'],
    Status: 'fully-qualified',
    char: '\u2652',
    Version: 'E0.6',
    name: 'Aquarius',
    category: 'Symbols',
    SubGroup: 'zodiac'
  },
  {
    CodePointsHex: ['2653'],
    Status: 'fully-qualified',
    char: '\u2653',
    Version: 'E0.6',
    name: 'Pisces',
    category: 'Symbols',
    SubGroup: 'zodiac'
  },
  {
    CodePointsHex: ['26CE'],
    Status: 'fully-qualified',
    char: '\u26CE',
    Version: 'E0.6',
    name: 'Ophiuchus',
    category: 'Symbols',
    SubGroup: 'zodiac'
  },
  {
    CodePointsHex: ['1F500'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD00',
    Version: 'E1.0',
    name: 'shuffle tracks button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['1F501'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD01',
    Version: 'E1.0',
    name: 'repeat button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['1F502'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD02',
    Version: 'E1.0',
    name: 'repeat single button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['25B6', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u25B6\uFE0F',
    Version: 'E0.6',
    name: 'play button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['25B6'],
    Status: 'unqualified',
    char: '\u25B6',
    Version: 'E0.6',
    name: 'play button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['23E9'],
    Status: 'fully-qualified',
    char: '\u23E9',
    Version: 'E0.6',
    name: 'fast-forward button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['23ED', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u23ED\uFE0F',
    Version: 'E0.7',
    name: 'next track button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['23ED'],
    Status: 'unqualified',
    char: '\u23ED',
    Version: 'E0.7',
    name: 'next track button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['23EF', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u23EF\uFE0F',
    Version: 'E1.0',
    name: 'play or pause button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['23EF'],
    Status: 'unqualified',
    char: '\u23EF',
    Version: 'E1.0',
    name: 'play or pause button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['25C0', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u25C0\uFE0F',
    Version: 'E0.6',
    name: 'reverse button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['25C0'],
    Status: 'unqualified',
    char: '\u25C0',
    Version: 'E0.6',
    name: 'reverse button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['23EA'],
    Status: 'fully-qualified',
    char: '\u23EA',
    Version: 'E0.6',
    name: 'fast reverse button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['23EE', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u23EE\uFE0F',
    Version: 'E0.7',
    name: 'last track button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['23EE'],
    Status: 'unqualified',
    char: '\u23EE',
    Version: 'E0.7',
    name: 'last track button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['1F53C'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD3C',
    Version: 'E0.6',
    name: 'upwards button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['23EB'],
    Status: 'fully-qualified',
    char: '\u23EB',
    Version: 'E0.6',
    name: 'fast up button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['1F53D'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD3D',
    Version: 'E0.6',
    name: 'downwards button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['23EC'],
    Status: 'fully-qualified',
    char: '\u23EC',
    Version: 'E0.6',
    name: 'fast down button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['23F8', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u23F8\uFE0F',
    Version: 'E0.7',
    name: 'pause button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['23F8'],
    Status: 'unqualified',
    char: '\u23F8',
    Version: 'E0.7',
    name: 'pause button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['23F9', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u23F9\uFE0F',
    Version: 'E0.7',
    name: 'stop button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['23F9'],
    Status: 'unqualified',
    char: '\u23F9',
    Version: 'E0.7',
    name: 'stop button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['23FA', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u23FA\uFE0F',
    Version: 'E0.7',
    name: 'record button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['23FA'],
    Status: 'unqualified',
    char: '\u23FA',
    Version: 'E0.7',
    name: 'record button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['23CF', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u23CF\uFE0F',
    Version: 'E1.0',
    name: 'eject button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['23CF'],
    Status: 'unqualified',
    char: '\u23CF',
    Version: 'E1.0',
    name: 'eject button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['1F3A6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFA6',
    Version: 'E0.6',
    name: 'cinema',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['1F505'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD05',
    Version: 'E1.0',
    name: 'dim button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['1F506'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD06',
    Version: 'E1.0',
    name: 'bright button',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['1F4F6'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCF6',
    Version: 'E0.6',
    name: 'antenna bars',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['1F6DC'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEDC',
    Version: 'E15.0',
    name: 'wireless',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['1F4F3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCF3',
    Version: 'E0.6',
    name: 'vibration mode',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['1F4F4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCF4',
    Version: 'E0.6',
    name: 'mobile phone off',
    category: 'Symbols',
    SubGroup: 'av-symbol'
  },
  {
    CodePointsHex: ['2640', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2640\uFE0F',
    Version: 'E4.0',
    name: 'female sign',
    category: 'Symbols',
    SubGroup: 'gender'
  },
  {
    CodePointsHex: ['2640'],
    Status: 'unqualified',
    char: '\u2640',
    Version: 'E4.0',
    name: 'female sign',
    category: 'Symbols',
    SubGroup: 'gender'
  },
  {
    CodePointsHex: ['2642', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2642\uFE0F',
    Version: 'E4.0',
    name: 'male sign',
    category: 'Symbols',
    SubGroup: 'gender'
  },
  {
    CodePointsHex: ['2642'],
    Status: 'unqualified',
    char: '\u2642',
    Version: 'E4.0',
    name: 'male sign',
    category: 'Symbols',
    SubGroup: 'gender'
  },
  {
    CodePointsHex: ['26A7', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u26A7\uFE0F',
    Version: 'E13.0',
    name: 'transgender symbol',
    category: 'Symbols',
    SubGroup: 'gender'
  },
  {
    CodePointsHex: ['26A7'],
    Status: 'unqualified',
    char: '\u26A7',
    Version: 'E13.0',
    name: 'transgender symbol',
    category: 'Symbols',
    SubGroup: 'gender'
  },
  {
    CodePointsHex: ['2716', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2716\uFE0F',
    Version: 'E0.6',
    name: 'multiply',
    category: 'Symbols',
    SubGroup: 'math'
  },
  {
    CodePointsHex: ['2716'],
    Status: 'unqualified',
    char: '\u2716',
    Version: 'E0.6',
    name: 'multiply',
    category: 'Symbols',
    SubGroup: 'math'
  },
  {
    CodePointsHex: ['2795'],
    Status: 'fully-qualified',
    char: '\u2795',
    Version: 'E0.6',
    name: 'plus',
    category: 'Symbols',
    SubGroup: 'math'
  },
  {
    CodePointsHex: ['2796'],
    Status: 'fully-qualified',
    char: '\u2796',
    Version: 'E0.6',
    name: 'minus',
    category: 'Symbols',
    SubGroup: 'math'
  },
  {
    CodePointsHex: ['2797'],
    Status: 'fully-qualified',
    char: '\u2797',
    Version: 'E0.6',
    name: 'divide',
    category: 'Symbols',
    SubGroup: 'math'
  },
  {
    CodePointsHex: ['1F7F0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDFF0',
    Version: 'E14.0',
    name: 'heavy equals sign',
    category: 'Symbols',
    SubGroup: 'math'
  },
  {
    CodePointsHex: ['267E', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u267E\uFE0F',
    Version: 'E11.0',
    name: 'infinity',
    category: 'Symbols',
    SubGroup: 'math'
  },
  {
    CodePointsHex: ['267E'],
    Status: 'unqualified',
    char: '\u267E',
    Version: 'E11.0',
    name: 'infinity',
    category: 'Symbols',
    SubGroup: 'math'
  },
  {
    CodePointsHex: ['203C', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u203C\uFE0F',
    Version: 'E0.6',
    name: 'double exclamation mark',
    category: 'Symbols',
    SubGroup: 'punctuation'
  },
  {
    CodePointsHex: ['203C'],
    Status: 'unqualified',
    char: '\u203C',
    Version: 'E0.6',
    name: 'double exclamation mark',
    category: 'Symbols',
    SubGroup: 'punctuation'
  },
  {
    CodePointsHex: ['2049', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2049\uFE0F',
    Version: 'E0.6',
    name: 'exclamation question mark',
    category: 'Symbols',
    SubGroup: 'punctuation'
  },
  {
    CodePointsHex: ['2049'],
    Status: 'unqualified',
    char: '\u2049',
    Version: 'E0.6',
    name: 'exclamation question mark',
    category: 'Symbols',
    SubGroup: 'punctuation'
  },
  {
    CodePointsHex: ['2753'],
    Status: 'fully-qualified',
    char: '\u2753',
    Version: 'E0.6',
    name: 'red question mark',
    category: 'Symbols',
    SubGroup: 'punctuation'
  },
  {
    CodePointsHex: ['2754'],
    Status: 'fully-qualified',
    char: '\u2754',
    Version: 'E0.6',
    name: 'white question mark',
    category: 'Symbols',
    SubGroup: 'punctuation'
  },
  {
    CodePointsHex: ['2755'],
    Status: 'fully-qualified',
    char: '\u2755',
    Version: 'E0.6',
    name: 'white exclamation mark',
    category: 'Symbols',
    SubGroup: 'punctuation'
  },
  {
    CodePointsHex: ['2757'],
    Status: 'fully-qualified',
    char: '\u2757',
    Version: 'E0.6',
    name: 'red exclamation mark',
    category: 'Symbols',
    SubGroup: 'punctuation'
  },
  {
    CodePointsHex: ['3030', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u3030\uFE0F',
    Version: 'E0.6',
    name: 'wavy dash',
    category: 'Symbols',
    SubGroup: 'punctuation'
  },
  {
    CodePointsHex: ['3030'],
    Status: 'unqualified',
    char: '\u3030',
    Version: 'E0.6',
    name: 'wavy dash',
    category: 'Symbols',
    SubGroup: 'punctuation'
  },
  {
    CodePointsHex: ['1F4B1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCB1',
    Version: 'E0.6',
    name: 'currency exchange',
    category: 'Symbols',
    SubGroup: 'currency'
  },
  {
    CodePointsHex: ['1F4B2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCB2',
    Version: 'E0.6',
    name: 'heavy dollar sign',
    category: 'Symbols',
    SubGroup: 'currency'
  },
  {
    CodePointsHex: ['2695', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2695\uFE0F',
    Version: 'E4.0',
    name: 'medical symbol',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['2695'],
    Status: 'unqualified',
    char: '\u2695',
    Version: 'E4.0',
    name: 'medical symbol',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['267B', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u267B\uFE0F',
    Version: 'E0.6',
    name: 'recycling symbol',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['267B'],
    Status: 'unqualified',
    char: '\u267B',
    Version: 'E0.6',
    name: 'recycling symbol',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['269C', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u269C\uFE0F',
    Version: 'E1.0',
    name: 'fleur-de-lis',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['269C'],
    Status: 'unqualified',
    char: '\u269C',
    Version: 'E1.0',
    name: 'fleur-de-lis',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['1F531'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD31',
    Version: 'E0.6',
    name: 'trident emblem',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['1F4DB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCDB',
    Version: 'E0.6',
    name: 'name badge',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['1F530'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD30',
    Version: 'E0.6',
    name: 'Japanese symbol for beginner',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['2B55'],
    Status: 'fully-qualified',
    char: '\u2B55',
    Version: 'E0.6',
    name: 'hollow red circle',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['2705'],
    Status: 'fully-qualified',
    char: '\u2705',
    Version: 'E0.6',
    name: 'check mark button',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['2611', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2611\uFE0F',
    Version: 'E0.6',
    name: 'check box with check',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['2611'],
    Status: 'unqualified',
    char: '\u2611',
    Version: 'E0.6',
    name: 'check box with check',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['2714', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2714\uFE0F',
    Version: 'E0.6',
    name: 'check mark',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['2714'],
    Status: 'unqualified',
    char: '\u2714',
    Version: 'E0.6',
    name: 'check mark',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['274C'],
    Status: 'fully-qualified',
    char: '\u274C',
    Version: 'E0.6',
    name: 'cross mark',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['274E'],
    Status: 'fully-qualified',
    char: '\u274E',
    Version: 'E0.6',
    name: 'cross mark button',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['27B0'],
    Status: 'fully-qualified',
    char: '\u27B0',
    Version: 'E0.6',
    name: 'curly loop',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['27BF'],
    Status: 'fully-qualified',
    char: '\u27BF',
    Version: 'E1.0',
    name: 'double curly loop',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['303D', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u303D\uFE0F',
    Version: 'E0.6',
    name: 'part alternation mark',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['303D'],
    Status: 'unqualified',
    char: '\u303D',
    Version: 'E0.6',
    name: 'part alternation mark',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['2733', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2733\uFE0F',
    Version: 'E0.6',
    name: 'eight-spoked asterisk',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['2733'],
    Status: 'unqualified',
    char: '\u2733',
    Version: 'E0.6',
    name: 'eight-spoked asterisk',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['2734', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2734\uFE0F',
    Version: 'E0.6',
    name: 'eight-pointed star',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['2734'],
    Status: 'unqualified',
    char: '\u2734',
    Version: 'E0.6',
    name: 'eight-pointed star',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['2747', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2747\uFE0F',
    Version: 'E0.6',
    name: 'sparkle',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['2747'],
    Status: 'unqualified',
    char: '\u2747',
    Version: 'E0.6',
    name: 'sparkle',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['A9', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u00A9\uFE0F',
    Version: 'E0.6',
    name: 'copyright',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['A9'],
    Status: 'unqualified',
    char: '\u00A9',
    Version: 'E0.6',
    name: 'copyright',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['AE', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u00AE\uFE0F',
    Version: 'E0.6',
    name: 'registered',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['AE'],
    Status: 'unqualified',
    char: '\u00AE',
    Version: 'E0.6',
    name: 'registered',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['2122', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2122\uFE0F',
    Version: 'E0.6',
    name: 'trade mark',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['2122'],
    Status: 'unqualified',
    char: '\u2122',
    Version: 'E0.6',
    name: 'trade mark',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['1FADF'],
    Status: 'fully-qualified',
    char: '\uD83E\uDEDF',
    Version: 'E16.0',
    name: 'splatter',
    category: 'Symbols',
    SubGroup: 'other-symbol'
  },
  {
    CodePointsHex: ['23', 'FE0F', '20E3'],
    Status: 'fully-qualified',
    char: null,
    Version: null,
    name: null,
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['23', '20E3'],
    Status: 'unqualified',
    char: null,
    Version: null,
    name: null,
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['2A', 'FE0F', '20E3'],
    Status: 'fully-qualified',
    char: '*\uFE0F\u20E3',
    Version: 'E2.0',
    name: 'keycap: *',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['2A', '20E3'],
    Status: 'unqualified',
    char: '*\u20E3',
    Version: 'E2.0',
    name: 'keycap: *',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['30', 'FE0F', '20E3'],
    Status: 'fully-qualified',
    char: '0\uFE0F\u20E3',
    Version: 'E0.6',
    name: 'keycap: 0',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['30', '20E3'],
    Status: 'unqualified',
    char: '0\u20E3',
    Version: 'E0.6',
    name: 'keycap: 0',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['31', 'FE0F', '20E3'],
    Status: 'fully-qualified',
    char: '1\uFE0F\u20E3',
    Version: 'E0.6',
    name: 'keycap: 1',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['31', '20E3'],
    Status: 'unqualified',
    char: '1\u20E3',
    Version: 'E0.6',
    name: 'keycap: 1',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['32', 'FE0F', '20E3'],
    Status: 'fully-qualified',
    char: '2\uFE0F\u20E3',
    Version: 'E0.6',
    name: 'keycap: 2',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['32', '20E3'],
    Status: 'unqualified',
    char: '2\u20E3',
    Version: 'E0.6',
    name: 'keycap: 2',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['33', 'FE0F', '20E3'],
    Status: 'fully-qualified',
    char: '3\uFE0F\u20E3',
    Version: 'E0.6',
    name: 'keycap: 3',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['33', '20E3'],
    Status: 'unqualified',
    char: '3\u20E3',
    Version: 'E0.6',
    name: 'keycap: 3',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['34', 'FE0F', '20E3'],
    Status: 'fully-qualified',
    char: '4\uFE0F\u20E3',
    Version: 'E0.6',
    name: 'keycap: 4',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['34', '20E3'],
    Status: 'unqualified',
    char: '4\u20E3',
    Version: 'E0.6',
    name: 'keycap: 4',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['35', 'FE0F', '20E3'],
    Status: 'fully-qualified',
    char: '5\uFE0F\u20E3',
    Version: 'E0.6',
    name: 'keycap: 5',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['35', '20E3'],
    Status: 'unqualified',
    char: '5\u20E3',
    Version: 'E0.6',
    name: 'keycap: 5',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['36', 'FE0F', '20E3'],
    Status: 'fully-qualified',
    char: '6\uFE0F\u20E3',
    Version: 'E0.6',
    name: 'keycap: 6',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['36', '20E3'],
    Status: 'unqualified',
    char: '6\u20E3',
    Version: 'E0.6',
    name: 'keycap: 6',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['37', 'FE0F', '20E3'],
    Status: 'fully-qualified',
    char: '7\uFE0F\u20E3',
    Version: 'E0.6',
    name: 'keycap: 7',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['37', '20E3'],
    Status: 'unqualified',
    char: '7\u20E3',
    Version: 'E0.6',
    name: 'keycap: 7',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['38', 'FE0F', '20E3'],
    Status: 'fully-qualified',
    char: '8\uFE0F\u20E3',
    Version: 'E0.6',
    name: 'keycap: 8',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['38', '20E3'],
    Status: 'unqualified',
    char: '8\u20E3',
    Version: 'E0.6',
    name: 'keycap: 8',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['39', 'FE0F', '20E3'],
    Status: 'fully-qualified',
    char: '9\uFE0F\u20E3',
    Version: 'E0.6',
    name: 'keycap: 9',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['39', '20E3'],
    Status: 'unqualified',
    char: '9\u20E3',
    Version: 'E0.6',
    name: 'keycap: 9',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['1F51F'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD1F',
    Version: 'E0.6',
    name: 'keycap: 10',
    category: 'Symbols',
    SubGroup: 'keycap'
  },
  {
    CodePointsHex: ['1F520'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD20',
    Version: 'E0.6',
    name: 'input latin uppercase',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F521'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD21',
    Version: 'E0.6',
    name: 'input latin lowercase',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F522'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD22',
    Version: 'E0.6',
    name: 'input numbers',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F523'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD23',
    Version: 'E0.6',
    name: 'input symbols',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F524'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD24',
    Version: 'E0.6',
    name: 'input latin letters',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F170', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDD70\uFE0F',
    Version: 'E0.6',
    name: 'A button (blood type)',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F170'],
    Status: 'unqualified',
    char: '\uD83C\uDD70',
    Version: 'E0.6',
    name: 'A button (blood type)',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F18E'],
    Status: 'fully-qualified',
    char: '\uD83C\uDD8E',
    Version: 'E0.6',
    name: 'AB button (blood type)',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F171', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDD71\uFE0F',
    Version: 'E0.6',
    name: 'B button (blood type)',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F171'],
    Status: 'unqualified',
    char: '\uD83C\uDD71',
    Version: 'E0.6',
    name: 'B button (blood type)',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F191'],
    Status: 'fully-qualified',
    char: '\uD83C\uDD91',
    Version: 'E0.6',
    name: 'CL button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F192'],
    Status: 'fully-qualified',
    char: '\uD83C\uDD92',
    Version: 'E0.6',
    name: 'COOL button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F193'],
    Status: 'fully-qualified',
    char: '\uD83C\uDD93',
    Version: 'E0.6',
    name: 'FREE button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['2139', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u2139\uFE0F',
    Version: 'E0.6',
    name: 'information',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['2139'],
    Status: 'unqualified',
    char: '\u2139',
    Version: 'E0.6',
    name: 'information',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F194'],
    Status: 'fully-qualified',
    char: '\uD83C\uDD94',
    Version: 'E0.6',
    name: 'ID button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['24C2', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u24C2\uFE0F',
    Version: 'E0.6',
    name: 'circled M',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['24C2'],
    Status: 'unqualified',
    char: '\u24C2',
    Version: 'E0.6',
    name: 'circled M',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F195'],
    Status: 'fully-qualified',
    char: '\uD83C\uDD95',
    Version: 'E0.6',
    name: 'NEW button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F196'],
    Status: 'fully-qualified',
    char: '\uD83C\uDD96',
    Version: 'E0.6',
    name: 'NG button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F17E', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDD7E\uFE0F',
    Version: 'E0.6',
    name: 'O button (blood type)',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F17E'],
    Status: 'unqualified',
    char: '\uD83C\uDD7E',
    Version: 'E0.6',
    name: 'O button (blood type)',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F197'],
    Status: 'fully-qualified',
    char: '\uD83C\uDD97',
    Version: 'E0.6',
    name: 'OK button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F17F', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDD7F\uFE0F',
    Version: 'E0.6',
    name: 'P button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F17F'],
    Status: 'unqualified',
    char: '\uD83C\uDD7F',
    Version: 'E0.6',
    name: 'P button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F198'],
    Status: 'fully-qualified',
    char: '\uD83C\uDD98',
    Version: 'E0.6',
    name: 'SOS button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F199'],
    Status: 'fully-qualified',
    char: '\uD83C\uDD99',
    Version: 'E0.6',
    name: 'UP! button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F19A'],
    Status: 'fully-qualified',
    char: '\uD83C\uDD9A',
    Version: 'E0.6',
    name: 'VS button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F201'],
    Status: 'fully-qualified',
    char: '\uD83C\uDE01',
    Version: 'E0.6',
    name: 'Japanese \u201Chere\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F202', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDE02\uFE0F',
    Version: 'E0.6',
    name: 'Japanese \u201Cservice charge\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F202'],
    Status: 'unqualified',
    char: '\uD83C\uDE02',
    Version: 'E0.6',
    name: 'Japanese \u201Cservice charge\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F237', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDE37\uFE0F',
    Version: 'E0.6',
    name: 'Japanese \u201Cmonthly amount\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F237'],
    Status: 'unqualified',
    char: '\uD83C\uDE37',
    Version: 'E0.6',
    name: 'Japanese \u201Cmonthly amount\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F236'],
    Status: 'fully-qualified',
    char: '\uD83C\uDE36',
    Version: 'E0.6',
    name: 'Japanese \u201Cnot free of charge\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F22F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDE2F',
    Version: 'E0.6',
    name: 'Japanese \u201Creserved\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F250'],
    Status: 'fully-qualified',
    char: '\uD83C\uDE50',
    Version: 'E0.6',
    name: 'Japanese \u201Cbargain\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F239'],
    Status: 'fully-qualified',
    char: '\uD83C\uDE39',
    Version: 'E0.6',
    name: 'Japanese \u201Cdiscount\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F21A'],
    Status: 'fully-qualified',
    char: '\uD83C\uDE1A',
    Version: 'E0.6',
    name: 'Japanese \u201Cfree of charge\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F232'],
    Status: 'fully-qualified',
    char: '\uD83C\uDE32',
    Version: 'E0.6',
    name: 'Japanese \u201Cprohibited\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F251'],
    Status: 'fully-qualified',
    char: '\uD83C\uDE51',
    Version: 'E0.6',
    name: 'Japanese \u201Cacceptable\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F238'],
    Status: 'fully-qualified',
    char: '\uD83C\uDE38',
    Version: 'E0.6',
    name: 'Japanese \u201Capplication\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F234'],
    Status: 'fully-qualified',
    char: '\uD83C\uDE34',
    Version: 'E0.6',
    name: 'Japanese \u201Cpassing grade\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F233'],
    Status: 'fully-qualified',
    char: '\uD83C\uDE33',
    Version: 'E0.6',
    name: 'Japanese \u201Cvacancy\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['3297', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u3297\uFE0F',
    Version: 'E0.6',
    name: 'Japanese \u201Ccongratulations\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['3297'],
    Status: 'unqualified',
    char: '\u3297',
    Version: 'E0.6',
    name: 'Japanese \u201Ccongratulations\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['3299', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u3299\uFE0F',
    Version: 'E0.6',
    name: 'Japanese \u201Csecret\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['3299'],
    Status: 'unqualified',
    char: '\u3299',
    Version: 'E0.6',
    name: 'Japanese \u201Csecret\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F23A'],
    Status: 'fully-qualified',
    char: '\uD83C\uDE3A',
    Version: 'E0.6',
    name: 'Japanese \u201Copen for business\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F235'],
    Status: 'fully-qualified',
    char: '\uD83C\uDE35',
    Version: 'E0.6',
    name: 'Japanese \u201Cno vacancy\u201D button',
    category: 'Symbols',
    SubGroup: 'alphanum'
  },
  {
    CodePointsHex: ['1F534'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD34',
    Version: 'E0.6',
    name: 'red circle',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F7E0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDFE0',
    Version: 'E12.0',
    name: 'orange circle',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F7E1'],
    Status: 'fully-qualified',
    char: '\uD83D\uDFE1',
    Version: 'E12.0',
    name: 'yellow circle',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F7E2'],
    Status: 'fully-qualified',
    char: '\uD83D\uDFE2',
    Version: 'E12.0',
    name: 'green circle',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F535'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD35',
    Version: 'E0.6',
    name: 'blue circle',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F7E3'],
    Status: 'fully-qualified',
    char: '\uD83D\uDFE3',
    Version: 'E12.0',
    name: 'purple circle',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F7E4'],
    Status: 'fully-qualified',
    char: '\uD83D\uDFE4',
    Version: 'E12.0',
    name: 'brown circle',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['26AB'],
    Status: 'fully-qualified',
    char: '\u26AB',
    Version: 'E0.6',
    name: 'black circle',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['26AA'],
    Status: 'fully-qualified',
    char: '\u26AA',
    Version: 'E0.6',
    name: 'white circle',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F7E5'],
    Status: 'fully-qualified',
    char: '\uD83D\uDFE5',
    Version: 'E12.0',
    name: 'red square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F7E7'],
    Status: 'fully-qualified',
    char: '\uD83D\uDFE7',
    Version: 'E12.0',
    name: 'orange square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F7E8'],
    Status: 'fully-qualified',
    char: '\uD83D\uDFE8',
    Version: 'E12.0',
    name: 'yellow square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F7E9'],
    Status: 'fully-qualified',
    char: '\uD83D\uDFE9',
    Version: 'E12.0',
    name: 'green square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F7E6'],
    Status: 'fully-qualified',
    char: '\uD83D\uDFE6',
    Version: 'E12.0',
    name: 'blue square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F7EA'],
    Status: 'fully-qualified',
    char: '\uD83D\uDFEA',
    Version: 'E12.0',
    name: 'purple square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F7EB'],
    Status: 'fully-qualified',
    char: '\uD83D\uDFEB',
    Version: 'E12.0',
    name: 'brown square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['2B1B'],
    Status: 'fully-qualified',
    char: '\u2B1B',
    Version: 'E0.6',
    name: 'black large square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['2B1C'],
    Status: 'fully-qualified',
    char: '\u2B1C',
    Version: 'E0.6',
    name: 'white large square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['25FC', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u25FC\uFE0F',
    Version: 'E0.6',
    name: 'black medium square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['25FC'],
    Status: 'unqualified',
    char: '\u25FC',
    Version: 'E0.6',
    name: 'black medium square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['25FB', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u25FB\uFE0F',
    Version: 'E0.6',
    name: 'white medium square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['25FB'],
    Status: 'unqualified',
    char: '\u25FB',
    Version: 'E0.6',
    name: 'white medium square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['25FE'],
    Status: 'fully-qualified',
    char: '\u25FE',
    Version: 'E0.6',
    name: 'black medium-small square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['25FD'],
    Status: 'fully-qualified',
    char: '\u25FD',
    Version: 'E0.6',
    name: 'white medium-small square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['25AA', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u25AA\uFE0F',
    Version: 'E0.6',
    name: 'black small square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['25AA'],
    Status: 'unqualified',
    char: '\u25AA',
    Version: 'E0.6',
    name: 'black small square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['25AB', 'FE0F'],
    Status: 'fully-qualified',
    char: '\u25AB\uFE0F',
    Version: 'E0.6',
    name: 'white small square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['25AB'],
    Status: 'unqualified',
    char: '\u25AB',
    Version: 'E0.6',
    name: 'white small square',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F536'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD36',
    Version: 'E0.6',
    name: 'large orange diamond',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F537'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD37',
    Version: 'E0.6',
    name: 'large blue diamond',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F538'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD38',
    Version: 'E0.6',
    name: 'small orange diamond',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F539'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD39',
    Version: 'E0.6',
    name: 'small blue diamond',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F53A'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD3A',
    Version: 'E0.6',
    name: 'red triangle pointed up',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F53B'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD3B',
    Version: 'E0.6',
    name: 'red triangle pointed down',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F4A0'],
    Status: 'fully-qualified',
    char: '\uD83D\uDCA0',
    Version: 'E0.6',
    name: 'diamond with a dot',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F518'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD18',
    Version: 'E0.6',
    name: 'radio button',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F533'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD33',
    Version: 'E0.6',
    name: 'white square button',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F532'],
    Status: 'fully-qualified',
    char: '\uD83D\uDD32',
    Version: 'E0.6',
    name: 'black square button',
    category: 'Symbols',
    SubGroup: 'geometric'
  },
  {
    CodePointsHex: ['1F3C1'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFC1',
    Version: 'E0.6',
    name: 'chequered flag',
    category: 'Flags',
    SubGroup: 'flag'
  },
  {
    CodePointsHex: ['1F6A9'],
    Status: 'fully-qualified',
    char: '\uD83D\uDEA9',
    Version: 'E0.6',
    name: 'triangular flag',
    category: 'Flags',
    SubGroup: 'flag'
  },
  {
    CodePointsHex: ['1F38C'],
    Status: 'fully-qualified',
    char: '\uD83C\uDF8C',
    Version: 'E0.6',
    name: 'crossed flags',
    category: 'Flags',
    SubGroup: 'flag'
  },
  {
    CodePointsHex: ['1F3F4'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFF4',
    Version: 'E1.0',
    name: 'black flag',
    category: 'Flags',
    SubGroup: 'flag'
  },
  {
    CodePointsHex: ['1F3F3', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFF3\uFE0F',
    Version: 'E0.7',
    name: 'white flag',
    category: 'Flags',
    SubGroup: 'flag'
  },
  {
    CodePointsHex: ['1F3F3'],
    Status: 'unqualified',
    char: '\uD83C\uDFF3',
    Version: 'E0.7',
    name: 'white flag',
    category: 'Flags',
    SubGroup: 'flag'
  },
  {
    CodePointsHex: ['1F3F3', 'FE0F', '200D', '1F308'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08',
    Version: 'E4.0',
    name: 'rainbow flag',
    category: 'Flags',
    SubGroup: 'flag'
  },
  {
    CodePointsHex: ['1F3F3', '200D', '1F308'],
    Status: 'unqualified',
    char: '\uD83C\uDFF3\u200D\uD83C\uDF08',
    Version: 'E4.0',
    name: 'rainbow flag',
    category: 'Flags',
    SubGroup: 'flag'
  },
  {
    CodePointsHex: ['1F3F3', 'FE0F', '200D', '26A7', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFF3\uFE0F\u200D\u26A7\uFE0F',
    Version: 'E13.0',
    name: 'transgender flag',
    category: 'Flags',
    SubGroup: 'flag'
  },
  {
    CodePointsHex: ['1F3F3', '200D', '26A7', 'FE0F'],
    Status: 'unqualified',
    char: '\uD83C\uDFF3\u200D\u26A7\uFE0F',
    Version: 'E13.0',
    name: 'transgender flag',
    category: 'Flags',
    SubGroup: 'flag'
  },
  {
    CodePointsHex: ['1F3F3', 'FE0F', '200D', '26A7'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFF3\uFE0F\u200D\u26A7',
    Version: 'E13.0',
    name: 'transgender flag',
    category: 'Flags',
    SubGroup: 'flag'
  },
  {
    CodePointsHex: ['1F3F3', '200D', '26A7'],
    Status: 'unqualified',
    char: '\uD83C\uDFF3\u200D\u26A7',
    Version: 'E13.0',
    name: 'transgender flag',
    category: 'Flags',
    SubGroup: 'flag'
  },
  {
    CodePointsHex: ['1F3F4', '200D', '2620', 'FE0F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFF4\u200D\u2620\uFE0F',
    Version: 'E11.0',
    name: 'pirate flag',
    category: 'Flags',
    SubGroup: 'flag'
  },
  {
    CodePointsHex: ['1F3F4', '200D', '2620'],
    Status: 'minimally-qualified',
    char: '\uD83C\uDFF4\u200D\u2620',
    Version: 'E11.0',
    name: 'pirate flag',
    category: 'Flags',
    SubGroup: 'flag'
  },
  {
    CodePointsHex: ['1F1E6', '1F1E8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE6\uD83C\uDDE8',
    Version: 'E2.0',
    name: 'flag: Ascension Island',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E6', '1F1E9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE6\uD83C\uDDE9',
    Version: 'E2.0',
    name: 'flag: Andorra',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E6', '1F1EA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE6\uD83C\uDDEA',
    Version: 'E2.0',
    name: 'flag: United Arab Emirates',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E6', '1F1EB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE6\uD83C\uDDEB',
    Version: 'E2.0',
    name: 'flag: Afghanistan',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E6', '1F1EC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE6\uD83C\uDDEC',
    Version: 'E2.0',
    name: 'flag: Antigua \u0026 Barbuda',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E6', '1F1EE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE6\uD83C\uDDEE',
    Version: 'E2.0',
    name: 'flag: Anguilla',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E6', '1F1F1'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE6\uD83C\uDDF1',
    Version: 'E2.0',
    name: 'flag: Albania',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E6', '1F1F2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE6\uD83C\uDDF2',
    Version: 'E2.0',
    name: 'flag: Armenia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E6', '1F1F4'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE6\uD83C\uDDF4',
    Version: 'E2.0',
    name: 'flag: Angola',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E6', '1F1F6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE6\uD83C\uDDF6',
    Version: 'E2.0',
    name: 'flag: Antarctica',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E6', '1F1F7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE6\uD83C\uDDF7',
    Version: 'E2.0',
    name: 'flag: Argentina',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E6', '1F1F8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE6\uD83C\uDDF8',
    Version: 'E2.0',
    name: 'flag: American Samoa',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E6', '1F1F9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE6\uD83C\uDDF9',
    Version: 'E2.0',
    name: 'flag: Austria',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E6', '1F1FA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE6\uD83C\uDDFA',
    Version: 'E2.0',
    name: 'flag: Australia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E6', '1F1FC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE6\uD83C\uDDFC',
    Version: 'E2.0',
    name: 'flag: Aruba',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E6', '1F1FD'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE6\uD83C\uDDFD',
    Version: 'E2.0',
    name: 'flag: \u00C5land Islands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E6', '1F1FF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE6\uD83C\uDDFF',
    Version: 'E2.0',
    name: 'flag: Azerbaijan',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1E6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDE6',
    Version: 'E2.0',
    name: 'flag: Bosnia \u0026 Herzegovina',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1E7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDE7',
    Version: 'E2.0',
    name: 'flag: Barbados',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1E9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDE9',
    Version: 'E2.0',
    name: 'flag: Bangladesh',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1EA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDEA',
    Version: 'E2.0',
    name: 'flag: Belgium',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1EB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDEB',
    Version: 'E2.0',
    name: 'flag: Burkina Faso',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1EC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDEC',
    Version: 'E2.0',
    name: 'flag: Bulgaria',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1ED'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDED',
    Version: 'E2.0',
    name: 'flag: Bahrain',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1EE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDEE',
    Version: 'E2.0',
    name: 'flag: Burundi',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1EF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDEF',
    Version: 'E2.0',
    name: 'flag: Benin',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1F1'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDF1',
    Version: 'E2.0',
    name: 'flag: St. Barth\u00E9lemy',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1F2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDF2',
    Version: 'E2.0',
    name: 'flag: Bermuda',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1F3'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDF3',
    Version: 'E2.0',
    name: 'flag: Brunei',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1F4'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDF4',
    Version: 'E2.0',
    name: 'flag: Bolivia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1F6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDF6',
    Version: 'E2.0',
    name: 'flag: Caribbean Netherlands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1F7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDF7',
    Version: 'E2.0',
    name: 'flag: Brazil',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1F8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDF8',
    Version: 'E2.0',
    name: 'flag: Bahamas',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1F9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDF9',
    Version: 'E2.0',
    name: 'flag: Bhutan',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1FB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDFB',
    Version: 'E2.0',
    name: 'flag: Bouvet Island',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1FC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDFC',
    Version: 'E2.0',
    name: 'flag: Botswana',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1FE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDFE',
    Version: 'E2.0',
    name: 'flag: Belarus',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E7', '1F1FF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE7\uD83C\uDDFF',
    Version: 'E2.0',
    name: 'flag: Belize',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1E6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDE6',
    Version: 'E2.0',
    name: 'flag: Canada',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1E8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDE8',
    Version: 'E2.0',
    name: 'flag: Cocos (Keeling) Islands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1E9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDE9',
    Version: 'E2.0',
    name: 'flag: Congo - Kinshasa',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1EB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDEB',
    Version: 'E2.0',
    name: 'flag: Central African Republic',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1EC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDEC',
    Version: 'E2.0',
    name: 'flag: Congo - Brazzaville',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1ED'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDED',
    Version: 'E2.0',
    name: 'flag: Switzerland',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1EE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDEE',
    Version: 'E2.0',
    name: 'flag: C\u00F4te d\u2019Ivoire',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1F0'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDF0',
    Version: 'E2.0',
    name: 'flag: Cook Islands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1F1'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDF1',
    Version: 'E2.0',
    name: 'flag: Chile',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1F2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDF2',
    Version: 'E2.0',
    name: 'flag: Cameroon',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1F3'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDF3',
    Version: 'E0.6',
    name: 'flag: China',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1F4'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDF4',
    Version: 'E2.0',
    name: 'flag: Colombia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1F5'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDF5',
    Version: 'E2.0',
    name: 'flag: Clipperton Island',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1F6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDF6',
    Version: 'E16.0',
    name: 'flag: Sark',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1F7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDF7',
    Version: 'E2.0',
    name: 'flag: Costa Rica',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1FA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDFA',
    Version: 'E2.0',
    name: 'flag: Cuba',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1FB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDFB',
    Version: 'E2.0',
    name: 'flag: Cape Verde',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1FC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDFC',
    Version: 'E2.0',
    name: 'flag: Cura\u00E7ao',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1FD'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDFD',
    Version: 'E2.0',
    name: 'flag: Christmas Island',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1FE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDFE',
    Version: 'E2.0',
    name: 'flag: Cyprus',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E8', '1F1FF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE8\uD83C\uDDFF',
    Version: 'E2.0',
    name: 'flag: Czechia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E9', '1F1EA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE9\uD83C\uDDEA',
    Version: 'E0.6',
    name: 'flag: Germany',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E9', '1F1EC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE9\uD83C\uDDEC',
    Version: 'E2.0',
    name: 'flag: Diego Garcia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E9', '1F1EF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE9\uD83C\uDDEF',
    Version: 'E2.0',
    name: 'flag: Djibouti',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E9', '1F1F0'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE9\uD83C\uDDF0',
    Version: 'E2.0',
    name: 'flag: Denmark',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E9', '1F1F2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE9\uD83C\uDDF2',
    Version: 'E2.0',
    name: 'flag: Dominica',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E9', '1F1F4'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE9\uD83C\uDDF4',
    Version: 'E2.0',
    name: 'flag: Dominican Republic',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1E9', '1F1FF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDE9\uD83C\uDDFF',
    Version: 'E2.0',
    name: 'flag: Algeria',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EA', '1F1E6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEA\uD83C\uDDE6',
    Version: 'E2.0',
    name: 'flag: Ceuta \u0026 Melilla',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EA', '1F1E8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEA\uD83C\uDDE8',
    Version: 'E2.0',
    name: 'flag: Ecuador',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EA', '1F1EA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEA\uD83C\uDDEA',
    Version: 'E2.0',
    name: 'flag: Estonia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EA', '1F1EC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEA\uD83C\uDDEC',
    Version: 'E2.0',
    name: 'flag: Egypt',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EA', '1F1ED'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEA\uD83C\uDDED',
    Version: 'E2.0',
    name: 'flag: Western Sahara',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EA', '1F1F7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEA\uD83C\uDDF7',
    Version: 'E2.0',
    name: 'flag: Eritrea',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EA', '1F1F8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEA\uD83C\uDDF8',
    Version: 'E0.6',
    name: 'flag: Spain',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EA', '1F1F9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEA\uD83C\uDDF9',
    Version: 'E2.0',
    name: 'flag: Ethiopia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EA', '1F1FA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEA\uD83C\uDDFA',
    Version: 'E2.0',
    name: 'flag: European Union',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EB', '1F1EE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEB\uD83C\uDDEE',
    Version: 'E2.0',
    name: 'flag: Finland',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EB', '1F1EF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEB\uD83C\uDDEF',
    Version: 'E2.0',
    name: 'flag: Fiji',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EB', '1F1F0'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEB\uD83C\uDDF0',
    Version: 'E2.0',
    name: 'flag: Falkland Islands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EB', '1F1F2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEB\uD83C\uDDF2',
    Version: 'E2.0',
    name: 'flag: Micronesia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EB', '1F1F4'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEB\uD83C\uDDF4',
    Version: 'E2.0',
    name: 'flag: Faroe Islands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EB', '1F1F7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEB\uD83C\uDDF7',
    Version: 'E0.6',
    name: 'flag: France',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1E6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDE6',
    Version: 'E2.0',
    name: 'flag: Gabon',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1E7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDE7',
    Version: 'E0.6',
    name: 'flag: United Kingdom',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1E9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDE9',
    Version: 'E2.0',
    name: 'flag: Grenada',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1EA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDEA',
    Version: 'E2.0',
    name: 'flag: Georgia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1EB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDEB',
    Version: 'E2.0',
    name: 'flag: French Guiana',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1EC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDEC',
    Version: 'E2.0',
    name: 'flag: Guernsey',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1ED'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDED',
    Version: 'E2.0',
    name: 'flag: Ghana',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1EE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDEE',
    Version: 'E2.0',
    name: 'flag: Gibraltar',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1F1'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDF1',
    Version: 'E2.0',
    name: 'flag: Greenland',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1F2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDF2',
    Version: 'E2.0',
    name: 'flag: Gambia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1F3'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDF3',
    Version: 'E2.0',
    name: 'flag: Guinea',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1F5'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDF5',
    Version: 'E2.0',
    name: 'flag: Guadeloupe',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1F6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDF6',
    Version: 'E2.0',
    name: 'flag: Equatorial Guinea',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1F7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDF7',
    Version: 'E2.0',
    name: 'flag: Greece',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1F8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDF8',
    Version: 'E2.0',
    name: 'flag: South Georgia \u0026 South Sandwich Islands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1F9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDF9',
    Version: 'E2.0',
    name: 'flag: Guatemala',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1FA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDFA',
    Version: 'E2.0',
    name: 'flag: Guam',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1FC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDFC',
    Version: 'E2.0',
    name: 'flag: Guinea-Bissau',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EC', '1F1FE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEC\uD83C\uDDFE',
    Version: 'E2.0',
    name: 'flag: Guyana',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1ED', '1F1F0'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDED\uD83C\uDDF0',
    Version: 'E2.0',
    name: 'flag: Hong Kong SAR China',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1ED', '1F1F2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDED\uD83C\uDDF2',
    Version: 'E2.0',
    name: 'flag: Heard \u0026 McDonald Islands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1ED', '1F1F3'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDED\uD83C\uDDF3',
    Version: 'E2.0',
    name: 'flag: Honduras',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1ED', '1F1F7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDED\uD83C\uDDF7',
    Version: 'E2.0',
    name: 'flag: Croatia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1ED', '1F1F9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDED\uD83C\uDDF9',
    Version: 'E2.0',
    name: 'flag: Haiti',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1ED', '1F1FA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDED\uD83C\uDDFA',
    Version: 'E2.0',
    name: 'flag: Hungary',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EE', '1F1E8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEE\uD83C\uDDE8',
    Version: 'E2.0',
    name: 'flag: Canary Islands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EE', '1F1E9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEE\uD83C\uDDE9',
    Version: 'E2.0',
    name: 'flag: Indonesia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EE', '1F1EA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEE\uD83C\uDDEA',
    Version: 'E2.0',
    name: 'flag: Ireland',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EE', '1F1F1'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEE\uD83C\uDDF1',
    Version: 'E2.0',
    name: 'flag: Israel',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EE', '1F1F2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEE\uD83C\uDDF2',
    Version: 'E2.0',
    name: 'flag: Isle of Man',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EE', '1F1F3'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEE\uD83C\uDDF3',
    Version: 'E2.0',
    name: 'flag: India',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EE', '1F1F4'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEE\uD83C\uDDF4',
    Version: 'E2.0',
    name: 'flag: British Indian Ocean Territory',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EE', '1F1F6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEE\uD83C\uDDF6',
    Version: 'E2.0',
    name: 'flag: Iraq',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EE', '1F1F7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEE\uD83C\uDDF7',
    Version: 'E2.0',
    name: 'flag: Iran',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EE', '1F1F8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEE\uD83C\uDDF8',
    Version: 'E2.0',
    name: 'flag: Iceland',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EE', '1F1F9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEE\uD83C\uDDF9',
    Version: 'E0.6',
    name: 'flag: Italy',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EF', '1F1EA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEF\uD83C\uDDEA',
    Version: 'E2.0',
    name: 'flag: Jersey',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EF', '1F1F2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEF\uD83C\uDDF2',
    Version: 'E2.0',
    name: 'flag: Jamaica',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EF', '1F1F4'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEF\uD83C\uDDF4',
    Version: 'E2.0',
    name: 'flag: Jordan',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1EF', '1F1F5'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDEF\uD83C\uDDF5',
    Version: 'E0.6',
    name: 'flag: Japan',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F0', '1F1EA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF0\uD83C\uDDEA',
    Version: 'E2.0',
    name: 'flag: Kenya',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F0', '1F1EC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF0\uD83C\uDDEC',
    Version: 'E2.0',
    name: 'flag: Kyrgyzstan',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F0', '1F1ED'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF0\uD83C\uDDED',
    Version: 'E2.0',
    name: 'flag: Cambodia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F0', '1F1EE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF0\uD83C\uDDEE',
    Version: 'E2.0',
    name: 'flag: Kiribati',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F0', '1F1F2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF0\uD83C\uDDF2',
    Version: 'E2.0',
    name: 'flag: Comoros',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F0', '1F1F3'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF0\uD83C\uDDF3',
    Version: 'E2.0',
    name: 'flag: St. Kitts \u0026 Nevis',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F0', '1F1F5'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF0\uD83C\uDDF5',
    Version: 'E2.0',
    name: 'flag: North Korea',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F0', '1F1F7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF0\uD83C\uDDF7',
    Version: 'E0.6',
    name: 'flag: South Korea',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F0', '1F1FC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF0\uD83C\uDDFC',
    Version: 'E2.0',
    name: 'flag: Kuwait',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F0', '1F1FE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF0\uD83C\uDDFE',
    Version: 'E2.0',
    name: 'flag: Cayman Islands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F0', '1F1FF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF0\uD83C\uDDFF',
    Version: 'E2.0',
    name: 'flag: Kazakhstan',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F1', '1F1E6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF1\uD83C\uDDE6',
    Version: 'E2.0',
    name: 'flag: Laos',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F1', '1F1E7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF1\uD83C\uDDE7',
    Version: 'E2.0',
    name: 'flag: Lebanon',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F1', '1F1E8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF1\uD83C\uDDE8',
    Version: 'E2.0',
    name: 'flag: St. Lucia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F1', '1F1EE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF1\uD83C\uDDEE',
    Version: 'E2.0',
    name: 'flag: Liechtenstein',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F1', '1F1F0'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF1\uD83C\uDDF0',
    Version: 'E2.0',
    name: 'flag: Sri Lanka',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F1', '1F1F7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF1\uD83C\uDDF7',
    Version: 'E2.0',
    name: 'flag: Liberia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F1', '1F1F8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF1\uD83C\uDDF8',
    Version: 'E2.0',
    name: 'flag: Lesotho',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F1', '1F1F9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF1\uD83C\uDDF9',
    Version: 'E2.0',
    name: 'flag: Lithuania',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F1', '1F1FA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF1\uD83C\uDDFA',
    Version: 'E2.0',
    name: 'flag: Luxembourg',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F1', '1F1FB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF1\uD83C\uDDFB',
    Version: 'E2.0',
    name: 'flag: Latvia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F1', '1F1FE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF1\uD83C\uDDFE',
    Version: 'E2.0',
    name: 'flag: Libya',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1E6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDE6',
    Version: 'E2.0',
    name: 'flag: Morocco',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1E8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDE8',
    Version: 'E2.0',
    name: 'flag: Monaco',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1E9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDE9',
    Version: 'E2.0',
    name: 'flag: Moldova',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1EA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDEA',
    Version: 'E2.0',
    name: 'flag: Montenegro',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1EB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDEB',
    Version: 'E2.0',
    name: 'flag: St. Martin',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1EC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDEC',
    Version: 'E2.0',
    name: 'flag: Madagascar',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1ED'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDED',
    Version: 'E2.0',
    name: 'flag: Marshall Islands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1F0'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDF0',
    Version: 'E2.0',
    name: 'flag: North Macedonia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1F1'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDF1',
    Version: 'E2.0',
    name: 'flag: Mali',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1F2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDF2',
    Version: 'E2.0',
    name: 'flag: Myanmar (Burma)',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1F3'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDF3',
    Version: 'E2.0',
    name: 'flag: Mongolia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1F4'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDF4',
    Version: 'E2.0',
    name: 'flag: Macao SAR China',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1F5'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDF5',
    Version: 'E2.0',
    name: 'flag: Northern Mariana Islands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1F6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDF6',
    Version: 'E2.0',
    name: 'flag: Martinique',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1F7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDF7',
    Version: 'E2.0',
    name: 'flag: Mauritania',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1F8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDF8',
    Version: 'E2.0',
    name: 'flag: Montserrat',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1F9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDF9',
    Version: 'E2.0',
    name: 'flag: Malta',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1FA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDFA',
    Version: 'E2.0',
    name: 'flag: Mauritius',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1FB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDFB',
    Version: 'E2.0',
    name: 'flag: Maldives',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1FC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDFC',
    Version: 'E2.0',
    name: 'flag: Malawi',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1FD'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDFD',
    Version: 'E2.0',
    name: 'flag: Mexico',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1FE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDFE',
    Version: 'E2.0',
    name: 'flag: Malaysia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F2', '1F1FF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF2\uD83C\uDDFF',
    Version: 'E2.0',
    name: 'flag: Mozambique',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F3', '1F1E6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF3\uD83C\uDDE6',
    Version: 'E2.0',
    name: 'flag: Namibia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F3', '1F1E8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF3\uD83C\uDDE8',
    Version: 'E2.0',
    name: 'flag: New Caledonia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F3', '1F1EA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF3\uD83C\uDDEA',
    Version: 'E2.0',
    name: 'flag: Niger',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F3', '1F1EB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF3\uD83C\uDDEB',
    Version: 'E2.0',
    name: 'flag: Norfolk Island',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F3', '1F1EC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF3\uD83C\uDDEC',
    Version: 'E2.0',
    name: 'flag: Nigeria',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F3', '1F1EE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF3\uD83C\uDDEE',
    Version: 'E2.0',
    name: 'flag: Nicaragua',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F3', '1F1F1'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF3\uD83C\uDDF1',
    Version: 'E2.0',
    name: 'flag: Netherlands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F3', '1F1F4'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF3\uD83C\uDDF4',
    Version: 'E2.0',
    name: 'flag: Norway',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F3', '1F1F5'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF3\uD83C\uDDF5',
    Version: 'E2.0',
    name: 'flag: Nepal',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F3', '1F1F7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF3\uD83C\uDDF7',
    Version: 'E2.0',
    name: 'flag: Nauru',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F3', '1F1FA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF3\uD83C\uDDFA',
    Version: 'E2.0',
    name: 'flag: Niue',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F3', '1F1FF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF3\uD83C\uDDFF',
    Version: 'E2.0',
    name: 'flag: New Zealand',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F4', '1F1F2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF4\uD83C\uDDF2',
    Version: 'E2.0',
    name: 'flag: Oman',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F5', '1F1E6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF5\uD83C\uDDE6',
    Version: 'E2.0',
    name: 'flag: Panama',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F5', '1F1EA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF5\uD83C\uDDEA',
    Version: 'E2.0',
    name: 'flag: Peru',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F5', '1F1EB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF5\uD83C\uDDEB',
    Version: 'E2.0',
    name: 'flag: French Polynesia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F5', '1F1EC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF5\uD83C\uDDEC',
    Version: 'E2.0',
    name: 'flag: Papua New Guinea',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F5', '1F1ED'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF5\uD83C\uDDED',
    Version: 'E2.0',
    name: 'flag: Philippines',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F5', '1F1F0'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF5\uD83C\uDDF0',
    Version: 'E2.0',
    name: 'flag: Pakistan',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F5', '1F1F1'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF5\uD83C\uDDF1',
    Version: 'E2.0',
    name: 'flag: Poland',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F5', '1F1F2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF5\uD83C\uDDF2',
    Version: 'E2.0',
    name: 'flag: St. Pierre \u0026 Miquelon',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F5', '1F1F3'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF5\uD83C\uDDF3',
    Version: 'E2.0',
    name: 'flag: Pitcairn Islands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F5', '1F1F7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF5\uD83C\uDDF7',
    Version: 'E2.0',
    name: 'flag: Puerto Rico',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F5', '1F1F8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF5\uD83C\uDDF8',
    Version: 'E2.0',
    name: 'flag: Palestinian Territories',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F5', '1F1F9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF5\uD83C\uDDF9',
    Version: 'E2.0',
    name: 'flag: Portugal',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F5', '1F1FC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF5\uD83C\uDDFC',
    Version: 'E2.0',
    name: 'flag: Palau',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F5', '1F1FE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF5\uD83C\uDDFE',
    Version: 'E2.0',
    name: 'flag: Paraguay',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F6', '1F1E6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF6\uD83C\uDDE6',
    Version: 'E2.0',
    name: 'flag: Qatar',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F7', '1F1EA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF7\uD83C\uDDEA',
    Version: 'E2.0',
    name: 'flag: R\u00E9union',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F7', '1F1F4'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF7\uD83C\uDDF4',
    Version: 'E2.0',
    name: 'flag: Romania',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F7', '1F1F8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF7\uD83C\uDDF8',
    Version: 'E2.0',
    name: 'flag: Serbia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F7', '1F1FA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF7\uD83C\uDDFA',
    Version: 'E0.6',
    name: 'flag: Russia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F7', '1F1FC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF7\uD83C\uDDFC',
    Version: 'E2.0',
    name: 'flag: Rwanda',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1E6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDE6',
    Version: 'E2.0',
    name: 'flag: Saudi Arabia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1E7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDE7',
    Version: 'E2.0',
    name: 'flag: Solomon Islands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1E8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDE8',
    Version: 'E2.0',
    name: 'flag: Seychelles',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1E9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDE9',
    Version: 'E2.0',
    name: 'flag: Sudan',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1EA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDEA',
    Version: 'E2.0',
    name: 'flag: Sweden',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1EC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDEC',
    Version: 'E2.0',
    name: 'flag: Singapore',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1ED'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDED',
    Version: 'E2.0',
    name: 'flag: St. Helena',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1EE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDEE',
    Version: 'E2.0',
    name: 'flag: Slovenia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1EF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDEF',
    Version: 'E2.0',
    name: 'flag: Svalbard \u0026 Jan Mayen',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1F0'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDF0',
    Version: 'E2.0',
    name: 'flag: Slovakia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1F1'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDF1',
    Version: 'E2.0',
    name: 'flag: Sierra Leone',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1F2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDF2',
    Version: 'E2.0',
    name: 'flag: San Marino',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1F3'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDF3',
    Version: 'E2.0',
    name: 'flag: Senegal',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1F4'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDF4',
    Version: 'E2.0',
    name: 'flag: Somalia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1F7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDF7',
    Version: 'E2.0',
    name: 'flag: Suriname',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1F8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDF8',
    Version: 'E2.0',
    name: 'flag: South Sudan',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1F9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDF9',
    Version: 'E2.0',
    name: 'flag: S\u00E3o Tom\u00E9 \u0026 Pr\u00EDncipe',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1FB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDFB',
    Version: 'E2.0',
    name: 'flag: El Salvador',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1FD'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDFD',
    Version: 'E2.0',
    name: 'flag: Sint Maarten',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1FE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDFE',
    Version: 'E2.0',
    name: 'flag: Syria',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F8', '1F1FF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF8\uD83C\uDDFF',
    Version: 'E2.0',
    name: 'flag: Eswatini',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F9', '1F1E6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF9\uD83C\uDDE6',
    Version: 'E2.0',
    name: 'flag: Tristan da Cunha',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F9', '1F1E8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF9\uD83C\uDDE8',
    Version: 'E2.0',
    name: 'flag: Turks \u0026 Caicos Islands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F9', '1F1E9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF9\uD83C\uDDE9',
    Version: 'E2.0',
    name: 'flag: Chad',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F9', '1F1EB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF9\uD83C\uDDEB',
    Version: 'E2.0',
    name: 'flag: French Southern Territories',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F9', '1F1EC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF9\uD83C\uDDEC',
    Version: 'E2.0',
    name: 'flag: Togo',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F9', '1F1ED'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF9\uD83C\uDDED',
    Version: 'E2.0',
    name: 'flag: Thailand',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F9', '1F1EF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF9\uD83C\uDDEF',
    Version: 'E2.0',
    name: 'flag: Tajikistan',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F9', '1F1F0'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF9\uD83C\uDDF0',
    Version: 'E2.0',
    name: 'flag: Tokelau',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F9', '1F1F1'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF9\uD83C\uDDF1',
    Version: 'E2.0',
    name: 'flag: Timor-Leste',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F9', '1F1F2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF9\uD83C\uDDF2',
    Version: 'E2.0',
    name: 'flag: Turkmenistan',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F9', '1F1F3'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF9\uD83C\uDDF3',
    Version: 'E2.0',
    name: 'flag: Tunisia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F9', '1F1F4'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF9\uD83C\uDDF4',
    Version: 'E2.0',
    name: 'flag: Tonga',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F9', '1F1F7'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF9\uD83C\uDDF7',
    Version: 'E2.0',
    name: 'flag: T\u00FCrkiye',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F9', '1F1F9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF9\uD83C\uDDF9',
    Version: 'E2.0',
    name: 'flag: Trinidad \u0026 Tobago',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F9', '1F1FB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF9\uD83C\uDDFB',
    Version: 'E2.0',
    name: 'flag: Tuvalu',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F9', '1F1FC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF9\uD83C\uDDFC',
    Version: 'E2.0',
    name: 'flag: Taiwan',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1F9', '1F1FF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDF9\uD83C\uDDFF',
    Version: 'E2.0',
    name: 'flag: Tanzania',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FA', '1F1E6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFA\uD83C\uDDE6',
    Version: 'E2.0',
    name: 'flag: Ukraine',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FA', '1F1EC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFA\uD83C\uDDEC',
    Version: 'E2.0',
    name: 'flag: Uganda',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FA', '1F1F2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFA\uD83C\uDDF2',
    Version: 'E2.0',
    name: 'flag: U.S. Outlying Islands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FA', '1F1F3'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFA\uD83C\uDDF3',
    Version: 'E4.0',
    name: 'flag: United Nations',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FA', '1F1F8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFA\uD83C\uDDF8',
    Version: 'E0.6',
    name: 'flag: United States',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FA', '1F1FE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFA\uD83C\uDDFE',
    Version: 'E2.0',
    name: 'flag: Uruguay',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FA', '1F1FF'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFA\uD83C\uDDFF',
    Version: 'E2.0',
    name: 'flag: Uzbekistan',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FB', '1F1E6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFB\uD83C\uDDE6',
    Version: 'E2.0',
    name: 'flag: Vatican City',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FB', '1F1E8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFB\uD83C\uDDE8',
    Version: 'E2.0',
    name: 'flag: St. Vincent \u0026 Grenadines',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FB', '1F1EA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFB\uD83C\uDDEA',
    Version: 'E2.0',
    name: 'flag: Venezuela',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FB', '1F1EC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFB\uD83C\uDDEC',
    Version: 'E2.0',
    name: 'flag: British Virgin Islands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FB', '1F1EE'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFB\uD83C\uDDEE',
    Version: 'E2.0',
    name: 'flag: U.S. Virgin Islands',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FB', '1F1F3'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFB\uD83C\uDDF3',
    Version: 'E2.0',
    name: 'flag: Vietnam',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FB', '1F1FA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFB\uD83C\uDDFA',
    Version: 'E2.0',
    name: 'flag: Vanuatu',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FC', '1F1EB'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFC\uD83C\uDDEB',
    Version: 'E2.0',
    name: 'flag: Wallis \u0026 Futuna',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FC', '1F1F8'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFC\uD83C\uDDF8',
    Version: 'E2.0',
    name: 'flag: Samoa',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FD', '1F1F0'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFD\uD83C\uDDF0',
    Version: 'E2.0',
    name: 'flag: Kosovo',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FE', '1F1EA'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFE\uD83C\uDDEA',
    Version: 'E2.0',
    name: 'flag: Yemen',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FE', '1F1F9'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFE\uD83C\uDDF9',
    Version: 'E2.0',
    name: 'flag: Mayotte',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FF', '1F1E6'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFF\uD83C\uDDE6',
    Version: 'E2.0',
    name: 'flag: South Africa',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FF', '1F1F2'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFF\uD83C\uDDF2',
    Version: 'E2.0',
    name: 'flag: Zambia',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F1FF', '1F1FC'],
    Status: 'fully-qualified',
    char: '\uD83C\uDDFF\uD83C\uDDFC',
    Version: 'E2.0',
    name: 'flag: Zimbabwe',
    category: 'Flags',
    SubGroup: 'country-flag'
  },
  {
    CodePointsHex: ['1F3F4', 'E0067', 'E0062', 'E0065', 'E006E', 'E0067', 'E007F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F',
    Version: 'E5.0',
    name: 'flag: England',
    category: 'Flags',
    SubGroup: 'subdivision-flag'
  },
  {
    CodePointsHex: ['1F3F4', 'E0067', 'E0062', 'E0073', 'E0063', 'E0074', 'E007F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F',
    Version: 'E5.0',
    name: 'flag: Scotland',
    category: 'Flags',
    SubGroup: 'subdivision-flag'
  },
  {
    CodePointsHex: ['1F3F4', 'E0067', 'E0062', 'E0077', 'E006C', 'E0073', 'E007F'],
    Status: 'fully-qualified',
    char: '\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F',
    Version: 'E5.0',
    name: 'flag: Wales',
    category: 'Flags',
    SubGroup: 'subdivision-flag'
  }
]

export { emojis }
